// Comprehensive Compatibility Matrix - Single Source of Truth
// This matrix contains all known connector compatibility information
// Each connector has detailed compatibility rules with warnings, notes, and use cases

const compatibilityMatrix = {
  // --- POWERCON ---
  'NAC3FXXA-W-S': { // PowerCON Blue Cable (Power-In, 20A)--  // VERIFY
    id: 'NAC3FXXA-W-S',
    skuCode: 'PCB',
    type: 'PowerCON',
    family: 'PowerCON Blue',
    poles: 2,
    gender: 'female',
    mountType: 'cable',
    purpose: 'power, hybrid',
    description: 'Neutrik PowerCON Blue Cable (Power-In, 20A)',
    image: '/images/NAC3FXXA-W-S.png',
    wireCompatibility: ['PSP12', 'PSP14', 'PSP16'],
    wireGaugeCompatibility: ['12AWG', '14AWG', '16AWG'],
    compatibleWith: [
      {
        id: 'NAC3MPX-TOP',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 20A PowerCON.',
        notes: 'PowerCON Blue cable custom wired to TRUE1 male panel.'
      },
      {
        id: 'NEMA_5-15P_panel_mount_male',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 20A PowerCON.',
        notes: 'PowerCON Blue cable custom wired to NEMA 5-15P panel.'
      },
      {
        id: 'NEMA_5-15P_cable_mount_male',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 20A PowerCON.',
        notes: 'PowerCON Blue cable custom wired to NEMA 5-15P cable.'
      },
      {
        id: 'IEC_C14_panel_mount_male',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 20A PowerCON.',
        notes: 'PowerCON Blue cable custom wired to IEC C14 panel.'
      },
      {
        id: 'IEC_C14_cable_mount_male',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 20A PowerCON.',
        notes: 'PowerCON Blue cable custom wired to IEC C14 cable.'
      },
      {
        id: 'NAC3M-TRUE1-S',
        type: 'custom',
        polesUsed: 2,
        warning: 'Ensure correct power flow (Blue cable as power-in, TRUE1 male as bidirectional).',
        notes: 'PowerCON Blue cable custom wired to TRUE1 male cable.'
      },
      {
        id: 'NAC3MPXXA',
        type: 'standard',
        polesUsed: 2,
        warning: null,
        notes: 'PowerCON Blue cable connects to PowerCON Blue panel (power-in to power-in).'
      },
      {
        id: 'NAC3FXXB-W-S',
        type: 'standard',
        polesUsed: 2,
        warning: null,
        notes: 'PowerCON Blue cable connects to PowerCON Grey cable (power-in to power-out).'
      }
    ],
    notCompatibleWith: [
      {
        id: 'NAC3FXXA-W-S',
        reason: 'Cannot connect cable to cable (same gender and purpose)',
        details: 'PowerCON Blue cable cannot connect to another PowerCON Blue cable directly.'
      },
      {
        id: 'NAC3FPX-TOP',
        reason: 'Incompatible connector type',
        details: 'PowerCON Blue cable cannot be custom wired to TRUE1 female panel.'
      },
      {
        id: 'IEC_C13_panel_mount_female',
        reason: 'IEC C13 is a load, not a source',
        details: 'IEC C13 panel cannot receive power from PowerCON Blue cable. (Use PowerCON Grey cable, or C14 instead)'
      },
      {
        id: 'IEC_C13_cable_mount_female',
        reason: 'IEC C13 is a load, not a source',
        details: 'IEC C13 cable cannot receive power from PowerCON Blue cable. (Use PowerCON Grey cable, or C14 instead)'
      },
      {
        id: 'NEMA_5-15R_panel_mount_female',
        reason: 'NEMA 5-15R is a load, not a source',
        details: 'NEMA 5-15R panel cannot receive power from PowerCON Blue cable. (Use PowerCON Grey cable, or 5-15P instead)'
      },
      {
        id: 'NEMA_5-15R_cable_mount_female',
        reason: 'NEMA 5-15R is a load, not a source',
        details: 'NEMA 5-15R cable cannot receive power from PowerCON Blue cable. (Use PowerCON Grey cable, or 5-15P instead)'
      }
    ],
    notes: 'For power-in only. Compatible with TRUE1 male panels, NEMA 5-15P, and IEC C14 connectors. Panel-to-panel connections are non-standard and require careful circuit design and labeling. Ensure proper derating for custom IEC/NEMA connections. CBC (NAC3FXXA) requires disconnection before plugging/unplugging.'
  },

  'NAC3FXXB-W-S': { // PowerCON Grey Cable (Power-Out, 20A)--  // VERIFY
    id: 'NAC3FXXB-W-S',
    skuCode: 'PCG',
    type: 'PowerCON',
    family: 'PowerCON Grey',
    poles: 2,
    gender: 'female',
    mountType: 'cable',
    purpose: 'power, hybrid',
    description: 'Neutrik PowerCON Grey Cable (Power-Out, 20A)',
    image: '/images/NAC3FXXB-W-S.png',
    wireCompatibility: ['PSP12', 'PSP14', 'PSP16'],
    wireGaugeCompatibility: ['12AWG', '14AWG', '16AWG'],
    compatibleWith: [
      {
        id: 'NAC3FPX-TOP',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 20A PowerCON.',
        notes: 'PowerCON Grey cable custom wired to TRUE1 female panel.'
      },
      {
        id: 'NEMA_5-15R_panel_mount_female',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 20A PowerCON.',
        notes: 'PowerCON Grey cable custom wired to NEMA 5-15R panel.'
      },
      {
        id: 'NEMA_5-15R_cable_mount_female',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 20A PowerCON.',
        notes: 'PowerCON Grey cable custom wired to NEMA 5-15R cable.'
      },
      {
        id: 'IEC_C13_panel_mount_female',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 20A PowerCON.',
        notes: 'PowerCON Grey cable custom wired to IEC C13 panel.'
      },
      {
        id: 'IEC_C13_cable_mount_female',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 20A PowerCON.',
        notes: 'PowerCON Grey cable custom wired to IEC C13 cable.'
      },
      {
        id: 'NAC3F-TRUE1-S',
        type: 'custom',
        polesUsed: 2,
        warning: 'Ensure correct power flow (Grey cable as power-out, TRUE1 female as bidirectional).',
        notes: 'PowerCON Grey cable custom wired to TRUE1 female cable.'
      },
      {
        id: 'NAC3MPXXB',
        type: 'standard',
        polesUsed: 2,
        warning: null,
        notes: 'PowerCON Grey cable connects to PowerCON Grey panel (power-out to power-out).'
      },
      {
        id: 'NAC3FXXA-W-S',
        type: 'standard',
        polesUsed: 2,
        warning: null,
        notes: 'PowerCON Grey cable connects to PowerCON Blue cable (power-out to power-in).'
      },
      {
        id: 'NAC3MPX-TOP',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 20A PowerCON.',
        notes: 'PowerCON Grey cable custom wired to TRUE1 male panel.'
      }
    ],
    notCompatibleWith: [
      {
        id: 'NAC3FXXB-W-S',
        reason: 'Cannot connect cable to cable (same gender and purpose)',
        details: 'PowerCON Grey cable cannot connect to another PowerCON Grey cable directly.'
      },
      // { removed to fix conflict yes/no compatible issue
      //   id: 'NAC3MPX-TOP',
      //   reason: 'Incompatible connector type',
      //   details: 'PowerCON Grey cable cannot be custom wired to TRUE1 male panel.'
      // },
      {
        id: 'NAC3MPXXA',
        reason: 'Incompatible purpose',
        details: 'PowerCON Grey cable (power-out) cannot be custom wired to PowerCON Blue panel (power-in).'
      },
      {
        id: 'IEC_C14_panel_mount_male',
        reason: 'IEC C14 is a source, not a load',
        details: 'IEC C14 panel cannot receive power from PowerCON Grey cable. (Use PowerCON Blue cable, or C13 instead)'
      },
      {
        id: 'IEC_C14_cable_mount_male',
        reason: 'IEC C14 is a source, not a load',
        details: 'IEC C14 cable cannot receive power from PowerCON Grey cable. (Use PowerCON Blue cable, or C13 instead)'
      },
      {
        id: 'NEMA_5-15P_panel_mount_male',
        reason: 'NEMA 5-15P is a source, not a load',
        details: 'NEMA 5-15P panel cannot receive power from PowerCON Grey cable. (Use PowerCON Blue cable, or 5-15R instead)'
      },
      {
        id: 'NEMA_5-15P_cable_mount_male',
        reason: 'NEMA 5-15P is a source, not a load',
        details: 'NEMA 5-15P cable cannot receive power from PowerCON Grey cable. (Use PowerCON Blue cable, or 5-15R instead)'
      }
    ],
    notes: 'For power-out only. Compatible with TRUE1 female panels, NEMA 5-15R, and IEC C13 connectors. Panel-to-panel connections are non-standard and require careful circuit design and labeling. Ensure proper derating for custom IEC/NEMA connections. CBC (NAC3FXXB) requires disconnection before plugging/unplugging.'
  },

  'NAC3MPXXA': { // PowerCON Blue Panel (Power-In, 20A)--  // VERIFY
    id: 'NAC3MPXXA',
    skuCode: 'PCBPM',
    type: 'PowerCON',
    family: 'PowerCON Blue',
    poles: 2,
    gender: 'male',
    mountType: 'panel',
    purpose: 'power',
    description: 'Neutrik PowerCON Blue Panel (Power-In, 20A)',
    image: '/images/NAC3MPXXA.jpg',
    wireCompatibility: ['PSP12', 'PSP14', 'PSP16'],
    wireGaugeCompatibility: ['12AWG', '14AWG', '16AWG'],
    compatibleWith: [
      {
        id: 'NEMA_5-15R_panel_mount_female',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 20A PowerCON.',
        notes: 'PowerCON Blue panel custom wired to NEMA 5-15R panel.'
      },
      {
        id: 'NEMA_5-15R_cable_mount_female',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 20A PowerCON.',
        notes: 'PowerCON Blue panel custom wired to NEMA 5-15R cable.'
      },
      {
        id: 'IEC_C13_panel_mount_female',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 20A PowerCON.',
        notes: 'PowerCON Blue panel custom wired to IEC C13 panel.'
      },
      {
        id: 'IEC_C13_cable_mount_female',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 20A PowerCON.',
        notes: 'PowerCON Blue panel custom wired to IEC C13 cable.'
      },
      {
        id: 'NAC3F-TRUE1-S',
        type: 'custom',
        polesUsed: 2,
        warning: 'Ensure correct power flow (Blue panel as power-in, TRUE1 female as bidirectional).',
        notes: 'PowerCON Blue panel custom wired to TRUE1 female cable.'
      },
      {
        id: 'NAC3FXXA-W-S',
        type: 'standard',
        polesUsed: 2,
        warning: null,
        notes: 'PowerCON Blue panel connects to PowerCON Blue cable (power-in to power-in).'
      },
      {
        id: 'NAC3MPXXB',
        type: 'standard',
        polesUsed: 2,
        warning: null,
        notes: 'PowerCON Blue panel connects to PowerCON Grey panel (power-in to power-out).'
      }
    ],
    notCompatibleWith: [
      {
        id: 'NAC3FPX-TOP',
        reason: 'Incompatible connector type',
        details: 'PowerCON Blue panel cannot be custom wired to TRUE1 female panel.'
      },
      {
        id: 'NAC3MPXXA',
        reason: 'Cannot connect panel to panel (same gender and purpose)',
        details: 'PowerCON Blue panel cannot connect to another PowerCON Blue panel as both are power-in.'
      },
      {
        id: 'NAC3MPX-TOP',
        reason: 'Incompatible connector type',
        details: 'PowerCON Blue panel cannot be custom wired to TRUE1 male panel.'
      },
      {
        id: 'IEC_C14_panel_mount_male',
        reason: 'IEC C14 is a source, not a load',
        details: 'IEC C14 panel cannot receive power from PowerCON Blue panel. (Use PowerCON Blue Cable Mount, or C13 instead)'
      },
      {
        id: 'NEMA_5-15P_panel_mount_male',
        reason: 'NEMA 5-15P is a source, not a load',
        details: 'NEMA 5-15P panel cannot receive power from PowerCON Blue panel. (Use PowerCON Blue Cable Mount, or 5-15R instead)'
      },
      {
        id: 'NEMA_5-15P_cable_mount_male',
        reason: 'NEMA 5-15P is a source, not a load',
        details: 'NEMA 5-15P cable cannot receive power from PowerCON Blue panel. (Use PowerCON Blue Cable Mount, or 5-15R instead)'
      },
      {
        id: 'IEC_C14_cable_mount_male',
        reason: 'IEC C14 is a source, not a load',
        details: 'IEC C14 cable cannot receive power from PowerCON Blue panel. (Use PowerCON Blue Cable Mount, or C13 instead)'
      }
    ],
    notes: 'For power-in only. Not compatible with TRUE1 cables or other PowerCON connectors except TRUE1 panels. Panel-to-panel connections are non-standard and require careful circuit design and labeling. Ensure proper derating for custom IEC/NEMA connections. CBC (NAC3MPXXA) requires disconnection before plugging/unplugging.'
  },

  'NAC3MPXXB': { // PowerCON Grey Panel (Power-Out, 20A)--  // VERIFY
    id: 'NAC3MPXXB',
    skuCode: 'PCGPM',
    type: 'PowerCON',
    family: 'PowerCON Grey',
    poles: 2,
    gender: 'male',
    mountType: 'panel',
    purpose: 'power',
    description: 'Neutrik PowerCON Grey Panel (Power-Out, 20A)',
    image: '/images/NAC3MPXXB.jpg',
    wireCompatibility: ['PSP12', 'PSP14', 'PSP16'],
    wireGaugeCompatibility: ['12AWG', '14AWG', '16AWG'],
    compatibleWith: [
      {
        id: 'NAC3MPX-TOP',
        type: 'custom',
        polesUsed: 2,
        warning: null,
        notes: 'PowerCON Grey panel custom wired to TRUE1 male panel.'
      },
      {
        id: 'NEMA_5-15P_panel_mount_male',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 20A PowerCON.',
        notes: 'PowerCON Grey panel custom wired to NEMA 5-15P panel.'
      },
      {
        id: 'NEMA_5-15P_cable_mount_male',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 20A PowerCON.',
        notes: 'PowerCON Grey panel custom wired to NEMA 5-15P cable.'
      },
      {
        id: 'IEC_C14_panel_mount_male',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 20A PowerCON.',
        notes: 'PowerCON Grey panel custom wired to IEC C14 panel.'
      },
      {
        id: 'IEC_C14_cable_mount_male',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 20A PowerCON.',
        notes: 'PowerCON Grey panel custom wired to IEC C14 cable.'
      },
      {
        id: 'NAC3M-TRUE1-S',
        type: 'custom',
        polesUsed: 2,
        warning: 'Ensure correct power flow (Grey panel as power-out, TRUE1 male as bidirectional).',
        notes: 'PowerCON Grey panel custom wired to TRUE1 male cable.'
      },
      {
        id: 'NAC3MPXXA',
        type: 'standard',
        polesUsed: 2,
        warning: null,
        notes: 'PowerCON Grey panel connects to PowerCON Blue panel (power-out to power-in).'
      },
      {
        id: 'NAC3FXXB-W-S',
        type: 'standard',
        polesUsed: 2,
        warning: null,
        notes: 'PowerCON Grey panel connects to PowerCON Grey cable (power-out to power-out).'
      }
    ],
    notCompatibleWith: [
      {
        id: 'NAC3MPXXB',
        reason: 'Cannot connect panel to panel (same gender and purpose)',
        details: 'PowerCON Grey panel cannot connect to another PowerCON Grey panel as both are power-out.'
      },
      {
        id: 'NAC3FPX-TOP',
        reason: 'Incompatible connector type',
        details: 'PowerCON Grey panel cannot be custom wired to TRUE1 female panel.'
      },
      {
        id: 'IEC_C13_panel_mount_female',
        reason: 'IEC C13 is a load, not a source',
        details: 'IEC C13 panel cannot receive power from PowerCON Grey panel. (Use PowerCON Blue cable, or C14 instead)'
      },
      {
        id: 'IEC_C13_cable_mount_female',
        reason: 'IEC C13 is a load, not a source',
        details: 'IEC C13 cable cannot receive power from PowerCON Grey panel. (Use PowerCON Blue cable, or C14 instead)'
      },
      {
        id: 'NEMA_5-15R_panel_mount_female',
        reason: 'NEMA 5-15R is a load, not a source',
        details: 'NEMA 5-15R panel cannot receive power from PowerCON Grey panel. (Use PowerCON Blue cable, or 5-15P instead)'
      },
      {
        id: 'NEMA_5-15R_cable_mount_female',
        reason: 'NEMA 5-15R is a load, not a source',
        details: 'NEMA 5-15R cable cannot receive power from PowerCON Grey panel. (Use PowerCON Blue cable, or 5-15P instead)'
      }
    ],
    notes: 'For power-out only. Not compatible with TRUE1 cables or other PowerCON connectors except TRUE1 male panels. Panel-to-panel connections are non-standard and require careful circuit design and labeling. Ensure proper derating for custom IEC/NEMA connections. CBC (NAC3MPXXB) requires disconnection before plugging/unplugging.'
  },

  // --- TRUE1 ---
  'NAC3M-TRUE1-S': { // TRUE1 Male Cable (Bidirectional, 16A) TRUE1_cable_mount_male--// VERIFY
    id: 'NAC3M-TRUE1-S',
    skuCode: 'T1M',
    type: 'TRUE1',
    family: 'TRUE1',
    poles: 2,
    gender: 'male',
    mountType: 'cable',
    purpose: 'power, hybrid',
    description: 'Neutrik PowerCON TRUE1 TOP Cable Mount Male (16A, IP65)',
    image: '/images/NAC3M-TRUE1-S.png',
    wireCompatibility: ['PSP12', 'PSP14', 'PSP16'],
    wireGaugeCompatibility: ['12AWG', '14AWG', '16AWG'],
    compatibleWith: [
      {
        id: 'NAC3F-TRUE1-S',
        type: 'direct',
        polesUsed: 2,
        warning: null,
        notes: 'TRUE1 male cable directly wired to TRUE1 female cable.'
      },
      {
        id: 'NAC3FPX-TOP',
        type: 'direct',
        polesUsed: 2,
        warning: null,
        notes: 'TRUE1 male cable directly wired to TRUE1 female panel.'
      },
      {
        id: 'NAC3MPXXB',
        type: 'custom',
        polesUsed: 2,
        warning: 'Ensure correct power flow (TRUE1 male as bidirectional, Grey panel as power-out).',
        notes: 'TRUE1 male cable custom wired to PowerCON Grey panel.'
      },
      {
        id: 'NAC3FXXA-W-S',
        type: 'custom',
        polesUsed: 2,
        warning: 'Ensure correct power flow (TRUE1 male as bidirectional, Blue cable as power-in).',
        notes: 'TRUE1 male cable custom wired to PowerCON Blue cable.'
      },
      {
        id: 'NEMA_5-15R_panel_mount_female',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 16A TRUE1.',
        notes: 'TRUE1 male cable custom wired to NEMA 5-15R panel.'
      },
      {
        id: 'NEMA_5-15R_cable_mount_female',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 16A TRUE1.',
        notes: 'TRUE1 male cable custom wired to NEMA 5-15R cable.'
      },
      {
        id: 'IEC_C13_panel_mount_female',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 16A TRUE1.',
        notes: 'TRUE1 male cable custom wired to IEC C13 panel.'
      },
      {
        id: 'IEC_C13_cable_mount_female',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 16A TRUE1.',
        notes: 'TRUE1 male cable custom wired to IEC C13 cable.'
      },
      {
        id: 'NAC3F-TRUE1-S',
        type: 'direct',
        polesUsed: 2,
        warning: null,
        notes: 'TRUE1 male cable can be directly connected to TRUE1 female cable.'
      }
    ],
    notCompatibleWith: [
      {
        id: 'NAC3M-TRUE1-S',
        reason: 'Cannot connect cable to cable (same gender and purpose)',
        details: 'TRUE1 male cable cannot connect to another TRUE1 male cable.'
      },
      {
        id: 'NAC3MPX-TOP',
        reason: 'Incompatible connector type',
        details: 'TRUE1 male cable cannot be custom wired to TRUE1 male panel.'
      },
      {
        id: 'NAC3FXXB-W-S',
        reason: 'Incompatible purpose',
        details: 'TRUE1 male cable (bidirectional) cannot be custom wired to PowerCON Grey cable (power-out).'
      },
      {
        id: 'NAC3MPXXA',
        reason: 'Incompatible purpose',
        details: 'TRUE1 male cable (bidirectional) cannot be custom wired to PowerCON Blue panel (power-in).'
      },
      {
        id: 'IEC_C14_panel_mount_male',
        reason: 'Cannot connect male to male',
        details: 'TRUE1 male cable cannot connect to IEC C14 panel due to same gender.'
      },
      {
        id: 'IEC_C14_cable_mount_male',
        reason: 'Cannot connect male to male',
        details: 'TRUE1 male cable cannot connect to IEC C14 cable due to same gender.'
      },
      {
        id: 'NEMA_5-15P_panel_mount_male',
        reason: 'Cannot connect male to male',
        details: 'TRUE1 male cable cannot connect to NEMA 5-15P panel due to same gender.'
      },
      {
        id: 'NEMA_5-15P_cable_mount_male',
        reason: 'Cannot connect male to male',
        details: 'TRUE1 male cable cannot connect to NEMA 5-15P cable due to same gender.'
      }
    ],
    notes: 'TRUE1 supports bidirectional power flow (in/out) and hot-plugging. Compatible with PowerCON Grey panels, PowerCON Blue cables, and certain IEC/NEMA connectors. Use TRUE1 TOP for IP65 (outdoor). Panel-to-panel connections are non-standard and require careful circuit design and labeling. Ensure proper derating for custom IEC/NEMA connections.'
  },

  'NAC3F-TRUE1-S': { // TRUE1 Female Cable (Bidirectional, 16A) TRUE1_cable_mount_female--  // VERIFY
    id: 'NAC3F-TRUE1-S',
    skuCode: 'T1F',
    type: 'TRUE1',
    family: 'TRUE1',
    poles: 2,
    gender: 'female',
    mountType: 'cable',
    purpose: 'power, hybrid',
    description: 'Neutrik PowerCON TRUE1 TOP Cable Mount Female (16A, IP65)',
    image: '/images/NAC3F-TRUE1-S.png',
    wireCompatibility: ['PSP12', 'PSP14', 'PSP16'],
    wireGaugeCompatibility: ['12AWG', '14AWG', '16AWG'],
    compatibleWith: [
      {
        id: 'NAC3M-TRUE1-S',
        type: 'direct',
        polesUsed: 2,
        warning: null,
        notes: 'TRUE1 female cable directly wired to TRUE1 male cable.'
      },
      {
        id: 'NAC3MPXXA',
        type: 'custom',
        polesUsed: 2,
        warning: 'Ensure correct power flow (TRUE1 female as bidirectional, Blue panel as power-in).',
        notes: 'TRUE1 female cable custom wired to PowerCON Blue panel.'
      },
      {
        id: 'NAC3FXXB-W-S',
        type: 'custom',
        polesUsed: 2,
        warning: 'Ensure correct power flow (TRUE1 female as bidirectional, Grey cable as power-out).',
        notes: 'TRUE1 female cable custom wired to PowerCON Grey cable.'
      },
      {
        id: 'NEMA_5-15P_panel_mount_male',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 16A TRUE1.',
        notes: 'TRUE1 female cable custom wired to NEMA 5-15P panel.'
      },
      {
        id: 'NEMA_5-15P_cable_mount_male',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 16A TRUE1.',
        notes: 'TRUE1 female cable custom wired to NEMA 5-15P cable.'
      },
      {
        id: 'IEC_C14_panel_mount_male',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 16A TRUE1.',
        notes: 'TRUE1 female cable custom wired to IEC C14 panel.'
      },
      {
        id: 'IEC_C14_cable_mount_male',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 16A TRUE1.',
        notes: 'TRUE1 female cable custom wired to IEC C14 cable.'
      },
      {
        id: 'NAC3M-TRUE1-S',
        type: 'direct',
        polesUsed: 2,
        warning: null,
        notes: 'TRUE1 female cable can be directly connected to TRUE1 male cable.'
      }
    ],
    notCompatibleWith: [
      {
        id: 'NAC3F-TRUE1-S',
        reason: 'Cannot connect cable to cable (same gender and purpose)',
        details: 'TRUE1 female cable cannot connect to another TRUE1 female cable.'
      },
      {
        id: 'NAC3FPX-TOP',
        reason: 'Cannot connect female to female',
        details: 'TRUE1 female cable cannot connect to TRUE1 female panel.'
      },
      {
        id: 'NAC3FXXA-W-S',
        reason: 'Incompatible purpose',
        details: 'TRUE1 female cable (bidirectional) cannot be custom wired to PowerCON Blue cable (power-in).'
      },
      {
        id: 'NAC3MPXXB',
        reason: 'Incompatible purpose',
        details: 'TRUE1 female cable (bidirectional) cannot be custom wired to PowerCON Grey panel (power-out).'
      },
      {
        id: 'IEC_C13_panel_mount_female',
        reason: 'Cannot connect female to female',
        details: 'TRUE1 female cable cannot connect to IEC C13 panel due to same gender.'
      },
      {
        id: 'IEC_C13_cable_mount_female',
        reason: 'Cannot connect female to female',
        details: 'TRUE1 female cable cannot connect to IEC C13 cable due to same gender.'
      },
      {
        id: 'NEMA_5-15R_panel_mount_female',
        reason: 'Cannot connect female to female',
        details: 'TRUE1 female cable cannot connect to NEMA 5-15R panel due to same gender.'
      },
      {
        id: 'NEMA_5-15R_cable_mount_female',
        reason: 'Cannot connect female to female',
        details: 'TRUE1 female cable cannot connect to NEMA 5-15R cable due to same gender.'
      }
    ],
    notes: 'TRUE1 supports bidirectional power flow (in/out) and hot-plugging. Compatible with PowerCON Blue panels, PowerCON Grey cables, and certain IEC/NEMA connectors. Use TRUE1 TOP for IP65 (outdoor). Panel-to-panel connections are non-standard and require careful circuit design and labeling. Ensure proper derating for custom IEC/NEMA connections.'
  },

  'NAC3MPX-TOP': { // TRUE1 Male Panel (Bidirectional, 16A) TRUE1_panel_mount_male-- // VERIFY
    id: 'NAC3MPX-TOP',
    skuCode: 'T1MPM',
    type: 'TRUE1',
    family: 'TRUE1',
    poles: 2,
    gender: 'male',
    mountType: 'panel',
    purpose: 'power',
    description: 'Neutrik PowerCON TRUE1 TOP Panel Mount Male (16A, IP65)',
    image: '/images/NAC3MPX-TOP.jpg',
    wireCompatibility: ['PSP12', 'PSP14', 'PSP16'],
    wireGaugeCompatibility: ['12AWG', '14AWG', '16AWG'],
    compatibleWith: [
      {
        id: 'NAC3F-TRUE1-S',
        type: 'direct',
        polesUsed: 2,
        warning: null,
        notes: 'TRUE1 male panel directly wired to TRUE1 female cable.'
      },
      {
        id: 'NAC3FPX-TOP',
        type: 'custom',
        polesUsed: 2,
        warning: null,
        notes: 'TRUE1 male panel custom wired to TRUE1 female panel.'
      },
      {
        id: 'NAC3FXXA-W-S',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 20A PowerCON.',
        notes: 'IEC C13 panel custom wired to PowerCON Blue cable.'
      },
      {
        id: 'NEMA_5-15R_panel_mount_female',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 16A TRUE1.',
        notes: 'TRUE1 male panel custom wired to NEMA 5-15R panel.'
      },
      {
        id: 'NEMA_5-15R_cable_mount_female',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 16A TRUE1.',
        notes: 'TRUE1 male panel custom wired to NEMA 5-15R cable.'
      },
      {
        id: 'IEC_C13_panel_mount_female',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 16A TRUE1.',
        notes: 'TRUE1 male panel custom wired to IEC C13 panel.'
      },
            {  
        id: 'IEC_C13_cable_mount_female',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 16A TRUE1.',
        notes: 'TRUE1 male panel custom wired to IEC C13 cable.'
      },
      {
        id: 'NAC3FXXB-W-S',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 20A PowerCON.',
        notes: 'TRUE1 male panel custom wired to PowerCON Grey cable.'
      },
      {
        id: 'NAC3MPXXB',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 20A PowerCON.',
        notes: 'TRUE1 male panel custom wired to PowerCON Grey panel.'
      },
      {
        id: 'NAC3F-TRUE1-S',
        type: 'direct',
        polesUsed: 2,
        warning: null,
        notes: 'TRUE1 male panel can be directly connected to TRUE1 female cable.'
      }
    ],
    notCompatibleWith: [
      {
        id: 'NAC3MPX-TOP',
        reason: 'Cannot connect panel to panel (same gender and purpose)',
        details: 'TRUE1 male panel cannot connect to another TRUE1 male panel.'
      },
      {
        id: 'NAC3M-TRUE1-S',
        reason: 'Incompatible connector type',
        details: 'TRUE1 male panel cannot be custom wired to TRUE1 male cable.'
      },
      // { removed to fix conflict yes/no compatible issue
      //   id: 'NAC3FXXB-W-S',
      //   reason: 'Original PowerCON and TRUE1 are incompatible',
      //   details: 'TRUE1 male panel cannot be custom wired to PowerCON Grey cable.'
      // },
      {
        id: 'NAC3MPXXA',
        reason: 'Original PowerCON and TRUE1 are incompatible',
        details: 'TRUE1 male panel cannot be custom wired to PowerCON Blue panel.'
      },
      // { removed to fix conflict yes/no compatible issue
      //   id: 'NAC3MPXXB',
      //   reason: 'Original PowerCON and TRUE1 are incompatible',
      //   details: 'TRUE1 male panel cannot be custom wired to PowerCON Grey panel.'
      // },
      {
        id: 'IEC_C14_panel_mount_male',
        reason: 'Cannot connect male to male',
        details: 'TRUE1 male panel cannot connect to IEC C14 panel due to same gender.'
      },
      {
        id: 'IEC_C14_cable_mount_male',
        reason: 'Cannot connect male to male',
        details: 'TRUE1 male panel cannot connect to IEC C14 cable due to same gender.'
      },
      {
        id: 'NEMA_5-15P_panel_mount_male',
        reason: 'Cannot connect male to male',
        details: 'TRUE1 male panel cannot connect to NEMA 5-15P panel due to same gender.'
      },
      {
        id: 'NEMA_5-15P_cable_mount_male',
        reason: 'Cannot connect male to male',
        details: 'TRUE1 male panel cannot connect to NEMA 5-15P cable due to same gender.'
      }
    ],
    notes: 'TRUE1 supports bidirectional power flow (in/out) and hot-plugging. Compatible with TRUE1 female panels and certain IEC/NEMA connectors. Use TRUE1 TOP for IP65 (outdoor). Panel-to-panel connections are non-standard and require careful circuit design and labeling. Ensure proper derating for custom IEC/NEMA connections.'
  },

  'NAC3FPX-TOP': { // TRUE1 Female Panel (Bidirectional, 16A) TRUE1_panel_mount_female-- // VERIFY
    id: 'NAC3FPX-TOP',
    skuCode: 'T1FPM',
    type: 'TRUE1',
    family: 'TRUE1',
    poles: 2,
    gender: 'female',
    mountType: 'panel',
    purpose: 'power',
    description: 'Neutrik PowerCON TRUE1 TOP Panel Mount Female (16A, IP65)',
    image: '/images/NAC3FPX-TOP.png',
    wireCompatibility: ['PSP12', 'PSP14', 'PSP16'],
    wireGaugeCompatibility: ['12AWG', '14AWG', '16AWG'],
    compatibleWith: [
      {
        id: 'NAC3M-TRUE1-S',
        type: 'direct',
        polesUsed: 2,
        warning: null,
        notes: 'TRUE1 female panel directly wired to TRUE1 male cable.'
      },
      {
        id: 'NAC3MPX-TOP',
        type: 'custom',
        polesUsed: 2,
        warning: null,
        notes: 'TRUE1 female panel custom wired to TRUE1 male panel.'
      },
      {
        id: 'NEMA_5-15P_panel_mount_male',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 16A TRUE1.',
        notes: 'TRUE1 female panel custom wired to NEMA 5-15P panel.'
      },
      {
        id: 'NEMA_5-15P_cable_mount_male',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 16A TRUE1.',
        notes: 'TRUE1 female panel custom wired to NEMA 5-15P cable.'
      },
      {
        id: 'IEC_C14_panel_mount_male',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 16A TRUE1.',
        notes: 'TRUE1 female panel custom wired to IEC C14 panel.'
      },
      {
        id: 'IEC_C14_cable_mount_male',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 16A TRUE1.',
        notes: 'TRUE1 female panel custom wired to IEC C14 cable.'
      },
      // { removed to fix conflict yes/no compatible issue
      //   id: 'NAC3MPXXA',
      //   type: 'custom',
      //   polesUsed: 2,
      //   warning: '15A max. Derate if using 20A PowerCON.',
      //   notes: 'TRUE1 female panel custom wired to PowerCON Blue panel.'
      // },
      {
        id: 'NAC3FXXB-W-S',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 20A PowerCON.',
        notes: 'TRUE1 female panel custom wired to PowerCON Grey cable.'
      },
      {
        id: 'NAC3M-TRUE1-S',
        type: 'direct',
        polesUsed: 2,
        warning: null,
        notes: 'TRUE1 female panel can be directly connected to TRUE1 male cable.'
      }
    ],
    notCompatibleWith: [
      {
        id: 'NAC3FPX-TOP',
        reason: 'Cannot connect panel to panel (same gender and purpose)',
        details: 'TRUE1 female panel cannot connect to another TRUE1 female panel.'
      },
      {
        id: 'NAC3F-TRUE1-S',
        reason: 'Incompatible connector type',
        details: 'TRUE1 female panel cannot be custom wired to TRUE1 female cable.'
      },
      {
        id: 'NAC3FXXA-W-S',
        reason: 'Original PowerCON and TRUE1 are incompatible',
        details: 'TRUE1 female panel cannot be custom wired to PowerCON Blue cable.'
      },
      // { removed to fix conflict yes/no compatible issue
      //   id: 'NAC3FXXB-W-S',
      //   reason: 'Original PowerCON and TRUE1 are incompatible',
      //   details: 'TRUE1 female panel cannot be custom wired to PowerCON Grey cable.'
      // },
      {
        id: 'NAC3MPXXA',
        reason: 'Original PowerCON and TRUE1 are incompatible',
        details: 'TRUE1 female panel cannot be custom wired to PowerCON Blue panel.'
      },
      {
        id: 'NAC3MPXXB',
        reason: 'Original PowerCON and TRUE1 are incompatible',
        details: 'TRUE1 female panel cannot be custom wired to PowerCON Grey panel.'
      },
      {
        id: 'IEC_C13_panel_mount_female',
        reason: 'Cannot connect female to female',
        details: 'TRUE1 female panel cannot connect to IEC C13 panel due to same gender.'
      },
      {
        id: 'IEC_C13_cable_mount_female',
        reason: 'Cannot connect female to female',
        details: 'TRUE1 female panel cannot connect to IEC C13 cable due to same gender.'
      },
      {
        id: 'NEMA_5-15R_panel_mount_female',
        reason: 'Cannot connect female to female',
        details: 'TRUE1 female panel cannot connect to NEMA 5-15R panel due to same gender.'
      },
      {
        id: 'NEMA_5-15R_cable_mount_female',
        reason: 'Cannot connect female to female',
        details: 'TRUE1 female panel cannot connect to NEMA 5-15R cable due to same gender.'
      }
    ],
    notes: 'TRUE1 supports bidirectional power flow (in/out) and hot-plugging. Compatible with TRUE1 male panels and certain IEC/NEMA connectors. Use TRUE1 TOP for IP65 (outdoor). Panel-to-panel connections are non-standard and require careful circuit design and labeling. Ensure proper derating for custom IEC/NEMA connections.'
  },
  
  // --- IEC ---
  'IEC_C13_cable_mount_female': { // IEC C13 Cable Mount Female (10–15A, 250V)-- // VERIFY
    id: 'IEC_C13_cable_mount_female',
    skuCode: 'IEC13',
    type: 'IEC',
    family: 'IEC C13 (Female)',
    poles: 3,
    gender: 'female',
    mountType: 'cable',
    purpose: 'power, hybrid',
    description: 'IEC C13 Cable Mount Female (10–15A, 250V)',
    image: '/images/IEC_C13_cable_mount_female.png',
    wireCompatibility: ['PSP14', 'PSP16'],
    wireGaugeCompatibility: ['14AWG', '16AWG'],
    compatibleWith: [
      {
        id: 'NAC3MPXXA',
        type: 'custom',
        polesUsed: 3,
        warning: '10–15A max. Derate if using 20A PowerCON.',
        notes: 'IEC C13 cable custom wired to PowerCON Blue panel.'
      },
      {
        id: 'NAC3FXXB-W-S',
        type: 'custom',
        polesUsed: 3,
        warning: '10–15A max. Derate if using 20A PowerCON.',
        notes: 'IEC C13 cable custom wired to PowerCON Grey cable.'
      },
      {
        id: 'NEMA_5-15P_panel_mount_male',
        type: 'custom',
        polesUsed: 3,
        warning: '15A max.',
        notes: 'IEC C13 cable custom wired to NEMA 5-15P panel.'
      },
      {
        id: 'NEMA_5-15P_cable_mount_male',
        type: 'custom',
        polesUsed: 3,
        warning: '15A max.',
        notes: 'IEC C13 cable custom wired to NEMA 5-15P cable.'
      },
      {
        id: 'IEC_C14_panel_mount_male',
        type: 'custom',
        polesUsed: 3,
        warning: '10–15A max.',
        notes: 'IEC C13 cable custom wired to IEC C14 panel.'
      },
      {
        id: 'IEC_C14_cable_mount_male',
        type: 'direct',
        polesUsed: 3,
        warning: null,
        notes: 'IEC C13 to IEC C14 cable (standard power cable, 10–15A)'
      },
      {
        id: 'NAC3M-TRUE1-S',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 16A TRUE1.',
        notes: 'IEC C13 cable custom wired to TRUE1 male cable.'
      },
      {
        id: 'NAC3MPX-TOP',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 16A TRUE1.',
        notes: 'IEC C13 cable custom wired to TRUE1 male panel.'
      }
    ],
    notCompatibleWith: [
      {
        id: 'NAC3FXXA-W-S', // Not Compatible?  // VERIFY
        reason: 'Original PowerCON and IEC C13 are incompatible',
        details: 'IEC C13 cable cannot be custom wired to PowerCON Blue cable.'
        // type: 'custom',
        // polesUsed: 3,
        // warning: '10–15A max. Derate if using 20A PowerCON.',
        // notes: 'IEC C13 cable custom wired to PowerCON Blue cable.'
      },
      // { removed to fix conflict yes/no compatible issue
      //   id: 'NAC3MPX-TOP', // Not Compatible?  // VERIFY
      //   reason: 'Original PowerCON and IEC C13 are incompatible',
      //   details: 'IEC C13 cable cannot be custom wired to TRUE1 male panel.'
      //   // type: 'custom',
      //   // polesUsed: 3,
      //   // warning: '10–15A max. Derate if using 16A TRUE1.',
      //   // notes: 'IEC C13 cable custom wired to TRUE1 male panel.'
      // },
      // { removed to fix conflict yes/no compatible issue
      //   id: 'NAC3M-TRUE1-S', // Not Compatible?  // VERIFY
      //   reason: 'Original PowerCON and IEC C13 are incompatible',
      //   details: 'IEC C13 cable cannot be custom wired to TRUE1 male cable.'
      //   // type: 'custom',
      //   // polesUsed: 3,
      //   // warning: '10–15A max. Derate if using 16A TRUE1.',
      //   // notes: 'IEC C13 cable custom wired to TRUE1 male cable.'
      // },
      {
        id: 'IEC_C13_cable_mount_female',
        reason: 'Cannot connect cable to cable (same gender and purpose)',
        details: 'IEC C13 cable cannot connect to another IEC C13 cable as both are loads.'
      },
      {
        id: 'IEC_C13_panel_mount_female',
        reason: 'IEC C13 is a load, not a source',
        details: 'IEC C13 cable cannot connect to IEC C13 panel as both are loads.'
      },
      {
        id: 'NEMA_5-15R_cable_mount_female',
        reason: 'NEMA 5-15R is a load, not a source',
        details: 'IEC C13 cable cannot connect to NEMA 5-15R cable as both are loads.'
      },
      {
        id: 'NEMA_5-15R_panel_mount_female',
        reason: 'NEMA 5-15R is a load, not a source',
        details: 'IEC C13 cable cannot connect to NEMA 5-15R panel as both are loads.'
      },
      {
        id: 'NAC3F-TRUE1-S',
        reason: 'Incompatible connector type',
        details: 'IEC C13 cable cannot be custom wired to TRUE1 female cable.'
      },
      {
        id: 'NAC3FPX-TOP',
        reason: 'Incompatible connector type',
        details: 'IEC C13 cable cannot be custom wired to TRUE1 female panel.'
      },
      {
        id: 'NAC3MPXXB',
        reason: 'Incompatible purpose',
        details: 'IEC C13 cable (load) cannot be custom wired to PowerCON Grey panel (power-out).'
      }
    ],
    notes: 'IEC C13 is for power-out (load) only. Compatible with PowerCON Blue connectors, TRUE1 male connectors, and certain IEC/NEMA connectors. Panel-to-panel connections are non-standard and require careful circuit design and labeling. Ensure proper derating for custom TRUE1/PowerCON connections. Disconnect power before plugging/unplugging IEC C13 to prevent arcing.'
  },

  'IEC_C14_cable_mount_male': { // IEC C14 Cable Mount Male (10–15A, 250V)-- // VERIFY
    id: 'IEC_C14_cable_mount_male',
    skuCode: 'IEC14',
    type: 'IEC',
    family: 'IEC C14 (Male)',
    poles: 3,
    gender: 'male',
    mountType: 'cable',
    purpose: 'power, hybrid',
    description: 'IEC C14 Cable Mount Male (10–15A, 250V)',
    image: '/images/IEC_C14_cable_mount_male.png',
    wireCompatibility: ['PSP14', 'PSP16'],
    wireGaugeCompatibility: ['14AWG', '16AWG'],
    compatibleWith: [
      {
        id: 'NAC3MPXXB',
        type: 'custom',
        polesUsed: 3,
        warning: '10–15A max. Derate if using 20A PowerCON.',
        notes: 'IEC C14 cable custom wired to PowerCON Grey panel.'
      },
      {
        id: 'NAC3FXXA-W-S',
        type: 'custom',
        polesUsed: 3,
        warning: '10–15A max. Derate if using 20A PowerCON.',
        notes: 'IEC C14 cable custom wired to PowerCON Blue cable.'
      },
      {
        id: 'NEMA_5-15R_panel_mount_female',
        type: 'custom',
        polesUsed: 3,
        warning: '15A max.',
        notes: 'IEC C14 cable custom wired to NEMA 5-15R panel.'
      },
      {
        id: 'NEMA_5-15R_cable_mount_female',
        type: 'custom',
        polesUsed: 3,
        warning: '15A max.',
        notes: 'IEC C14 cable custom wired to NEMA 5-15R cable.'
      },
      {
        id: 'IEC_C13_panel_mount_female',
        type: 'custom',
        polesUsed: 3,
        warning: '10–15A max.',
        notes: 'IEC C14 cable custom wired to IEC C13 panel.'
      },
      {
        id: 'IEC_C13_cable_mount_female',
        type: 'direct',
        polesUsed: 3,
        warning: null,
        notes: 'IEC C14 to IEC C13 cable (standard power cable, 10–15A)'
      },
      {
        id: 'NAC3F-TRUE1-S',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 16A TRUE1.',
        notes: 'IEC C14 cable custom wired to TRUE1 female cable.'
      },
      {
        id: 'NAC3FPX-TOP',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 16A TRUE1.',
        notes: 'IEC C14 cable custom wired to TRUE1 female panel.'
      }
    ],
    notCompatibleWith: [
      {
        id: 'NAC3FXXB-W-S', // Not Compatible?  // VERIFY
        reason: 'Original PowerCON and IEC C14 are incompatible',
        details: 'IEC C14 cable cannot be custom wired to PowerCON Grey cable.'
        // type: 'custom',
        // polesUsed: 3,
        // warning: '10–15A max. Derate if using 20A PowerCON.',
        // notes: 'IEC C14 cable custom wired to PowerCON Grey cable.'
      },
      {
        id: 'NAC3MPX-TOP',
        reason: 'Incompatible connector type',
        details: 'IEC C14 cable cannot be custom wired to TRUE1 male panel.'
      },
      {
        id: 'NAC3M-TRUE1-S',
        reason: 'Incompatible connector type',
        details: 'IEC C14 cable cannot be custom wired to TRUE1 male cable.'
      },
      {
        id: 'IEC_C14_cable_mount_male',
        reason: 'Cannot connect cable to cable (same gender and purpose)',
        details: 'IEC C14 cable cannot connect to another IEC C14 cable as both are sources.'
      },
      {
        id: 'IEC_C14_panel_mount_male',
        reason: 'IEC C14 is a source, not a load',
        details: 'IEC C14 cable cannot connect to IEC C14 panel as both are sources.'
      },
      {
        id: 'NEMA_5-15P_cable_mount_male',
        reason: 'NEMA 5-15P is a source, not a load',
        details: 'IEC C14 cable cannot connect to NEMA 5-15P cable as both are sources.'
      },
      {
        id: 'NEMA_5-15P_panel_mount_male',
        reason: 'NEMA 5-15P is a source, not a load',
        details: 'IEC C14 cable cannot connect to NEMA 5-15P panel as both are sources.'
      },
      {
        id: 'NAC3MPXXA',
        reason: 'Incompatible purpose',
        details: 'IEC C14 cable (source) cannot be custom wired to PowerCON Blue panel (power-in).'
      }
    ],
    notes: 'IEC C14 is for power-in (source) only. Compatible with PowerCON Grey connectors, TRUE1 female connectors, and certain IEC/NEMA connectors. Panel-to-panel connections are non-standard and require careful circuit design and labeling. Ensure proper derating for custom TRUE1/PowerCON connections. Disconnect power before plugging/unplugging IEC C14 to prevent arcing.'
  },

  'IEC_C13_panel_mount_female': { // IEC C13 Panel Mount Female (10–15A, 250V)-- // VERIFY
    id: 'IEC_C13_panel_mount_female',
    skuCode: 'IEC13P',
    type: 'IEC',
    family: 'IEC C13 (Female)',
    poles: 3,
    gender: 'female',
    mountType: 'panel',
    purpose: 'power',
    description: 'IEC C13 Panel Mount Female (10–15A, 250V)',
    image: '/images/IEC_C13_panel_mount_female.png',
    wireCompatibility: ['PSP14', 'PSP16'],
    wireGaugeCompatibility: ['14AWG', '16AWG'],
    compatibleWith: [
      {
        id: 'NAC3MPXXA',
        type: 'custom',
        polesUsed: 3,
        warning: '10–15A max. Derate if using 20A PowerCON.',
        notes: 'IEC C13 panel custom wired to PowerCON Blue panel.'
      },
      {
        id: 'NAC3FXXB-W-S',
        type: 'custom',
        polesUsed: 3,
        warning: '10–15A max. Derate if using 20A PowerCON.',
        notes: 'IEC C13 panel custom wired to PowerCON Grey cable.'
      },
      {
        id: 'NEMA_5-15P_panel_mount_male',
        type: 'custom',
        polesUsed: 3,
        warning: '15A max.',
        notes: 'IEC C13 panel custom wired to NEMA 5-15P panel.'
      },
      {
        id: 'NEMA_5-15P_cable_mount_male',
        type: 'custom',
        polesUsed: 3,
        warning: '15A max.',
        notes: 'IEC C13 panel custom wired to NEMA 5-15P cable.'
      },
      {
        id: 'IEC_C14_panel_mount_male',
        type: 'custom',
        polesUsed: 3,
        warning: '10–15A max.',
        notes: 'IEC C13 panel custom wired to IEC C14 panel.'
      },
      {
        id: 'IEC_C14_cable_mount_male',
        type: 'direct',
        polesUsed: 3,
        warning: null,
        notes: 'IEC C13 panel to IEC C14 cable (standard power cable, 10–15A)'
      },
      {
        id: 'NAC3M-TRUE1-S',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 16A TRUE1.',
        notes: 'IEC C13 panel custom wired to TRUE1 male cable.'
      },
      {
        id: 'NAC3MPX-TOP',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 16A TRUE1.',
        notes: 'IEC C13 panel custom wired to TRUE1 male panel.'
      }
    ],
    notCompatibleWith: [
      // { removed to fix conflict yes/no compatible issue
      //   id: 'NAC3MPX-TOP', // Not Compatible?  // VERIFY
      //   reason: 'Original PowerCON and IEC C13 are incompatible',
      //   details: 'IEC C13 panel cannot be custom wired to TRUE1 male panel.'
      //   // type: 'custom',
      //   // polesUsed: 3,
      //   // warning: '10–15A max. Derate if using 16A TRUE1.',
      //   // notes: 'IEC C13 panel custom wired to TRUE1 male panel.'
      // },
      // { removed to fix conflict yes/no compatible issue
      //   id: 'NAC3M-TRUE1-S', // Not Compatible?  // VERIFY
      //   reason: 'Original PowerCON and IEC C13 are incompatible',
      //   details: 'IEC C13 panel cannot be custom wired to TRUE1 male cable.'
      //   // type: 'custom',
      //   // polesUsed: 3,
      //   // warning: '10–15A max. Derate if using 16A TRUE1.',
      //   // notes: 'IEC C13 panel custom wired to TRUE1 male cable.'
      // },
      {
        id: 'NAC3FXXA-W-S', // Not Compatible?  // VERIFY
        reason: 'Original PowerCON Blueand IEC C13 are incompatible',
        details: 'IEC C13 panel cannot be custom wired to PowerCON Blue cable.'
        // type: 'custom',
        // polesUsed: 3,
        // warning: '10–15A max. Derate if using 20A PowerCON.',
        // notes: 'IEC C13 panel custom wired to PowerCON Blue cable.'
      },
      {
        id: 'IEC_C13_panel_mount_female',
        reason: 'Cannot connect panel to panel (same gender and purpose)',
        details: 'IEC C13 panel cannot connect to another IEC C13 panel as both are loads.'
      },
      {
        id: 'IEC_C13_cable_mount_female',
        reason: 'IEC C13 is a load, not a source',
        details: 'IEC C13 panel cannot connect to IEC C13 cable as both are loads.'
      },
      {
        id: 'NEMA_5-15R_cable_mount_female',
        reason: 'NEMA 5-15R is a load, not a source',
        details: 'IEC C13 panel cannot connect to NEMA 5-15R cable as both are loads.'
      },
      {
        id: 'NEMA_5-15R_panel_mount_female',
        reason: 'NEMA 5-15R is a load, not a source',
        details: 'IEC C13 panel cannot connect to NEMA 5-15R panel as both are loads.'
      },
      {
        id: 'NAC3F-TRUE1-S',
        reason: 'Incompatible connector type',
        details: 'IEC C13 panel cannot be custom wired to TRUE1 female cable.'
      },
      {
        id: 'NAC3FPX-TOP',
        reason: 'Incompatible connector type',
        details: 'IEC C13 panel cannot be custom wired to TRUE1 female panel.'
      },
      {
        id: 'NAC3MPXXB',
        reason: 'Incompatible purpose',
        details: 'IEC C13 panel (load) cannot be custom wired to PowerCON Grey panel (power-out).'
      }
    ],
    notes: 'IEC C13 is for power-out (load) only. Compatible with PowerCON Blue connectors, TRUE1 male connectors, and certain IEC/NEMA connectors. Panel-to-panel connections are non-standard and require careful circuit design and labeling. Ensure proper derating for custom TRUE1/PowerCON connections. Disconnect power before plugging/unplugging IEC C13 to prevent arcing.'
  },

  'IEC_C14_panel_mount_male': { // IEC C14 Panel Mount Male (10–15A, 250V)-- // VERIFY
    id: 'IEC_C14_panel_mount_male',
    skuCode: 'IEC14P',
    type: 'IEC',
    family: 'IEC C14 (Male)',
    poles: 3,
    gender: 'male',
    mountType: 'panel',
    purpose: 'power',
    description: 'IEC C14 Panel Mount Male (10–15A, 250V)',
    image: '/images/IEC_C14_panel_mount_male.png',
    wireCompatibility: ['PSP14', 'PSP16'],
    wireGaugeCompatibility: ['14AWG', '16AWG'],
    compatibleWith: [
      {
        id: 'NAC3MPXXB',
        type: 'custom',
        polesUsed: 3,
        warning: '10–15A max. Derate if using 20A PowerCON.',
        notes: 'IEC C14 panel custom wired to PowerCON Grey panel.'
      },
      {
        id: 'NAC3FXXA-W-S',
        type: 'custom',
        polesUsed: 3,
        warning: '10–15A max. Derate if using 20A PowerCON.',
        notes: 'IEC C14 panel custom wired to PowerCON Blue cable.'
      },
      {
        id: 'NEMA_5-15R_panel_mount_female',
        type: 'custom',
        polesUsed: 3,
        warning: '15A max.',
        notes: 'IEC C14 panel custom wired to NEMA 5-15R panel.'
      },
      {
        id: 'NEMA_5-15R_cable_mount_female',
        type: 'custom',
        polesUsed: 3,
        warning: '15A max.',
        notes: 'IEC C14 panel custom wired to NEMA 5-15R cable.'
      },
      {
        id: 'IEC_C13_panel_mount_female',
        type: 'custom',
        polesUsed: 3,
        warning: '10–15A max.',
        notes: 'IEC C14 panel custom wired to IEC C13 panel.'
      },
      {
        id: 'IEC_C13_cable_mount_female',
        type: 'direct',
        polesUsed: 3,
        warning: null,
        notes: 'IEC C14 panel to IEC C13 cable (standard power cable, 10–15A)'
      },
      {
        id: 'NAC3F-TRUE1-S',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 16A TRUE1.',
        notes: 'IEC C14 panel custom wired to TRUE1 female cable.'
      },
      {
        id: 'NAC3FPX-TOP',
        type: 'custom',
        polesUsed: 2,
        warning: '10–15A max. Derate if using 16A TRUE1.',
        notes: 'IEC C14 panel custom wired to TRUE1 female panel.'
      }
    ],
    notCompatibleWith: [
      {
        id: 'NAC3FXXB-W-S', // Not Compatible?  // VERIFY
        reason: 'Original PowerCON and IEC C14 are incompatible',
        details: 'IEC C14 panel cannot be custom wired to PowerCON Grey cable.'
        // type: 'custom',
        // polesUsed: 3,
        // warning: '10–15A max. Derate if using 20A PowerCON.',
        // notes: 'IEC C14 panel custom wired to PowerCON Grey cable.'
      },
      {
        id: 'IEC_C14_panel_mount_male',
        reason: 'Cannot connect panel to panel (same gender and purpose)',
        details: 'IEC C14 panel cannot connect to another IEC C14 panel as both are sources.'
      },
      {
        id: 'IEC_C14_cable_mount_male',
        reason: 'IEC C14 is a source, not a load',
        details: 'IEC C14 panel cannot connect to IEC C14 cable as both are sources.'
      },
      {
        id: 'NEMA_5-15P_cable_mount_male',
        reason: 'NEMA 5-15P is a source, not a load',
        details: 'IEC C14 panel cannot connect to NEMA 5-15P cable as both are sources.'
      },
      {
        id: 'NEMA_5-15P_panel_mount_male',
        reason: 'NEMA 5-15P is a source, not a load',
        details: 'IEC C14 panel cannot connect to NEMA 5-15P panel as both are sources.'
      },
      {
        id: 'NAC3M-TRUE1-S',
        reason: 'Incompatible connector type',
        details: 'IEC C14 panel cannot be custom wired to TRUE1 male cable.'
      },
      {
        id: 'NAC3MPX-TOP',
        reason: 'Incompatible connector type',
        details: 'IEC C14 panel cannot be custom wired to TRUE1 male panel.'
      },
      {
        id: 'NAC3MPXXA',
        reason: 'Incompatible purpose',
        details: 'IEC C14 panel (source) cannot be custom wired to PowerCON Blue panel (power-in).'
      }
    ],
    notes: 'IEC C14 is for power-in (source) only. Compatible with PowerCON Grey connectors, TRUE1 female connectors, and certain IEC/NEMA connectors. Panel-to-panel connections are non-standard and require careful circuit design and labeling. Ensure proper derating for custom TRUE1/PowerCON connections. Disconnect power before plugging/unplugging IEC C14 to prevent arcing.'
  },

  // --- NEMA ---
  'NEMA_5-15P_cable_mount_male': { // NEMA 5-15P Cable Mount Male (15A, 125V)-- // VERIFY
    id: 'NEMA_5-15P_cable_mount_male',
    skuCode: '515P',
    type: 'NEMA',
    family: '5-15P (Male)',
    poles: 3,
    gender: 'male',
    mountType: 'cable',
    purpose: 'power, hybrid',
    description: 'NEMA 5-15P Cable Mount Male (15A, 125V)',
    image: '/images/5-15P_cable_mount_male.png',
    wireCompatibility: ['PSP12', 'PSP14', 'PSP16'],
    wireGaugeCompatibility: ['12AWG', '14AWG', '16AWG'],
    compatibleWith: [
      {
        id: 'NAC3MPXXB',
        type: 'custom',
        polesUsed: 3,
        warning: '15A max. Derate if using 20A PowerCON.',
        notes: 'NEMA 5-15P cable custom wired to PowerCON Grey panel.'
      },
      {
        id: 'NAC3FXXA-W-S',
        type: 'custom',
        polesUsed: 3,
        warning: '15A max. Derate if using 20A PowerCON.',
        notes: 'NEMA 5-15P cable custom wired to PowerCON Blue cable.'
      },
      {
        id: 'NEMA_5-15R_panel_mount_female',
        type: 'custom',
        polesUsed: 3,
        warning: '15A max.',
        notes: 'NEMA 5-15P cable custom wired to NEMA 5-15R panel.'
      },
      {
        id: 'NEMA_5-15R_cable_mount_female',
        type: 'direct',
        polesUsed: 3,
        warning: null,
        notes: 'NEMA 5-15P to NEMA 5-15R cable (standard US power cable, 15A)'
      },
      {
        id: 'IEC_C13_cable_mount_female',
        type: 'custom',
        polesUsed: 3,
        warning: '10–15A max.',
        notes: 'NEMA 5-15P cable custom wired to IEC C13 cable.'
      },
      {
        id: 'IEC_C13_panel_mount_female',
        type: 'custom',
        polesUsed: 3,
        warning: '10–15A max.',
        notes: 'NEMA 5-15P cable custom wired to IEC C13 panel.'
      },
      {
        id: 'NAC3F-TRUE1-S',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 16A TRUE1.',
        notes: 'NEMA 5-15P cable custom wired to TRUE1 female cable.'
      },
      {
        id: 'NAC3FPX-TOP',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 16A TRUE1.',
        notes: 'NEMA 5-15P cable custom wired to TRUE1 female panel.'
      }
    ],
    notCompatibleWith: [
      {
        id: 'NAC3FXXB-W-S', // Not Compatible?  // VERIFY
        reason: 'Original PowerCON and NEMA 5-15P are incompatible',
        details: 'NEMA 5-15P cable cannot be custom wired to PowerCON Grey cable.'
        // type: 'custom',
        // polesUsed: 3,
        // warning: '15A max. Derate if using 20A PowerCON.',
        // notes: 'NEMA 5-15P cable custom wired to PowerCON Grey cable.'
      },


      {
        id: 'NEMA_5-15P_cable_mount_male',
        reason: 'Cannot connect cable to cable (same gender and purpose)',
        details: 'NEMA 5-15P cable cannot connect to another NEMA 5-15P cable as both are sources.'
      },
      {
        id: 'NEMA_5-15P_panel_mount_male',
        reason: 'NEMA 5-15P is a source, not a load',
        details: 'NEMA 5-15P cable cannot connect to NEMA 5-15P panel as both are sources.'
      },
      {
        id: 'IEC_C14_cable_mount_male',
        reason: 'IEC C14 is a source, not a load',
        details: 'NEMA 5-15P cable cannot connect to IEC C14 cable as both are sources.'
      },
      {
        id: 'IEC_C14_panel_mount_male',
        reason: 'IEC C14 is a source, not a load',
        details: 'NEMA 5-15P cable cannot connect to IEC C14 panel as both are sources.'
      },
      {
        id: 'NAC3MPXXA',
        reason: 'Incompatible purpose',
        details: 'NEMA 5-15P cable (source) cannot be custom wired to PowerCON Blue panel (power-in).'
      }
    ],
    notes: 'NEMA 5-15P is for power-in (source) only. Compatible with PowerCON Grey connectors, TRUE1 female connectors, and certain NEMA/IEC connectors. Panel-to-panel connections are non-standard and require careful circuit design and labeling. Ensure proper derating for custom TRUE1/PowerCON/IEC connections. Disconnect power before plugging/unplugging NEMA 5-15P to prevent arcing.'
  },

  'NEMA_5-15R_cable_mount_female': { // NEMA 5-15R Cable Mount Female (15A, 125V)-- // VERIFY
    id: 'NEMA_5-15R_cable_mount_female',
    skuCode: '515R',
    type: 'NEMA',
    family: '5-15R (Female)',
    poles: 3,
    gender: 'female',
    mountType: 'cable',
    purpose: 'power, hybrid',
    description: 'NEMA 5-15R Cable Mount Female (15A, 125V)',
    image: '/images/5-15R_cable_mount_female.png',
    wireCompatibility: ['PSP12', 'PSP14', 'PSP16'],
    wireGaugeCompatibility: ['12AWG', '14AWG', '16AWG'],
    compatibleWith: [
      {
        id: 'NAC3MPXXA',
        type: 'custom',
        polesUsed: 3,
        warning: '15A max. Derate if using 20A PowerCON.',
        notes: 'NEMA 5-15R cable custom wired to PowerCON Blue panel.'
      },
      {
        id: 'NAC3FXXB-W-S',
        type: 'custom',
        polesUsed: 3,
        warning: '15A max. Derate if using 20A PowerCON.',
        notes: 'NEMA 5-15R cable custom wired to PowerCON Grey cable.'
      },
      {
        id: 'NEMA_5-15P_panel_mount_male',
        type: 'custom',
        polesUsed: 3,
        warning: '15A max.',
        notes: 'NEMA 5-15R cable custom wired to NEMA 5-15P panel.'
      },
      {
        id: 'NEMA_5-15P_cable_mount_male',
        type: 'direct',
        polesUsed: 3,
        warning: null,
        notes: 'NEMA 5-15R to NEMA 5-15P cable (standard US power cable, 15A)'
      },
      {
        id: 'IEC_C14_cable_mount_male',
        type: 'custom',
        polesUsed: 3,
        warning: '10–15A max.',
        notes: 'NEMA 5-15R cable custom wired to IEC C14 cable.'
      },
      {
        id: 'IEC_C14_panel_mount_male',
        type: 'custom',
        polesUsed: 3,
        warning: '10–15A max.',
        notes: 'NEMA 5-15R cable custom wired to IEC C14 panel.'
      },
      {
        id: 'NAC3M-TRUE1-S',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 16A TRUE1.',
        notes: 'NEMA 5-15R cable custom wired to TRUE1 male cable.'
      },
      {
        id: 'NAC3MPX-TOP',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 16A TRUE1.',
        notes: 'NEMA 5-15R cable custom wired to TRUE1 male panel.'
      }
    ],
    notCompatibleWith: [
      {
        id: 'NAC3FXXA-W-S', // Not Compatible?  // VERIFY
        reason: 'Original PowerCON and NEMA 5-15R are incompatible',
        details: 'NEMA 5-15R cable cannot be custom wired to PowerCON Blue cable.'
      },
      {
        id: 'NEMA_5-15R_cable_mount_female',
        reason: 'Cannot connect cable to cable (same gender and purpose)',
        details: 'NEMA 5-15R cable cannot connect to another NEMA 5-15R cable as both are loads.'
      },
      {
        id: 'NEMA_5-15R_panel_mount_female',
        reason: 'NEMA 5-15R is a load, not a source',
        details: 'NEMA 5-15R cable cannot connect to NEMA 5-15R panel as both are loads.'
      },
      {
        id: 'IEC_C13_cable_mount_female',
        reason: 'IEC C13 is a load, not a source',
        details: 'NEMA 5-15R cable cannot connect to IEC C13 cable as both are loads.'
      },
      {
        id: 'IEC_C13_panel_mount_female',
        reason: 'IEC C13 is a load, not a source',
        details: 'NEMA 5-15R cable cannot connect to IEC C13 panel as both are loads.'
      },
      {
        id: 'NAC3MPXXB',
        reason: 'Incompatible purpose',
        details: 'NEMA 5-15R cable (load) cannot be custom wired to PowerCON Grey panel (power-out).'
      }
    ],
    notes: 'NEMA 5-15R is for power-out (load) only. Compatible with PowerCON Blue connectors, TRUE1 male connectors, and certain NEMA/IEC connectors. Panel-to-panel connections are non-standard and require careful circuit design and labeling. Ensure proper derating for custom TRUE1/PowerCON/IEC connections. Disconnect power before plugging/unplugging NEMA 5-15R to prevent arcing.'
  },

  'NEMA_5-15P_panel_mount_male': { // NEMA 5-15P Panel Mount Male (15A, 125V)-- // VERIFY
    id: 'NEMA_5-15P_panel_mount_male',
    skuCode: '515PP',
    type: 'NEMA',
    family: '5-15P (Male)',
    poles: 3,
    gender: 'male',
    mountType: 'panel',
    purpose: 'power',
    description: 'NEMA 5-15P Panel Mount Male (15A, 125V)',
    image: '/images/515P_M.jpg',
    wireCompatibility: ['PSP12', 'PSP14', 'PSP16'],
    wireGaugeCompatibility: ['12AWG', '14AWG', '16AWG'],
    compatibleWith: [
      {
        id: 'NAC3MPXXB',
        type: 'custom',
        polesUsed: 3,
        warning: '15A max. Derate if using 20A PowerCON.',
        notes: 'NEMA 5-15P panel custom wired to PowerCON Grey panel.'
      },
      {
        id: 'NAC3FXXA-W-S',
        type: 'custom',
        polesUsed: 3,
        warning: '15A max. Derate if using 20A PowerCON.',
        notes: 'NEMA 5-15P panel custom wired to PowerCON Blue cable.'
      },
      {
        id: 'NEMA_5-15R_panel_mount_female',
        type: 'custom',
        polesUsed: 3,
        warning: '15A max.',
        notes: 'NEMA 5-15P panel custom wired to NEMA 5-15R panel.'
      },
      {
        id: 'NEMA_5-15R_cable_mount_female',
        type: 'direct',
        polesUsed: 3,
        warning: null,
        notes: 'NEMA 5-15P panel to NEMA 5-15R cable (standard US power cable, 15A)'
      },
      {
        id: 'IEC_C13_cable_mount_female',
        type: 'custom',
        polesUsed: 3,
        warning: '10–15A max.',
        notes: 'NEMA 5-15P panel custom wired to IEC C13 cable.'
      },
      {
        id: 'IEC_C13_panel_mount_female',
        type: 'custom',
        polesUsed: 3,
        warning: '10–15A max.',
        notes: 'NEMA 5-15P panel custom wired to IEC C13 panel.'
      },
      {
        id: 'NAC3FPX-TOP',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 16A TRUE1.',
        notes: 'NEMA 5-15P panel custom wired to TRUE1 female panel.'
      },
      {
        id: 'NAC3F-TRUE1-S',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 16A TRUE1.',
        notes: 'NEMA 5-15P panel custom wired to TRUE1 female cable.'
      }
    ],
    notCompatibleWith: [
      {
        id: 'NAC3FXXB-W-S', // Not Compatible?  // VERIFY
        reason: 'Original PowerCON and NEMA 5-15P are incompatible',
        details: 'NEMA 5-15P panel cannot be custom wired to PowerCON Grey cable.'
        // type: 'custom',
        // polesUsed: 3,
        // warning: '15A max. Derate if using 20A PowerCON.',
        // notes: 'NEMA 5-15P panel custom wired to PowerCON Grey cable.'
      },
      {
        id: 'NEMA_5-15P_panel_mount_male',
        reason: 'Cannot connect panel to panel (same gender and purpose)',
        details: 'NEMA 5-15P panel cannot connect to another NEMA 5-15P panel as both are sources.'
      },
      {
        id: 'NEMA_5-15P_cable_mount_male',
        reason: 'NEMA 5-15P is a source, not a load',
        details: 'NEMA 5-15P panel cannot connect to NEMA 5-15P cable as both are sources.'
      },
      {
        id: 'IEC_C14_cable_mount_male',
        reason: 'IEC C14 is a source, not a load',
        details: 'NEMA 5-15P panel cannot connect to IEC C14 cable as both are sources.'
      },
      {
        id: 'IEC_C14_panel_mount_male',
        reason: 'IEC C14 is a source, not a load',
        details: 'NEMA 5-15P panel cannot connect to IEC C14 panel as both are sources.'
      },
      {
        id: 'NAC3MPXXA',
        reason: 'Incompatible purpose',
        details: 'NEMA 5-15P panel (source) cannot be custom wired to PowerCON Blue panel (power-in).'
      }
    ],
    notes: 'NEMA 5-15P is for power-in (source) only. Compatible with PowerCON Grey connectors, TRUE1 female connectors, and certain NEMA/IEC connectors. Panel-to-panel connections are non-standard and require careful circuit design and labeling. Ensure proper derating for custom TRUE1/PowerCON/IEC connections. Disconnect power before plugging/unplugging NEMA 5-15P to prevent arcing.'
  },

  'NEMA_5-15R_panel_mount_female': { // NEMA 5-15R Panel Mount Female (15A, 125V)-- // VERIFY
    id: 'NEMA_5-15R_panel_mount_female',
    skuCode: '515RP',
    type: 'NEMA',
    family: '5-15R (Female)',
    poles: 3,
    gender: 'female',
    mountType: 'panel',
    purpose: 'power',
    description: 'NEMA 5-15R Panel Mount Female (15A, 125V)',
    image: '/images/515R_F.jpg',
    wireCompatibility: ['PSP12', 'PSP14', 'PSP16'],
    wireGaugeCompatibility: ['12AWG', '14AWG', '16AWG'],
    compatibleWith: [
      {
        id: 'NAC3MPXXA',
        type: 'custom',
        polesUsed: 3,
        warning: '15A max. Derate if using 20A PowerCON.',
        notes: 'NEMA 5-15R panel custom wired to PowerCON Blue panel.'
      },
      {
        id: 'NAC3FXXB-W-S',
        type: 'custom',
        polesUsed: 3,
        warning: '15A max. Derate if using 20A PowerCON.',
        notes: 'NEMA 5-15R panel custom wired to PowerCON Grey cable.'
      },
      {
        id: 'NEMA_5-15P_cable_mount_male',
        type: 'direct',
        polesUsed: 3,
        warning: null,
        notes: 'NEMA 5-15R panel to NEMA 5-15P cable (standard US power cable, 15A)'
      },
      {
        id: 'NEMA_5-15P_panel_mount_male',
        type: 'custom',
        polesUsed: 3,
        warning: '15A max.',
        notes: 'NEMA 5-15R panel custom wired to NEMA 5-15P panel.'
      },
      {
        id: 'IEC_C14_cable_mount_male',
        type: 'custom',
        polesUsed: 3,
        warning: '10–15A max.',
        notes: 'NEMA 5-15R panel custom wired to IEC C14 cable.'
      },
      {
        id: 'IEC_C14_panel_mount_male',
        type: 'custom',
        polesUsed: 3,
        warning: '10–15A max.',
        notes: 'NEMA 5-15R panel custom wired to IEC C14 panel.'
      },
      {
        id: 'NAC3M-TRUE1-S',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 16A TRUE1.',
        notes: 'NEMA 5-15R panel custom wired to TRUE1 male cable.'
      },
      {
        id: 'NAC3MPX-TOP',
        type: 'custom',
        polesUsed: 2,
        warning: '15A max. Derate if using 16A TRUE1.',
        notes: 'NEMA 5-15R panel custom wired to TRUE1 male panel.'
      }
    ],
    notCompatibleWith: [
      {
        id: 'NAC3FXXA-W-S', // Not Compatible?  // VERIFY
        reason: 'Original PowerCON and NEMA 5-15R are incompatible',
        details: 'NEMA 5-15R panel cannot be custom wired to PowerCON Blue cable.'
        // type: 'custom',
        // polesUsed: 3,
        // warning: '15A max. Derate if using 20A PowerCON.',
        // notes: 'NEMA 5-15R panel custom wired to PowerCON Blue cable.'
      },
      {
        id: 'NEMA_5-15R_panel_mount_female',
        reason: 'Cannot connect panel to panel (same gender and purpose)',
        details: 'NEMA 5-15R panel cannot connect to another NEMA 5-15R panel as both are loads.'
      },
      {
        id: 'NEMA_5-15R_cable_mount_female',
        reason: 'NEMA 5-15R is a load, not a source',
        details: 'NEMA 5-15R panel cannot connect to NEMA 5-15R cable as both are loads.'
      },
      {
        id: 'IEC_C13_cable_mount_female',
        reason: 'IEC C13 is a load, not a source',
        details: 'NEMA 5-15R panel cannot connect to IEC C13 cable as both are loads.'
      },
      {
        id: 'IEC_C13_panel_mount_female',
        reason: 'IEC C13 is a load, not a source',
        details: 'NEMA 5-15R panel cannot connect to IEC C13 panel as both are loads.'
      },
      {
        id: 'NAC3F-TRUE1-S',
        reason: 'Incompatible connector type',
        details: 'NEMA 5-15R panel cannot be custom wired to TRUE1 female cable.'
      },
      {
        id: 'NAC3FPX-TOP',
        reason: 'Incompatible connector type',
        details: 'NEMA 5-15R panel cannot be custom wired to TRUE1 female panel.'
      },
      {
        id: 'NAC3MPXXB',
        reason: 'Incompatible purpose',
        details: 'NEMA 5-15R panel (load) cannot be custom wired to PowerCON Grey panel (power-out).'
      }
    ],
    notes: 'NEMA 5-15R is for power-out (load) only. Compatible with PowerCON Blue connectors, TRUE1 male connectors, and certain NEMA/IEC connectors. Panel-to-panel connections are non-standard and require careful circuit design and labeling. Ensure proper derating for custom TRUE1/PowerCON/IEC connections. Disconnect power before plugging/unplugging NEMA 5-15R to prevent arcing.'
  },

  // XLR Cable Mount Female // -- CORRECTED--
  'NC3FXX': {  
    id: 'NC3FXX',
    skuCode: 'XLRF',
    type: 'XLR',
    family: 'XLR 3-pin',
    poles: 3,
    gender: 'female',
    mountType: 'cable',
    purpose: 'audio, wye, hybrid, dmx',
    description: '3-pin XLR Female',
    image: '/images/nc3fxx.jpg',
    wireCompatibility: ["PSM","PSDMX","Zip"],
    compatibleWith: [
      {id: 'NC3MXX', type: 'direct', polesUsed: 3, warning: null, notes: 'Standard balanced connection'},
      {id: 'NC3MRX', type: 'direct', polesUsed: 3, warning: null, notes: 'Standard balanced connection, right-angle'},
      {id: 'NC3MD-L-1', type: 'direct', polesUsed: 3, warning: null, notes: 'Standard balanced connection, panel-mount'},
      {id: 'NC3FXX', type: 'custom', polesUsed: 3, warning: null, notes: 'For use as extension or adapter cable'},
      {id: 'NC3FRX', type: 'custom', polesUsed: 3, warning: null, notes: 'For use as extension or adapter cable, right-angle'},
      {id: 'NC3FD-L-1', type: 'custom', polesUsed: 3, warning: null, notes: 'For use as extension or adapter cable, panel-mount'},
      {id: 'NC5MXX', type: 'partial', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused', notes: '5-pin XLR male cable'},
      {id: 'NC5MD-L-1', type: 'partial', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused', notes: '5-pin XLR male panel-mount'},
      {id: 'NC5FXX', type: 'custom', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused', notes: '5-pin XLR female cable'},
      {id: 'NC5FD-L-1', type: 'custom', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused', notes: '5-pin XLR female panel-mount'},
      {id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS male connection'},
      {id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS female connection'},
      {id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS male right angle connection'},
      {id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS female right angle connection'},
      {id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS male panel-mount connection'},
      {id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS female panel-mount connection'},
      {id: '2TR_M', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio connection'},
      {id: '2TR_F', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio connection'},
      {id: '2TR_FL', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio connection'},
      {id: '2TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio right angle connection'},
      {id: '2TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio right angle connection'},
      {id: '2TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio panel-mount connection'},
      {id: '2TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio panel-mount connection'},
      {id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS male connection'},
      {id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized.', notes: '1/4" TS female connection'},
      {id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS male right angle connection'},
      {id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS female right angle connection'},
      {id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS male panel-mount connection'},
      {id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS female panel-mount connection'},
      {id: '3TR_M', type: 'direct', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio connection'},
      {id: '3TR_F', type: 'direct', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio connection'},
      {id: '3TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio right angle connection'},
      {id: '3TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio right angle connection'},
      {id: '3TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio panel-mount connection'},
      {id: '3TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio panel-mount connection'},
      {id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: 'RCA male connection'},
      {id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized. ', notes: 'RCA female connection'},
      {id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: 'RCA male connection'},
      {id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized. ', notes: 'RCA female connection'},
      {id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: 'RCA male connection'},
      {id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized. ', notes: 'RCA female connection'}
    ],
    // Official notation: XLR and Speakon are not compatible (different connector families and signal levels).
    notCompatibleWith: [
      { id: 'NL2MX', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL4MX', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL4FXX-W-S', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'SPK4_M_PM', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL8MX', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL8FC', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'SPK8_M_PM', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'SPK8_M_PM_BAG', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' }
    ],
    notes: 'Used in audio applications. Custom wiring allows same-gender connections.'
  },
  // XLR Right Angle Female // -- CORRECTED--
  'NC3FRX': {
    id: 'NC3FRX',
    skuCode: 'XLRFRA',
    type: 'XLR',
    family: 'XLR 3-pin',
    poles: 3,
    gender: 'female',
    mountType: 'rightangle',
    purpose: 'audio, wye, hybrid, dmx',
    description: '3-pin XLR Female Right-Angle',
    image: '/images/nc3frx.jpg',
    wireCompatibility: ["PSM","PSDMX","Zip"],
    compatibleWith: [
      {id: 'NC3MXX', type: 'direct', polesUsed: 3, warning: null, notes: 'Standard balanced connection'},
      {id: 'NC3MRX', type: 'direct', polesUsed: 3, warning: null, notes: 'Standard balanced connection, right-angle'},
      {id: 'NC3MD-L-1', type: 'direct', polesUsed: 3, warning: null, notes: 'Standard balanced connection, panel-mount'},
      {id: 'NC3FXX', type: 'custom', polesUsed: 3, warning: null, notes: 'For use as extension or adapter cable'},
      {id: 'NC3FRX', type: 'custom', polesUsed: 3, warning: null, notes: 'For use as extension or adapter cable, right-angle'},
      {id: 'NC3FD-L-1', type: 'custom', polesUsed: 3, warning: null, notes: 'For use as extension or adapter cable, panel-mount'},
      {id: 'NC5MXX', type: 'partial', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused', notes: '5-pin XLR male cable'},
      {id: 'NC5MD-L-1', type: 'partial', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused', notes: '5-pin XLR male panel-mount'},
      {id: 'NC5FXX', type: 'custom', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused', notes: '5-pin XLR female cable'},
      {id: 'NC5FD-L-1', type: 'custom', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused', notes: '5-pin XLR female panel-mount'},
      {id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS male connection'},
      {id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS female connection'},
      {id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS male right angle connection'},
      {id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS female right angle connection'},
      {id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS male panel-mount connection'},
      {id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS female panel-mount connection'},
      {id: '2TR_M', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio connection'},
      {id: '2TR_F', type: 'custom', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio connection'},
      {id: '2TR_FL', type: 'custom', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio connection'},
      {id: '2TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio right angle connection'},
      {id: '2TR_F_RA', type: 'custom', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio right angle connection'},
      {id: '2TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio panel-mount connection'},
      {id: '2TR_F_PM', type: 'custom', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio panel-mount connection'},
      {id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS male connection'},
      {id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized.', notes: '1/4" TS female connection'},
      {id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS male right angle connection'},
      {id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS female right angle connection'},
      {id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS male panel-mount connection'},
      {id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS female panel-mount connection'},
      {id: '3TR_M', type: 'direct', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio connection'},
      {id: '3TR_F', type: 'custom', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio connection'},
      {id: '3TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio right angle connection'},
      {id: '3TR_F_RA', type: 'custom', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio right angle connection'},
      {id: '3TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio panel-mount connection'},
      {id: '3TR_F_PM', type: 'custom', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio panel-mount connection'},
      {id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: 'RCA male connection'},
      {id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized. ', notes: 'RCA female connection'},
      {id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: 'RCA male connection'},
      {id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized. ', notes: 'RCA female connection'},
      {id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: 'RCA male connection'},
      {id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized. ', notes: 'RCA female connection'}
    ],
    // Official notation: XLR and Speakon are not compatible (different connector families and signal levels).
    notCompatibleWith: [
      { id: 'NL2MX', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL4MX', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL4FXX-W-S', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'SPK4_M_PM', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL8MX', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL8FC', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'SPK8_M_PM', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'SPK8_M_PM_BAG', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' }
    ],
    notes: 'Used in audio applications. Right-angle design for tight spaces.'
  },

  // XLR Panel Mount Female //
  'NC3FD-L-1': {
    id: 'NC3FD-L-1',
    skuCode: 'XLRFPM',
    type: 'XLR',
    family: 'XLR 3-pin',
    poles: 3,
    gender: 'female',
    mountType: 'panel',
    purpose: 'audio, wye, dmx',
    description: '3-pin XLR Female Panel-Mount',
    image: '/images/nc3fd-L-1.jpg',
    wireCompatibility: ["PSM","PSDMX","Zip"],
    compatibleWith: [
      {id: 'NC3MXX', type: 'direct', polesUsed: 3, warning: null, notes: 'Standard balanced connection'},
      {id: 'NC3MRX', type: 'direct', polesUsed: 3, warning: null, notes: 'Standard balanced connection, right-angle'},
      {id: 'NC3MD-L-1', type: 'direct', polesUsed: 3, warning: null, notes: 'Standard balanced connection, panel-mount'},
      {id: 'NC3FXX', type: 'custom', polesUsed: 3, warning: null, notes: 'For use as extension or adapter cable'},
      {id: 'NC3FRX', type: 'custom', polesUsed: 3, warning: null, notes: 'For use as extension or adapter cable, right-angle'},
      {id: 'NC3FD-L-1', type: 'custom', polesUsed: 3, warning: null, notes: 'For use as extension or adapter cable, panel-mount'},
      {id: 'NC5MXX', type: 'partial', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused', notes: '5-pin XLR male cable'},
      {id: 'NC5MD-L-1', type: 'partial', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused', notes: '5-pin XLR male panel-mount'},
      {id: 'NC5FXX', type: 'custom', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused.', notes: '5-pin XLR female cable'},
      {id: 'NC5FD-L-1', type: 'custom', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused.', notes: '5-pin XLR female panel-mount'},
      {id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS male connection'},
      {id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS female connection'},
      {id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS male right angle connection'},
      {id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS female right angle connection'},
      {id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS male panel-mount connection'},
      {id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS female panel-mount connection'},
      {id: '2TR_M', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio connection'},
      {id: '2TR_F', type: 'custom', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio connection'},
      {id: '2TR_FL', type: 'custom', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio connection'},
      {id: '2TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio right angle connection'},
      {id: '2TR_F_RA', type: 'custom', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio right angle connection'},
      {id: '2TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio panel-mount connection'},
      {id: '2TR_F_PM', type: 'custom', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio panel-mount connection'},
      {id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS male connection'},
      {id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized.', notes: '1/4" TS female connection'},
      {id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS male right angle connection'},
      {id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS female right angle connection'},
      {id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS male panel-mount connection'},
      {id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS female panel-mount connection'},
      {id: '3TR_M', type: 'direct', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio connection'},
      {id: '3TR_F', type: 'custom', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio connection'},
      {id: '3TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio right angle connection'},
      {id: '3TR_F_RA', type: 'custom', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio right angle connection'},
      {id: '3TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio panel-mount connection'},
      {id: '3TR_F_PM', type: 'custom', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio panel-mount connection'},
      {id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: 'RCA male connection'},
      {id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized. ', notes: 'RCA female connection'},
      {id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: 'RCA male connection'},
      {id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized. ', notes: 'RCA female connection'},
      {id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: 'RCA male connection'},
      {id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized. ', notes: 'RCA female connection'}
    ],
    // Official notation: XLR and Speakon are not compatible (different connector families and signal levels).
    notCompatibleWith: [
      { id: 'NL2MX', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL4MX', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL4FXX-W-S', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'SPK4_M_PM', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL8MX', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL8FC', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'SPK8_M_PM', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'SPK8_M_PM_BAG', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' }
    ],
    notes: 'Used in audio applications. Panel-mount design for equipment integration.'
  },

  // XLR Cable Mount Male // -- CORRECTED--
  'NC3MXX': {
    id: 'NC3MXX',
    skuCode: 'XLRM',
    type: 'XLR',
    family: 'XLR 3-pin',
    poles: 3,
    gender: 'male',
    mountType: 'cable',
    purpose: 'audio, wye, hybrid, dmx',
    description: '3-pin XLR Male',
    image: '/images/nc3mxx.jpg',
    wireCompatibility: ["PSM","PSDMX","Zip"],
    compatibleWith: [
      {id: 'NC3FXX', type: 'direct', polesUsed: 3, warning: null, notes: 'Standard balanced connection'},
      {id: 'NC3FRX', type: 'direct', polesUsed: 3, warning: null, notes: 'Standard balanced connection, right-angle'},
      {id: 'NC3FD-L-1', type: 'direct', polesUsed: 3, warning: null, notes: 'Standard balanced connection, panel-mount'},
      {id: 'NC3MXX', type: 'custom', polesUsed: 3, warning: null, notes: 'For use as extension or adapter cable'},
      {id: 'NC3MRX', type: 'custom', polesUsed: 3, warning: null, notes: 'For use as extension or adapter cable, right-angle'},
      {id: 'NC3MD-L-1', type: 'custom', polesUsed: 3, warning: null, notes: 'For use as extension or adapter cable, panel-mount'},
      {id: 'NC5FXX', type: 'partial', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused', notes: '5-pin XLR female cable'},
      {id: 'NC5FD-L-1', type: 'partial', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused', notes: '5-pin XLR female panel-mount'},
      {id: 'NC5MXX', type: 'custom', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused.', notes: '5-pin XLR male cable'},
      {id: 'NC5MD-L-1', type: 'custom', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused.', notes: '5-pin XLR male panel-mount'},
      {id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS male connection'},
      {id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS female connection'},
      {id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS male right angle connection'},
      {id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS female right angle connection'},
      {id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS male panel-mount connection'},
      {id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS female panel-mount connection'},
      {id: '2TR_M', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio connection'},
      {id: '2TR_F', type: 'custom', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio connection'},
      {id: '2TR_FL', type: 'custom', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio connection'},
      {id: '2TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio right angle connection'},
      {id: '2TR_F_RA', type: 'custom', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio right angle connection'},
      // {id: '2TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio panel-mount connection'},
      {id: '2TR_F_PM', type: 'custom', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio panel-mount connection'},
      {id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS male connection'},
      {id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized.', notes: '1/4" TS female connection'},
      {id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS male right angle connection'},
      {id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS female right angle connection'},
      {id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS male panel-mount connection'},
      {id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS female panel-mount connection'},
      {id: '3TR_M', type: 'direct', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio connection'},
      {id: '3TR_F', type: 'custom', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio connection'},
      {id: '3TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio right angle connection'},
      {id: '3TR_F_RA', type: 'custom', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio right angle connection'},
      {id: '3TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio panel-mount connection'},
      {id: '3TR_F_PM', type: 'custom', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio panel-mount connection'},
      {id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: 'RCA male connection'},
      {id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized. ', notes: 'RCA female connection'},
      {id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: 'RCA male connection'},
      {id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized. ', notes: 'RCA female connection'},
      {id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: 'RCA male connection'},
      {id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized. ', notes: 'RCA female connection'}
    ],
    // Official notation: XLR and Speakon are not compatible (different connector families and signal levels).
    notCompatibleWith: [
      { id: 'NL2MX', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL4MX', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL4FXX-W-S', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'SPK4_M_PM', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL8MX', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL8FC', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'SPK8_M_PM', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'SPK8_M_PM_BAG', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' }
    ],
    notes: 'Used in audio applications. Custom wiring allows same-gender connections.'
  },
  // XLR Right Angle Male // -- CORRECTED--
  'NC3MRX': {
    id: 'NC3MRX',
    skuCode: 'XLRMRA',
    type: 'XLR',
    family: 'XLR 3-pin',
    poles: 3,
    gender: 'male',
    mountType: 'rightangle',
    purpose: 'audio, wye, hybrid, dmx',
    description: '3-pin XLR Male Right-Angle',
    image: '/images/nc3mrx.jpg',
    wireCompatibility: ["PSM","PSDMX","Zip"],
    compatibleWith: [
      {id: 'NC3FXX', type: 'direct', polesUsed: 3, warning: null, notes: 'Standard balanced connection'},
      {id: 'NC3FRX', type: 'direct', polesUsed: 3, warning: null, notes: 'Standard balanced connection, right-angle'},
      {id: 'NC3FD-L-1', type: 'direct', polesUsed: 3, warning: null, notes: 'Standard balanced connection, panel-mount'},
      {id: 'NC3MXX', type: 'custom', polesUsed: 3, warning: null, notes: 'For use as extension or adapter cable'},
      {id: 'NC3MRX', type: 'custom', polesUsed: 3, warning: null, notes: 'For use as extension or adapter cable, right-angle'},
      {id: 'NC3MD-L-1', type: 'custom', polesUsed: 3, warning: null, notes: 'For use as extension or adapter cable, panel-mount'},
      {id: 'NC5FXX', type: 'partial', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused', notes: '5-pin XLR female cable'},
      {id: 'NC5FD-L-1', type: 'partial', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused', notes: '5-pin XLR female panel-mount'},
      {id: 'NC5MXX', type: 'custom', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused.', notes: '5-pin XLR male cable'},
      {id: 'NC5MD-L-1', type: 'custom', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused.', notes: '5-pin XLR male panel-mount'},
      {id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS male connection'},
      {id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS female connection'},
      {id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS male right angle connection'},
      {id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS female right angle connection'},
      {id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS male panel-mount connection'},
      {id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS female panel-mount connection'},
      {id: '2TR_M', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio connection'},
      {id: '2TR_F', type: 'custom', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio connection'},
      {id: '2TR_FL', type: 'custom', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio connection'},
      {id: '2TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio right angle connection'},
      {id: '2TR_F_RA', type: 'custom', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio right angle connection'},
      {id: '2TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio panel-mount connection'},
      {id: '2TR_F_PM', type: 'custom', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio panel-mount connection'},
      {id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS male connection'},
      {id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized.', notes: '1/4" TS female connection'},
      {id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS male right angle connection'},
      {id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS female right angle connection'},
      {id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS male panel-mount connection'},
      {id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS female panel-mount connection'},
      {id: '3TR_M', type: 'direct', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio connection'},
      {id: '3TR_F', type: 'custom', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio connection'},
      {id: '3TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio right angle connection'},
      {id: '3TR_F_RA', type: 'custom', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio right angle connection'},
      {id: '3TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio panel-mount connection'},
      {id: '3TR_F_PM', type: 'custom', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio panel-mount connection'},
      {id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: 'RCA male connection'},
      {id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized. ', notes: 'RCA female connection'},
      {id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: 'RCA male connection'},
      {id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized. ', notes: 'RCA female connection'},
      {id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: 'RCA male connection'},
      {id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized. ', notes: 'RCA female connection'}
    ],
    // Official notation: XLR and Speakon are not compatible (different connector families and signal levels).
    notCompatibleWith: [
      { id: 'NL2MX', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL4MX', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL4FXX-W-S', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'SPK4_M_PM', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL8MX', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL8FC', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'SPK8_M_PM', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'SPK8_M_PM_BAG', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' }
    ],
    notes: 'Used in audio applications. Right-angle design for tight spaces.'
  },

  // XLR Panel Mount Male // -- CORRECTED--
  'NC3MD-L-1': {
    id: 'NC3MD-L-1',
    skuCode: 'XLRMPM',
    type: 'XLR',
    family: 'XLR 3-pin',
    poles: 3,
    gender: 'male',
    mountType: 'panel',
    purpose: 'audio, wye, dmx',
    description: '3-pin XLR Male Panel-Mount',
    image: '/images/nc3md-l-1.jpg',
    wireCompatibility: ["PSM","PSDMX","Zip"],
    compatibleWith: [
      {id: 'NC3FXX', type: 'direct', polesUsed: 3, warning: null, notes: 'Standard balanced connection'},
      {id: 'NC3FRX', type: 'direct', polesUsed: 3, warning: null, notes: 'Standard balanced connection, right-angle'},
      {id: 'NC3FD-L-1', type: 'direct', polesUsed: 3, warning: null, notes: 'Standard balanced connection, panel-mount'},
      {id: 'NC3MXX', type: 'custom', polesUsed: 3, warning: null, notes: 'For use as extension or adapter cable'},
      {id: 'NC3MRX', type: 'custom', polesUsed: 3, warning: null, notes: 'For use as extension or adapter cable, right-angle'},
      {id: 'NC3MD-L-1', type: 'custom', polesUsed: 3, warning: null, notes: 'For use as extension or adapter cable, panel-mount'},
      {id: 'NC5FXX', type: 'partial', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused', notes: '5-pin XLR female cable'},
      {id: 'NC5FD-L-1', type: 'partial', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused', notes: '5-pin XLR female panel-mount'},
      {id: 'NC5MXX', type: 'custom', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused.', notes: '5-pin XLR male cable'},
      {id: 'NC5MD-L-1', type: 'custom', polesUsed: 3, warning: 'Only pins 1-3 are wired; pins 4-5 are unused.', notes: '5-pin XLR male panel-mount'},
      {id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS male connection'},
      {id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS female connection'},
      {id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS male right angle connection'},
      {id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS female right angle connection'},
      {id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS male panel-mount connection'},
      {id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '3.5mm TS female panel-mount connection'},
      {id: '2TR_M', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio connection'},
      {id: '2TR_F', type: 'custom', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio connection'},
      {id: '2TR_FL', type: 'custom', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio connection'},
      {id: '2TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio right angle connection'},
      {id: '2TR_F_RA', type: 'custom', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio right angle connection'},
      {id: '2TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio panel-mount connection'},
      {id: '2TR_F_PM', type: 'custom', polesUsed: 3, warning: null, notes: '3.5mm TRS balanced audio panel-mount connection'},
      {id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS male connection'},
      {id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized.', notes: '1/4" TS female connection'},
      {id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS male right angle connection'},
      {id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS female right angle connection'},
      {id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS male panel-mount connection'},
      {id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: '1/4" TS female panel-mount connection'},
      {id: '3TR_M', type: 'direct', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio connection'},
      {id: '3TR_F', type: 'custom', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio connection'},
      {id: '3TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio right angle connection'},
      {id: '3TR_F_RA', type: 'custom', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio right angle connection'},
      {id: '3TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio panel-mount connection'},
      {id: '3TR_F_PM', type: 'custom', polesUsed: 3, warning: null, notes: '1/4" TRS balanced audio panel-mount connection'},
      {id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: 'RCA male connection'},
      {id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized. ', notes: 'RCA female connection'},
      {id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: 'RCA male connection'},
      {id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized. ', notes: 'RCA female connection'},
      {id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized', notes: 'RCA male connection'},
      {id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but provides unbalanced audio - Only 2 poles utilized. ', notes: 'RCA female connection'}
    ],
    // Official notation: XLR and Speakon are not compatible (different connector families and signal levels).
    notCompatibleWith: [
      { id: 'NL2MX', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL4MX', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL4FXX-W-S', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'SPK4_M_PM', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL8MX', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'NL8FC', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'SPK8_M_PM', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' },
      { id: 'SPK8_M_PM_BAG', reason: 'Not compatible', details: 'XLR and Speakon are not compatible; different connector families and signal levels (line-level vs. speaker-level). Official notation: do not pair.' }
    ],
    notes: 'Used in audio applications. Panel-mount design for equipment integration.'
  },

  // 1/4" TRS Connectors // -- CORRECTED--
  '2TR_M': {
    id: '2TR_M',
    skuCode: '1/4TRSM',
    type: '1/4"',
    family: '1/4" TRS',
    poles: 3,
    gender: 'male',
    mountType: 'cable',
    purpose: 'audio, hybrid',
    description: '1/4" Tip/Ring/Sleeve (TRS) Male',
    image: '/images/1_4_ TRS (ACPS-GN).png',
    wireCompatibility: ["PSI","PSM"], // Zip is not compatible
    compatibleWith: [
      // Direct TRS connections
      { id: '2TR_F', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to cable' },
      { id: '2TR_FL', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to cable' },
      { id: '2TR_M', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to cable' },
      { id: '2TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to right-angle' },
      { id: '2TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to right-angle' },
      { id: '2TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to panel-mount' },
      { id: '2TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to panel-mount' },
      // TS connections (unbalanced)
      { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      // 3.5mm connections (direct)
      { id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      // 3.5mm connections (TRS)
      { id: '3TR_M', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to cable' },
      { id: '3TR_F', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to cable' },
      { id: '3TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to panel-mount' },
      { id: '3TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to panel-mount' },
      { id: '3TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to right-angle' },
      { id: '3TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to right-angle' },
      // RCA connections (unbalanced)
      { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      // XLR connections (unbalanced)
      { id: 'NC3MXX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Custom Wired' },
      { id: 'NC3FXX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Custom Wired' },
      { id: 'NC3MRX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Custom Wired' },
      { id: 'NC3FRX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Custom Wired' },
      { id: 'NC3MD-L-1', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FD-L-1', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC5MXX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Custom Wired; Pins 4-5 unused' },
      { id: 'NC5FXX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Custom Wired; Pins 4-5 unused' },
      { id: 'NC5MRX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Custom Wired; Pins 4-5 unused' },
      { id: 'NC5FRX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Custom Wired; Pins 4-5 unused' },
      // Speaker connections (non-standard)
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL4MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL4FXX-W-S', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL8MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL8FC', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      // Other connections
      { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' },
      { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' }
    ],
    notes: 'Balanced mono audio or stereo audio with ring.'
  },
  // 1/4" TRS Right-Angle Male // -- CORRECTED--
  '2TR_M_RA': {
    id: '2TR_M_RA',
    skuCode: '1/4TRSMRA',
    type: '1/4"',
    family: '1/4" TRS',
    poles: 3,
    gender: 'male',
    mountType: 'rightangle',
    purpose: 'audio, hybrid',
    description: '1/4" Tip/Ring/Sleeve (TRS) Male Right Angle',
    image: '/images/1_4 TRS-RA (ACPS-TN).png',
    wireCompatibility: ["PSI","PSM"], // Zip is not compatible
    compatibleWith: [
      // Direct TRS connections
      { id: '2TR_F', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to cable' },
      { id: '2TR_FL', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to cable' },
      { id: '2TR_M', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to cable' },
      { id: '2TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to right-angle' },
      { id: '2TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to right-angle' },
      { id: '2TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to panel-mount' },
      { id: '2TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to panel-mount' },
      // TS connections (unbalanced)
      { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      // 3.5mm connections (direct)
      { id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      // 3.5mm connections (TRS)
      { id: '3TR_M', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to cable' },
      { id: '3TR_F', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to cable' },
      { id: '3TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to panel-mount' },
      { id: '3TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to panel-mount' },
      { id: '3TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to right-angle' },
      { id: '3TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to right-angle' },
      // RCA connections (unbalanced)
      { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      // XLR connections (unbalanced)
      { id: 'NC3MXX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FXX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3MRX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FRX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FD-L-1', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3MD-L-1', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC5MXX', type: 'unbalanced', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
      { id: 'NC5FXX', type: 'unbalanced', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
      // Speaker connections (non-standard)
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL4MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL4FXX-W-S', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL8MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL8FC', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      // Other connections
      { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' },
      { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' }
    ],
    notes: 'Right-angle TRS for tight spaces. Compatible with all TRS variants (cable, right-angle, panel-mount). Balanced audio, DMX (non-standard).'
  },
  // 1/4" TRS Connectors // -- CORRECTED--
  '2TR_F': {
    id: '2TR_F',
    skuCode: '1/4TRSF',
    type: '1/4"',
    family: '1/4" TRS',
    poles: 3,
    gender: 'female',
    mountType: 'cable',
    purpose: 'audio',
    description: '1/4" Tip/Ring/Sleeve (TRS) Female',
    image: '/images/NYS2203P.png',
    wireCompatibility: ["PSI","PSM"], // Zip is not compatible
    compatibleWith: [
      // Direct TRS connections
      { id: '2TR_M', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to cable' },
      { id: '2TR_F', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to cable' },
      { id: '2TR_FL', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to cable' },
      { id: '2TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to right-angle' },
      { id: '2TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to right-angle' },
      { id: '2TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to panel-mount' },
      { id: '2TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to panel-mount' },
      // TS connections (unbalanced)
      { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      // 3.5mm connections (direct)
      { id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      // 3.5mm connections (TRS)
      { id: '3TR_M', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to cable' },
      { id: '3TR_F', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to cable' },
      { id: '3TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to panel-mount' },
      { id: '3TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to panel-mount' },
      { id: '3TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to right-angle' },
      { id: '3TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to right-angle' },
      // RCA connections (unbalanced)
      { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      // XLR connections (unbalanced)
      { id: 'NC3MXX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FXX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3MRX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FRX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FD-L-1', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3MD-L-1', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC5MXX', type: 'direct', polesUsed: 3, warning: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
      { id: 'NC5FXX', type: 'direct', polesUsed: 3, warning: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
      // Speaker connections (non-standard)
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL4MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL4FXX-W-S', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL8MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL8FC', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      // Other connections
      { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' },
      { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' }
    ],
    notes: 'Balanced mono audio or stereo audio with ring.'
  },
  '2TR_FL': {
    id: '2TR_FL',
    skuCode: '1/4TRSFL',
    type: '1/4"',
    family: '1/4" TRS',
    poles: 3,
    gender: 'female',
    mountType: 'cable',
    purpose: 'audio',
    description: '1/4" Tip/Ring/Sleeve (TRS) Female (Locking)',
    image: '/images/nj3fc6.png',
    wireCompatibility: ["PSI","PSM"], // Zip is not compatible
    compatibleWith: [
      // Direct TRS connections
      { id: '2TR_M', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to cable' },
      { id: '2TR_F', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to cable' },
      { id: '2TR_FL', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to cable' },
      { id: '2TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to right-angle' },
      { id: '2TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to right-angle' },
      { id: '2TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to panel-mount' },
      { id: '2TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to panel-mount' },
      // TS connections (unbalanced)
      { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      // 3.5mm connections (direct)
      { id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      // 3.5mm connections (TRS)
      { id: '3TR_M', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to cable' },
      { id: '3TR_F', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to cable' },
      { id: '3TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to panel-mount' },
      { id: '3TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to panel-mount' },
      { id: '3TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to right-angle' },
      { id: '3TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; cable to right-angle' },
      // RCA connections (unbalanced)
      { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      // XLR connections (unbalanced)
      { id: 'NC3MXX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FXX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3MRX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FRX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FD-L-1', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3MD-L-1', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC5MXX', type: 'direct', polesUsed: 3, warning: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
      { id: 'NC5FXX', type: 'direct', polesUsed: 3, warning: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
      // Speaker connections (non-standard)
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL4MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL4FXX-W-S', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL8MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL8FC', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      // Other connections
      { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' },
      { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' }
    ],
    notes: 'Balanced mono audio or stereo audio with ring.'
  },
  // 1/4" TRS Right-Angle Female // -- CORRECTED--
  '2TR_F_RA': {
    id: '2TR_F_RA',
    skuCode: '1/4TRSFRA',
    type: '1/4"',
    family: '1/4" TRS',
    poles: 3,
    gender: 'female',
    mountType: 'rightangle',
    purpose: 'audio',
    description: '1/4" Tip/Sleeve (TRS) Female Right Angle',
    image: '/images/coming_soon.png',
    wireCompatibility: ["PSI","PSM"], // Zip is not compatible
    compatibleWith: [
      // Direct TRS connections
      { id: '2TR_M', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to cable' },
      { id: '2TR_F', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to cable' },
      { id: '2TR_FL', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to cable' },
      { id: '2TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to right-angle' },
      { id: '2TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to panel-mount' },
      { id: '2TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to panel-mount' },
      // TS connections (unbalanced)
      { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      // 3.5mm connections (direct)
      { id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      // 3.5mm connections (TRS)
      { id: '3TR_M', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to cable' },
      { id: '3TR_F', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to cable' },
      { id: '3TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to panel-mount' },
      { id: '3TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to panel-mount' },
      { id: '3TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to right-angle' },
      { id: '3TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to right-angle' },
      // RCA connections (unbalanced)
      { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      // XLR connections (unbalanced)
      { id: 'NC3MXX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FXX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3MRX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FRX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FD-L-1', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3MD-L-1', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC5MXX', type: 'direct', polesUsed: 3, warning: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
      { id: 'NC5FXX', type: 'direct', polesUsed: 3, warning: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
      // Speaker connections (non-standard)
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL4MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL4FXX-W-S', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL8MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL8FC', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      // Other connections
      { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' },
      { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' }
    ],
    notes: 'Right-angle TRS for tight spaces. Compatible with all TRS variants (cable, right-angle, panel-mount). Balanced audio, DMX (non-standard).'
  },

  // 1/4" TRS Panel-Mount Male // -- CORRECTED--
  // '2TR_M_PM': {
  //   id: '2TR_M_PM',
  //   skuCode: '1/4TRSMPM',
  //   type: '1/4"',
  //   family: '1/4" TRS',
  //   poles: 3,
  //   gender: 'male',
  //   mountType: 'panel',
  //   purpose: 'audio, dmx, wye',
  //   description: '1/4" Tip/Ring/Sleeve (TRS) Male Panel Mount',
  //   image: '/images/coming_soon.png',
  //   wireCompatibility: ["PSI","PSM","Zip"],
  //   compatibleWith: [
  //     // Direct TRS connections
  //     { id: '2TR_F', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to cable' },
  //     { id: '2TR_FL', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to cable' },
  //     { id: '2TR_M', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to cable' },
  //     { id: '2TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to right-angle' },
  //     { id: '2TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to right-angle' },
  //     { id: '2TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to panel-mount' },
  //     // TS connections (unbalanced)
  //     { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
  //     { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
  //     { id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
  //     { id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
  //     { id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
  //     { id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
  //     // 3.5mm connections (direct)
  //     { id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
  //     { id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
  //     { id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
  //     { id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
  //     { id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
  //     { id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
  //     // 3.5mm connections (TRS)
  //     { id: '3TR_M', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to cable' },
  //     { id: '3TR_F', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to cable' },
  //     { id: '3TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to panel-mount' },
  //     { id: '3TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to panel-mount' },
  //     { id: '3TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to right-angle' },
  //     { id: '3TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to right-angle' },
  //     // RCA connections (unbalanced)
  //     { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
  //     { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
  //     { id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
  //     { id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
  //     { id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
  //     { id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
  //     // XLR connections (unbalanced)
  //     { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
  //     { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
  //     { id: 'NC5MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
  //     { id: 'NC5FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
  //     // Speaker connections (non-standard)
  //     { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
  //     { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
  //     { id: 'NL4MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
  //     { id: 'NL4FXX-W-S', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
  //     { id: 'NL8MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
  //     { id: 'NL8FC', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
  //     // Other connections
  //     { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' },
  //     { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' }
  //   ],
  //   notes: 'Panel-mount TRS for equipment. Compatible with all TRS variants (cable, right-angle, panel-mount). Balanced audio, DMX (non-standard).'
  // },
  // 1/4" TRS Panel-Mount Female // -- CORRECTED--
  '2TR_F_PM': {
    id: '2TR_F_PM',
    skuCode: '1/4TRSFPM',
    type: '1/4"',
    family: '1/4" TRS',
    poles: 3,
    gender: 'female',
    mountType: 'panel',
    purpose: 'audio',
    description: '1/4" Tip/Ring/Sleeve (TRS) Female Panel Mount',
    image: '/images/coming_soon.png',
    wireCompatibility: ["PSI","PSM"], // Zip is not compatible
    compatibleWith: [
      // Direct TRS connections
      { id: '2TR_M', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to cable' },
      { id: '2TR_F', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to cable' },
      { id: '2TR_FL', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to cable' },
      { id: '2TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to right-angle' },
      { id: '2TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to right-angle' },
      { id: '2TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to panel-mount' },
      // TS connections (unbalanced)
      { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      // 3.5mm connections (direct)
      { id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      // 3.5mm connections (TRS)
      { id: '3TR_M', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to cable' },
      { id: '3TR_F', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to cable' },
      { id: '3TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to panel-mount' },
      { id: '3TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to panel-mount' },
      { id: '3TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to right-angle' },
      { id: '3TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to right-angle' },
      // RCA connections (unbalanced)
      { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      // XLR connections (unbalanced)
      { id: 'NC3MXX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FXX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3MRX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FRX', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FD-L-1', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3MD-L-1', type: 'direct', polesUsed: 3, warning: null, notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC5MXX', type: 'direct', polesUsed: 3, warning: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
      { id: 'NC5FXX', type: 'direct', polesUsed: 3, warning: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
      // Speaker connections (non-standard)
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL4MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL4FXX-W-S', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL8MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL8FC', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      // Other connections
      { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' },
      { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' }
    ],
    notes: 'Panel-mount TRS for equipment. Compatible with all TRS variants (cable, right-angle, panel-mount). Balanced audio, DMX (non-standard).'
  },

  // 1/4" TS Male // -- CORRECTED--
  '2T_M': {
    id: '2T_M',
    skuCode: '1/4TSM',
    type: '1/4"',
    family: '1/4" TS',
    poles: 2,
    gender: 'male',
    mountType: 'cable',
    purpose: 'audio, wye',
    description: '1/4" Tip/Sleeve (TS) Male',
    image: '/images/1_4 TS (ACPM-GN).png',
    wireCompatibility: ["PSI","PSM","Zip"],
    compatibleWith: [
      // Direct TS connections
      { id: '2T_F', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to cable' },
      { id: '2T_M', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to cable' },
      { id: '2T_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to right-angle' },
      { id: '2T_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to right-angle' },
      { id: '2T_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to panel-mount' },
      { id: '2T_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to panel-mount' },
      // TRS connections (unbalanced)
      { id: '2TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_FL', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      // 3.5mm connections (unbalanced)
      { id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to cable' },
      { id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to cable' },
      { id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to panel-mount' },
      { id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to panel-mount' },
      { id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to right-angle' },
      { id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to right-angle' },
      // 3.5mm connections (TRS)
      { id: '3TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      // RCA connections (unbalanced)
      { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      // XLR connections (unbalanced)
      { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC5MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
      { id: 'NC5FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
      // Speaker connections (non-standard)
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL4MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL4FXX-W-S', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL8MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL8FC', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      // Other connections
      { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' },
      { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' }
    ],
    notes: 'Unbalanced mono audio only. Use 24 AWG shielded single-conductor cable for audio.'
  },
  // 1/4" TS Female // -- CORRECTED--
  '2T_F': {
    id: '2T_F',
    skuCode: '1/4TSF',
    type: '1/4"',
    family: '1/4" TS',
    poles: 2,
    gender: 'female',
    mountType: 'cable',
    purpose: 'audio, wye',
    description: '1/4" Tip/Sleeve (TS) Female',
    image: '/images/TS_1_4inch_female.png',
    wireCompatibility: ["PSI","PSM","Zip"],
    compatibleWith: [
      // Direct TS connections
      { id: '2T_M', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to cable' },
      { id: '2T_F', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to cable' },
      { id: '2T_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to right-angle' },
      { id: '2T_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to right-angle' },
      { id: '2T_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to panel-mount' },
      { id: '2T_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to panel-mount' },
      // TRS connections (unbalanced)
      { id: '2TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_FL', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      // 3.5mm connections (unbalanced)
      { id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to cable' },
      { id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to cable' },
      { id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to panel-mount' },
      { id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to panel-mount' },
      { id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to right-angle' },
      { id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; cable to right-angle' },
      // 3.5mm connections (unbalanced)
      { id: '3TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      // RCA connections (unbalanced)
      { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      // XLR connections (unbalanced)
      { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC5MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
      { id: 'NC5FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
      // Speaker connections (non-standard)
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL4MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL4FXX-W-S', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL8MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL8FC', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      // Other connections
      { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' },
      { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' }
    ],
    notes: 'Unbalanced mono audio only. Use 24 AWG shielded single-conductor cable for audio.'
  },

  // 1/4" TS Right-Angle Male // -- CORRECTED--
  '2T_M_RA': {
    id: '2T_M_RA',
    skuCode: '1/4TSMRA',
    type: '1/4"',
    family: '1/4" TS',
    poles: 2,
    gender: 'male',
    mountType: 'rightangle',
    purpose: 'audio, wye',
    description: '1/4" Tip/Sleeve (TS) Male Right Angle',
    image: '/images/1_4 TS-RA (ACPM-TN).png',
    wireCompatibility: ["PSI","PSM","Zip"],
    compatibleWith: [
      // Direct TS connections
      { id: '2T_F', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to cable' },
      { id: '2T_M', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to cable' },
      { id: '2T_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to right-angle' },
      { id: '2T_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to right-angle' },
      { id: '2T_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to panel-mount' },
      { id: '2T_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to panel-mount' },
      // TRS connections (unbalanced)
      { id: '2TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_FL', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      // 3.5mm connections (unbalanced)
      { id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to cable' },
      { id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to cable' },
      { id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to panel-mount' },
      { id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to panel-mount' },
      { id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to right-angle' },
      { id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to right-angle' },
      // 3.5mm connections (TRS)
      { id: '3TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      // RCA connections (unbalanced)
      { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      // XLR connections (unbalanced)
      { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC5MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
      { id: 'NC5FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
      // Speaker connections (non-standard)
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL4MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL4FXX-W-S', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL8MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL8FC', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      // Other connections
      { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' },
      { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' }
    ],
    notes: 'Right-angle TS for tight spaces. Compatible with all TS variants (cable, right-angle, panel-mount). Unbalanced audio. Noise-prone for long runs.'
  },

  // 1/4" TS Right-Angle Female // -- CORRECTED--
  '2T_F_RA': {
    id: '2T_F_RA',
    skuCode: '1/4TSFRA',
    type: '1/4"',
    family: '1/4" TS',
    poles: 2,
    gender: 'female',
    mountType: 'rightangle',
    purpose: 'audio, wye',
    description: '1/4" Tip/Sleeve (TS) Female Right Angle',
    image: '/images/coming_soon.png',
    wireCompatibility: ["PSI","PSM","Zip"],
    compatibleWith: [
      // Direct TS connections
      { id: '2T_M', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to cable' },
      { id: '2T_F', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to cable' },
      { id: '2T_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to right-angle' },
      { id: '2T_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to right-angle' },
      { id: '2T_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to panel-mount' },
      { id: '2T_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to panel-mount' },
      // TRS connections (unbalanced)
      { id: '2TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_FL', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      // 3.5mm connections (unbalanced)
      { id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to cable' },
      { id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to cable' },
      { id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to panel-mount' },
      { id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to panel-mount' },
      { id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to right-angle' },
      { id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; right-angle to right-angle' },
      // 3.5mm connections (TRS)
      { id: '3TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      // RCA connections (unbalanced)
      { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      // XLR connections (unbalanced)
      { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC5MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
      { id: 'NC5FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
      // Speaker connections (non-standard)
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL4MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL4FXX-W-S', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL8MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL8FC', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      // Other connections
      { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' },
      { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' }
    ],
    notes: 'Right-angle TS for tight spaces. Compatible with all TS variants (cable, right-angle, panel-mount). Unbalanced audio. Noise-prone for long runs.'
  },


  // 1/4" TS Panel-Mount Female // -- CORRECTED--
  '2T_F_PM': {
    id: '2T_F_PM',
    skuCode: '1/4TSFPM',
    type: '1/4"',
    family: '1/4" TS',
    poles: 2,
    gender: 'female',
    mountType: 'panel',
    purpose: 'audio, wye',
    description: '1/4" Tip/Sleeve (TS) Female Panel Mount',
    image: '/images/coming_soon.png',
    wireCompatibility: ["PSI","PSM","Zip"],
    compatibleWith: [
      // Direct TS connections
      { id: '2T_M', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; panel-mount to cable' },
      { id: '2T_F', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; panel-mount to cable' },
      { id: '2T_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; panel-mount to right-angle' },
      { id: '2T_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; panel-mount to right-angle' },
      { id: '2T_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; panel-mount to panel-mount' },
      { id: '2T_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; panel-mount to panel-mount' },
      // TRS connections (unbalanced)
      { id: '2TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_FL', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '2TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      // 3.5mm connections (unbalanced)
      { id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; panel-mount to cable' },
      { id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; panel-mount to cable' },
      { id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; panel-mount to panel-mount' },
      { id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; panel-mount to panel-mount' },
      { id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; panel-mount to right-angle' },
      { id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: null, notes: 'Unbalanced mono audio; panel-mount to right-angle' },
      // 3.5mm connections (TRS)
      { id: '3TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      { id: '3TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve' },
      // RCA connections (unbalanced)
      { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      { id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to center, sleeve to shield' },
      // XLR connections (unbalanced)
      { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC5MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
      { id: 'NC5FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
      // Speaker connections (non-standard)
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL4MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL4FXX-W-S', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL8MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      { id: 'NL8FC', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1' },
      // Other connections
      { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' },
      { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Tip to positive, sleeve to negative' }
    ],
    notes: 'Panel-mount TS for equipment. Compatible with all TS variants (cable, right-angle, panel-mount). Unbalanced audio. Noise-prone for long runs.'
  },

  // RCA Connectors (Comprehensive)
  'RCA_M': {
    id: 'RCA_M',
    skuCode: 'RCAM',
    type: 'RCA',
    family: 'RCA',
    poles: 2,
    gender: 'male',
    mountType: 'cable',
    purpose: 'audio, video',
    description: 'RCA Male Cable Connector (Standard)',
    image: '/images/RCA Male (ACPR-SBK).png',
    wireCompatibility: ["PSI","PSM","Zip"],
    compatibleWith: [
      { id: 'RCA_F', type: 'direct', polesUsed: 2, warning: null, notes: 'Standard unbalanced audio or composite/component video, cable to cable' },
      { id: 'RCA_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, cable to panel-mount' },
      { id: 'RCA_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, cable to right-angle' },
      { id: 'RCA_M', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, cable to cable' },
      { id: 'RCA_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, cable to panel-mount' },
      { id: 'RCA_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, cable to right-angle' },
      // 1/4" and 3.5mm TR 
      { id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      // 1/4" and 3.5mm TRS
      { id: '3TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '3TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleev, ring unused' },
      { id: '2TR_FL', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleev, ring unused' },
      { id: '3TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '3TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleev, ring unused' },
      { id: '3TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '3TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleev, ring unused' },
      //XLR
      { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC5MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pins 4-5 unused' },
      { id: 'NC5FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pins 4-5 unused' },
      //Speakon
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL4MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL4FXX-W-S', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL8MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL8FC', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Center to positive, shield to negative' },
      { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Center to positive, shield to negative' }
    ],
    notes: 'Unbalanced audio (line-level) or composite/component video. Use 24 AWG shielded single-conductor cable for audio, 75-ohm coaxial for video due to unbalanced signal.'
  },

  'RCA_F': {
    id: 'RCA_F',
    skuCode: 'RCAF',
    type: 'RCA',
    family: 'RCA',
    poles: 2,
    gender: 'female',
    mountType: 'cable',
    purpose: 'audio, video',
    description: 'RCA Female Cable Connector (Standard)',
    image: '/images/coming_soon.png',
    wireCompatibility: ["PSI","PSM","Zip"],
    compatibleWith: [
      { id: 'RCA_M', type: 'direct', polesUsed: 2, warning: null, notes: 'Standard unbalanced audio or composite/component video, cable to cable' },
      { id: 'RCA_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, cable to panel-mount' },
      { id: 'RCA_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, cable to right-angle' },
      { id: 'RCA_F', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, cable to cable' },
      { id: 'RCA_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, cable to panel-mount' },
      { id: 'RCA_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, cable to right-angle' },
      // 1/4" and 3.5mm TR 
      { id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      // 1/4" and 3.5mm TRS
      { id: '3TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '3TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleev, ring unused' },
      { id: '2TR_FL', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleev, ring unused' },
      { id: '3TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '3TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleev, ring unused' },
      { id: '3TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '3TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleev, ring unused' },
      //XLR
      { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC5MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pins 4-5 unused' },
      { id: 'NC5FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pins 4-5 unused' },
      //Speakon
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL4MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL4FXX-W-S', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL8MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL8FC', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Center to positive, shield to negative' },
      { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Center to positive, shield to negative' }
    ],
    notes: 'Unbalanced audio (line-level) or composite/component video. Use 24 AWG shielded single-conductor cable for audio, 75-ohm coaxial for video due to unbalanced signal.'
  },

  // RCA Right-Angle Variants
  'RCA_M_RA': {
    id: 'RCA_M_RA',
    skuCode: 'RCAMRA',
    type: 'RCA',
    family: 'RCA',
    poles: 2,
    gender: 'male',
    mountType: 'rightangle',
    purpose: 'audio, video',
    description: 'RCA Male Right-Angle',
    image: '/images/coming_soon.png',
    wireCompatibility: ["PSI","PSM","Zip"],
    compatibleWith: [
      { id: 'RCA_F', type: 'direct', polesUsed: 2, warning: null, notes: 'Standard unbalanced audio or video, right-angle to cable' },
      { id: 'RCA_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, right-angle to panel-mount' },
      { id: 'RCA_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, right-angle to right-angle' },
      { id: 'RCA_M', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, right-angle to cable' },
      { id: 'RCA_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, right-angle to panel-mount' },
      { id: 'RCA_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, right-angle to right-angle' },
      // 1/4" and 3.5mm TR 
      { id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      // 1/4" and 3.5mm TRS
      { id: '3TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '3TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleev, ring unused' },
      { id: '2TR_FL', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleev, ring unused' },
      { id: '3TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '3TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleev, ring unused' },
      { id: '3TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '3TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleev, ring unused' },
      //XLR
      { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC5MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pins 4-5 unused' },
      { id: 'NC5FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pins 4-5 unused' },
      //Speakon
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL4MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL4FXX-W-S', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL8MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL8FC', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Center to positive, shield to negative' },
      { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Center to positive, shield to negative' }
    ],
    notes: 'Unbalanced audio (line-level) or composite/component video. Use 24 AWG shielded single-conductor cable for audio, 75-ohm coaxial for video. Limited right-angle availability (e.g., Rean NYS373).'
  },

  'RCA_F_RA': {
    id: 'RCA_F_RA',
    skuCode: 'RCAFRA',
    type: 'RCA',
    family: 'RCA',
    poles: 2,
    gender: 'female',
    mountType: 'rightangle',
    purpose: 'audio, video',
    description: 'RCA Female Right-Angle',
    image: '/images/coming_soon.png',
    wireCompatibility: ["PSI","PSM","Zip"],
    compatibleWith: [
      { id: 'RCA_M', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, right-angle to cable' },
      { id: 'RCA_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, right-angle to panel-mount' },
      { id: 'RCA_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, right-angle to right-angle' },
      { id: 'RCA_F', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, right-angle to cable' },
      { id: 'RCA_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, right-angle to panel-mount' },
      { id: 'RCA_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, right-angle to right-angle' },
      // 1/4" and 3.5mm TR 
      { id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      // 1/4" and 3.5mm TRS
      { id: '3TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '3TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleev, ring unused' },
      { id: '2TR_FL', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleev, ring unused' },
      { id: '3TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '3TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleev, ring unused' },
      { id: '3TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '3TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleev, ring unused' },
      //XLR
      { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC5MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pins 4-5 unused' },
      { id: 'NC5FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pins 4-5 unused' },
      //Speakon
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL4MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL4FXX-W-S', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL8MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL8FC', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Center to positive, shield to negative' },
      { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Center to positive, shield to negative' }
    ],
    notes: 'Unbalanced audio (line-level) or composite/component video. Use 24 AWG shielded single-conductor cable for audio, 75-ohm coaxial for video. Limited right-angle availability.'
  },

  'RCA_F_PM': {
    id: 'RCA_F_PM',
    skuCode: 'RCAFPM',
    type: 'RCA',
    family: 'RCA',
    poles: 2,
    gender: 'female',
    mountType: 'panel',
    purpose: 'audio, video',
    description: 'RCA Female Panel-Mount',
    image: '/images/coming_soon.png',
    wireCompatibility: ["PSI","PSM","Zip"],
    compatibleWith: [
      { id: 'RCA_M', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, panel-mount to cable' },
      { id: 'RCA_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, panel-mount to panel-mount' },
      { id: 'RCA_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, panel-mount to right-angle' },
      { id: 'RCA_F', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, panel-mount to cable' },
      { id: 'RCA_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, panel-mount to panel-mount' },
      { id: 'RCA_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: 'Unbalanced audio or video, panel-mount to right-angle' },
      // 1/4" and 3.5mm TR 
      { id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      { id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve' },
      // 1/4" and 3.5mm TRS
      { id: '3TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '3TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleev, ring unused' },
      { id: '2TR_FL', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleev, ring unused' },
      { id: '3TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '3TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleev, ring unused' },
      { id: '3TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '3TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleeve, ring unused' },
      { id: '2TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; noise-prone for long runs', notes: 'Audio: Center to tip, shield to sleev, ring unused' },
      //XLR
      { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC5MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pins 4-5 unused' },
      { id: 'NC5FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pins 4-5 unused' },
      //Speakon
      { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pin 3 unused or grounded' },
      { id: 'NC5MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pins 4-5 unused' },
      { id: 'NC5FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; Pins 4-5 unused', notes: 'Audio: Center to Pin 2, shield to Pin 1, Pins 4-5 unused' },
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker)', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL4MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL4FXX-W-S', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2 unused', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL8MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'NL8FC', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Center to +1, shield to -1' },
      { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Center to positive, shield to negative' },
      { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: Center to positive, shield to negative' }
    ],
    notes: 'Unbalanced audio (line-level) or composite/component video. Use 24 AWG shielded single-conductor cable for audio, 75-ohm coaxial for video.'
  },
  
  'JMB-025': {  //// GREEN CHECKBOX /// VERIFYY
    id: 'JMB-025',
    skuCode: '1/4TSM',
    type: '1/4"',
    family: '1/4" Speaker',
    poles: 2,
    gender: 'male',
    mountType: 'cable',
    purpose: 'audio',
    description: '1/4" Speaker Male',
    image: '/images/quarter inch connector2.png',
    wireCompatibility: ["PSS12","PSS14","PSS16"],
    compatibleWith: [
      { id: 'NL2FXX-W-S', type: 'direct', polesUsed: 2, warning: null, notes: 'Cable to cable for single speaker circuit' },
      { id: 'JMB-025', type: 'direct', polesUsed: 2, warning: null, notes: 'Cable to cable for single speaker circuit' },
      ],
    notes: 'Primarily for single-channel speaker audio. Use 16-12 AWG cable for audio.'
  },
  
  'NL2FXX-W-S': {  //// GREEN CHECKBOX /// VERIFYY
    id: 'NL2FXX-W-S',
    skuCode: 'NL2F',
    type: 'Speakon',
    family: 'Speakon',
    poles: 2,
    gender: 'female',
    mountType: 'cable', 
    purpose: 'audio',
    description: 'Neutrik Speakon 2-Pole Female',
    image: '/images/NL2FXX-W-S.png',
    wireCompatibility: ["PSS12","PSS14","PSS16"],
    compatibleWith: [
      { id: 'NL2FXX-W-S', type: 'direct', polesUsed: 2, warning: null, notes: 'Cable to cable for single speaker circuit' },
      { id: 'NL4MPXX', type: 'direct', polesUsed: 2, warning: null, notes: 'Cable to panel-mount for single speaker circuit' },
      { id: 'JMB-025', type: 'direct', polesUsed: 2, warning: null, notes: 'Cable to cable for single speaker circuit' },
      ],
    notes: 'Primarily for single-channel speaker audio. Use 14-12 AWG cable for audio.'
  },
  
  'NL4FXX-W-S': {  //// GREEN CHECKBOX /// VERIFYY
    id: 'NL4FXX-W-S',
    skuCode: 'NL4F',
    type: 'Speakon',
    family: 'Speakon',
    poles: 4,
    gender: 'female',
    mountType: 'cable',
    purpose: 'audio',
    description: 'Neutrik Speakon 4-Pole Female',
    image: '/images/NL4FXX-W-S.png',
    wireCompatibility: ["PSS12","PSS14","PSS16"],
    compatibleWith: [
      { id: 'NL4MPXX', type: 'direct', polesUsed: 4, warning: null, notes: 'Standard balanced audio for two speaker circuits (bi-amping), cable to panel-mount' },
      { id: 'NL4FXX-W-S', type: 'direct', polesUsed: 4, warning: null, notes: 'Cable to cable extension for two speaker circuits or hybrid power/DMX' },
      ],
    notes: 'Balanced audio for two speaker circuits (bi-amping) or hybrid power/DMX. Use 12 AWG 4-conductor cable for audio, 2.5 mm² + 0.22 mm² for hybrid. Non-standard, use +2/-2/ground with 110-ohm cable.'
  },
  
  'NL4MPXX': {  //// GREEN CHECKBOX /// VERIFYY
    id: 'NL4MPXX',
    skuCode: 'NL4FPM',
    type: 'Speakon',
    family: 'Speakon',
    poles: 4,
    gender: 'female',
    mountType: 'panel',
    purpose: 'audio',
    description: 'Neutrik Speakon 4-Pole Female Panel-Mount',
    image: '/images/Speakon_4pole_female_panel.png',
    wireCompatibility: ["PSS14"],
    compatibleWith: [
      { id: 'NL2FXX-W-S', type: 'direct', polesUsed: 2, warning: null, notes: 'Cable to panel-mount for single speaker circuit' },
      { id: 'NL4FXX-W-S', type: 'direct', polesUsed: 4, warning: null, notes: 'Standard balanced audio for two speaker circuits, panel to cable' },
      { id: 'NL4MPXX', type: 'direct', polesUsed: 4, warning: null, notes: 'Panel to panel connection for two speaker circuits or hybrid power/DMX' },
      { id: 'NL2FXX-W-S', type: 'partial', polesUsed: 2, warning: 'Only +1/-1 used; +2/-2 unused', notes: 'Connects to 2-pole cable connector, single circuit audio' },
      ],
    notes: 'Balanced audio for two speaker circuits or hybrid power/DMX. Use 12 AWG 4-conductor cable for audio, 2.5 mm² + 0.22 mm² for hybrid. Non-standard.'
  },
  
  'NL8FC': {   //// GREEN CHECKBOX /// VERIFYY
    id: 'NL8FC',
    skuCode: 'NL8F',
    type: 'Speakon',
    family: 'Speakon',
    poles: 8,
    gender: 'female',
    mountType: 'cable',
    purpose: 'audio',
    description: 'Neutrik Speakon 8-Pole Female',
    image: '/images/NL8FC.jpg',
    wireCompatibility: ["PSS12","PSS14"],
    compatibleWith: [
      { id: 'NL8FC', type: 'direct', polesUsed: 8, warning: null, notes: 'Cable to cable extension for four speaker circuits or complex hybrid' },
      { id: 'NL8MPRXX', type: 'direct', polesUsed: 8, warning: null, notes: 'Standard balanced audio for four speaker circuits, female to male panel-mount' }
    ],
    notes: 'Balanced audio for four speaker circuits or complex hybrid power/DMX. Use 12 AWG 8-conductor cable for audio, 2.5 mm² + 0.22 mm² for hybrid. Non-standard, use +2/-2/ground or higher poles for multiple DMX signals.'
  },
  
  'NL8MPRXX': {    //// GREEN CHECKBOX /// VERIFYY
    id: 'NL8MPRXX',
    skuCode: 'NL8MPM',
    type: 'Speakon',
    family: 'Speakon',
    poles: 8,
    gender: 'male',
    mountType: 'panel',
    purpose: 'audio',
    description: 'Neutrik Speakon 8-Pole Male Panel-Mount',
    image: '/images/NL8MPRXX.jpg',
    wireCompatibility: ["PSS12"],
    compatibleWith: [
      { id: 'NL8FC', type: 'direct', polesUsed: 8, warning: null, notes: 'Cable to cable extension for four speaker circuits or complex hybrid' },
      { id: 'NL8MPRXX', type: 'direct', polesUsed: 8, warning: null, notes: 'Standard balanced audio for four speaker circuits, female to male panel-mount' }
    ],
    notes: 'Balanced audio for four speaker circuits or complex hybrid power/DMX. Use 12 AWG 8-conductor cable for audio, 2.5 mm² + 0.22 mm² for hybrid. Non-standard.'
  },
  
   // 3.5mm TRS/TS Connectors
  // 3.5mm TRS Male Cable-Mount
  // '3TR_M': {
  //   id: '3TR_M',
  //   skuCode: '3.5TRSM',
  //   type: '3.5mm',
  //   family: '3.5mm TRS',
  //   poles: 3,
  //   gender: 'male',
  //   mountType: 'cable',
  //   purpose: 'audio, wye',
  //   description: '3.5mm Tip/Ring/Sleeve (TRS) Male',
  //   image: '/images/TRS_3_5mm_male.png',
  //   wireCompatibility: ["PSI","PSM","Zip"],
  //   compatibleWith: [
  //     // 3.5mm TRS connections (balanced)
  //     { id: '3TR_F', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 3.5mm TRS connection - Balanced audio' },
  //     { id: '3TR_M', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 3.5mm TRS connection - Balanced audio' },
  //     { id: '3TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 3.5mm TRS connection - Balanced audio' },
  //     { id: '3TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 3.5mm TRS connection - Balanced audio' },
  //     { id: '3TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 3.5mm TRS connection - Balanced audio' },
  //     { id: '3TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 3.5mm TRS connection - Balanced audio' },
  //     // 1/4" TRS connections (balanced)
  //     { id: '2TR_M', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 1/4" TRS connection - Balanced audio' },
  //     { id: '2TR_F', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 1/4" TRS connection - Balanced audio' },
  //     { id: '2TR_FL', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 1/4" TRS connection - Balanced audio' },
  //     { id: '2TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 1/4" TRS right-angle connection - Balanced audio' },
  //     { id: '2TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 1/4" TRS right-angle connection - Balanced audio' },
  //     { id: '2TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 1/4" TRS panel-mount connection - Balanced audio' },
  //     { id: '2TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 1/4" TRS panel-mount connection - Balanced audio' },
  //     // Unbalanced connections (TS variants)
  //     { id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '1/4" TS to 3.5mm TRS connection' },
  //     { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '1/4" TS to 3.5mm TRS connection' },
  //     { id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '1/4" TS right-angle to 3.5mm TRS connection' },
  //     { id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '1/4" TS right-angle to 3.5mm TRS connection' },
  //     { id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '1/4" TS panel-mount to 3.5mm TRS connection' },
  //     { id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '1/4" TS panel-mount to 3.5mm TRS connection' },
  //     // RCA connections (unbalanced)
  //     { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: 'RCA to 3.5mm TRS connection' },
  //     { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: 'RCA to 3.5mm TRS connection' },
  //     { id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: 'RCA right-angle to 3.5mm TRS connection' },
  //     { id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: 'RCA right-angle to 3.5mm TRS connection' },
  //     { id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: 'RCA panel-mount to 3.5mm TRS connection' },
  //     { id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: 'RCA panel-mount to 3.5mm TRS connection' },
  //     // XLR connections (balanced)
  //     { id: 'NC3FXX', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to XLR connection - Balanced audio' },
  //     { id: 'NC3MXX', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to XLR connection - Balanced audio' },
  //     { id: 'NC3FRX', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to XLR right-angle connection - Balanced audio' },
  //     { id: 'NC3MRX', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to XLR right-angle connection - Balanced audio' },
  //     { id: 'NC3FD-L-1', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to XLR panel-mount connection - Balanced audio' },
  //     { id: 'NC3MD-L-1', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to XLR panel-mount connection - Balanced audio' },
  //     // Speakon connections (partial - hybrid/DMX)
  //     { id: 'NL2MX', type: 'partial', polesUsed: 3, warning: 'Non-standard; pin mapping required', notes: 'Hybrid' },
  //     { id: 'NL2MX', type: 'partial', polesUsed: 3, warning: 'Non-standard; pin mapping required', notes: 'Hybrid' },
  //     { id: 'NL4FXX-W-S', type: 'partial', polesUsed: 3, warning: 'Non-standard; pin mapping required', notes: 'Hybrid' },
  //     { id: 'NL4MX', type: 'partial', polesUsed: 3, warning: 'Non-standard; pin mapping required', notes: 'Hybrid' }
  //   ],
  //   notes: '3.5mm TRS for consumer audio devices. Balanced audio, DMX (non-standard). Pin 1 to sleeve, Pin 2 to tip, Pin 3 to ring.'
  // },
  // // 3.5mm TRS Female Cable-Mount
  // '3TR_F': {
  //   id: '3TR_F',
  //   skuCode: '3.5TRSF',
  //   type: '3.5mm',
  //   family: '3.5mm TRS',
  //   poles: 3,
  //   gender: 'female',
  //   mountType: 'cable',
  //   purpose: 'audio, wye',
  //   description: '3.5mm Tip/Ring/Sleeve (TRS) Female',
  //   image: '/images/TRS_3_5mm_female.png',
  //   wireCompatibility: ["PSI","PSM","Zip"],
  //   compatibleWith: [
  //     // 3.5mm TRS connections (balanced)
  //     { id: '3TR_M', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 3.5mm TRS connection - Balanced audio' },
  //     { id: '3TR_F', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 3.5mm TRS connection - Balanced audio' },
  //     { id: '3TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 3.5mm TRS connection - Balanced audio' },
  //     { id: '3TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 3.5mm TRS connection - Balanced audio' },
  //     { id: '3TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 3.5mm TRS connection - Balanced audio' },
  //     { id: '3TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 3.5mm TRS connection - Balanced audio' },
  //     // 1/4" TRS connections (balanced)
  //     { id: '2TR_M', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 1/4" TRS connection - Balanced audio' },
  //     { id: '2TR_F', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 1/4" TRS connection - Balanced audio' },
  //     { id: '2TR_FL', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 1/4" TRS connection - Balanced audio' },
  //     { id: '2TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 1/4" TRS right-angle connection - Balanced audio' },
  //     { id: '2TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 1/4" TRS right-angle connection - Balanced audio' },
  //     { id: '2TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 1/4" TRS panel-mount connection - Balanced audio' },
  //     { id: '2TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to 1/4" TRS panel-mount connection - Balanced audio' },
  //     // Unbalanced connections (TS variants)
  //     { id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '1/4" TS to 3.5mm TRS connection' },
  //     { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '1/4" TS to 3.5mm TRS connection' },
  //     { id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '1/4" TS right-angle to 3.5mm TRS connection' },
  //     { id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '1/4" TS right-angle to 3.5mm TRS connection' },
  //     { id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '1/4" TS panel-mount to 3.5mm TRS connection' },
  //     { id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '1/4" TS panel-mount to 3.5mm TRS connection' },
  //     // RCA connections (unbalanced)
  //     { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: 'RCA to 3.5mm TRS connection' },
  //     { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: 'RCA to 3.5mm TRS connection' },
  //     { id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: 'RCA right-angle to 3.5mm TRS connection' },
  //     { id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: 'RCA right-angle to 3.5mm TRS connection' },
  //     { id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: 'RCA panel-mount to 3.5mm TRS connection' },
  //     { id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: 'RCA panel-mount to 3.5mm TRS connection' },
  //     // XLR connections (balanced)
  //     { id: 'NC3FXX', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to XLR connection - Balanced audio' },
  //     { id: 'NC3MXX', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to XLR connection - Balanced audio' },
  //     { id: 'NC3FRX', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to XLR right-angle connection - Balanced audio' },
  //     { id: 'NC3MRX', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to XLR right-angle connection - Balanced audio' },
  //     { id: 'NC3FD-L-1', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to XLR panel-mount connection - Balanced audio' },
  //     { id: 'NC3MD-L-1', type: 'direct', polesUsed: 3, warning: null, notes: '3.5mm TRS to XLR panel-mount connection - Balanced audio' },
  //     // Speakon connections (partial - hybrid/DMX)
  //     { id: 'NL2MX', type: 'partial', polesUsed: 3, warning: 'Non-standard; pin mapping required', notes: 'Hybrid' },
  //     { id: 'NL2MX', type: 'partial', polesUsed: 3, warning: 'Non-standard; pin mapping required', notes: 'Hybrid' },
  //     { id: 'NL4FXX-W-S', type: 'partial', polesUsed: 3, warning: 'Non-standard; pin mapping required', notes: 'Hybrid' },
  //     { id: 'NL4MX', type: 'partial', polesUsed: 3, warning: 'Non-standard; pin mapping required', notes: 'Hybrid' }
  //   ],
  //   notes: '3.5mm TRS for consumer audio devices. Balanced audio, DMX (non-standard). Pin 1 to sleeve, Pin 2 to tip, Pin 3 to ring. Use 110-ohm cable for DMX.'
  // },
      // 3.5mm TS Male Cable-Mount // -- CORRECTED-- -  TEMPORARILY REMOVED
  // '3T_M': {
  //   id: '3T_M',
  //   skuCode: '3.5TSM',
  //   type: '3.5mm',
  //   family: '3.5mm TS',
  //   poles: 2,
  //   gender: 'male',
  //   mountType: 'cable',
  //   purpose: 'audio, wye',
  //   description: '3.5mm Tip/Sleeve (TS) Male',
  //   image: '/images/TS_3_5mm_male.png',
  //   wireCompatibility: ["PSI","PSM","Zip"],
  //   compatibleWith: [
  //     // 3.5mm TS connections (unbalanced)
  //     { id: '3T_F', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_M', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     // 1/4" TS connections (unbalanced)
  //     { id: '2T_M', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS connection - Unbalanced audio' },
  //     { id: '2T_F', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS connection - Unbalanced audio' },
  //     { id: '2T_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS right-angle connection - Unbalanced audio' },
  //     { id: '2T_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS right-angle connection - Unbalanced audio' },
  //     { id: '2T_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS panel-mount connection - Unbalanced audio' },
  //     { id: '2T_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS panel-mount connection - Unbalanced audio' },
  //     // TRS connections (unbalanced with warning)
  //     { id: '3TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '2TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS connection' },
  //     { id: '2TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS connection' },
  //     { id: '2TR_FL', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS connection' },
  //     { id: '2TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS right-angle connection' },
  //     { id: '2TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS right-angle connection' },
  //     { id: '2TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS panel-mount connection' },
  //     { id: '2TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS panel-mount connection' },
  //     // RCA connections (unbalanced)
  //     { id: 'RCA_M', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA connection - Unbalanced audio' },
  //     { id: 'RCA_F', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA connection - Unbalanced audio' },
  //     { id: 'RCA_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA right-angle connection - Unbalanced audio' },
  //     { id: 'RCA_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA right-angle connection - Unbalanced audio' },
  //     { id: 'RCA_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA panel-mount connection - Unbalanced audio' },
  //     { id: 'RCA_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA panel-mount connection - Unbalanced audio' },
  //     // XLR connections (unbalanced with warning)
  //     { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR connection' },
  //     { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR connection' },
  //     { id: 'NC3FRX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR right-angle connection' },
  //     { id: 'NC3MRX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR right-angle connection' },
  //     { id: 'NC3FD-L-1', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR panel-mount connection' },
  //     { id: 'NC3MD-L-1', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR panel-mount connection' },
  //     // Speakon connections (partial - hybrid/DMX)
  //     { id: 'NL2MX', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' },
  //     { id: 'NL2MX', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' },
  //     { id: 'NL4FXX-W-S', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' },
  //     { id: 'NL4MX', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' }
  //   ],
  //   notes: '3.5mm TS for consumer audio devices. Unbalanced audio. Pin 2 to tip, Pin 1 to sleeve, Pin 3 unused or grounded. Noise-prone for long runs.'
  // },
    // // 3.5mm TS Female Cable-Mount // -- CORRECTED--
  // '3T_F': {
  //   id: '3T_F',
  //   skuCode: '3.5TSF',
  //   type: '3.5mm',
  //   family: '3.5mm TS',
  //   poles: 2,
  //   gender: 'female',
  //   mountType: 'cable',
  //   purpose: 'audio, wye',
  //   description: '3.5mm Tip/Sleeve (TS) Female',
  //   image: '/images/TS_3_5mm_female.png',
  //   wireCompatibility: ["PSI","PSM","Zip"],
  //   compatibleWith: [
  //     // 3.5mm TS connections (unbalanced)
  //     { id: '3T_F', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_M', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     // 1/4" TS connections (unbalanced)
  //     { id: '2T_M', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS connection - Unbalanced audio' },
  //     { id: '2T_F', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS connection - Unbalanced audio' },
  //     { id: '2T_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS right-angle connection - Unbalanced audio' },
  //     // { id: '2T_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS right-angle connection - Unbalanced audio' },
  //     { id: '2T_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS panel-mount connection - Unbalanced audio' },
  //     { id: '2T_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS panel-mount connection - Unbalanced audio' },
  //     // TRS connections (unbalanced with warning)
  //     { id: '3TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '2TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS connection' },
  //     { id: '2TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS connection' },
  //     { id: '2TR_FL', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS connection' },
  //     { id: '2TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS right-angle connection' },
  //     { id: '2TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS right-angle connection' },
  //     { id: '2TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS panel-mount connection' },
  //     { id: '2TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS panel-mount connection' },
  //     // RCA connections (unbalanced)
  //     { id: 'RCA_M', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA connection - Unbalanced audio' },
  //     { id: 'RCA_F', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA connection - Unbalanced audio' },
  //     { id: 'RCA_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA right-angle connection - Unbalanced audio' },
  //     { id: 'RCA_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA right-angle connection - Unbalanced audio' },
  //     { id: 'RCA_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA panel-mount connection - Unbalanced audio' },
  //     { id: 'RCA_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA panel-mount connection - Unbalanced audio' },
  //     // XLR connections (unbalanced with warning)
  //     { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR connection' },
  //     { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR connection' },
  //     { id: 'NC3FRX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR right-angle connection' },
  //     { id: 'NC3MRX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR right-angle connection' },
  //     { id: 'NC3FD-L-1', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR panel-mount connection' },
  //     { id: 'NC3MD-L-1', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR panel-mount connection' },
  //     // Speakon connections (partial - hybrid/DMX)
  //     { id: 'NL2MX', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' },
  //     { id: 'NL2MX', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' },
  //     { id: 'NL4FXX-W-S', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' },
  //     { id: 'NL4MX', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' }
  //   ],
  //   notes: '3.5mm TS for consumer audio devices. Unbalanced audio. Pin 2 to tip, Pin 1 to sleeve, Pin 3 unused or grounded. Noise-prone for long runs.'
  // },
  
// XLR 5-Pin Connectors
'NC5FXX': {
    id: 'NC5FXX',
    skuCode: 'XLRF5',
    type: 'XLR',
    family: 'XLR 5-pin',
    poles: 5,
    gender: 'female',
    mountType: 'cable',
    purpose: 'dmx',
    description: 'XLR 5-Pin Female (DMX)',
    image: '/images/nc5fxx.png',
    wireCompatibility: ["PSDMX"], // Zip is not compatible
    compatibleWith: [
      // XLR 5-pin to XLR 5-pin (full compatibility)
      { id: 'NC5MXX', type: 'direct', polesUsed: 5, warning: null, notes: 'Full 5-pin DMX/stereo audio connection' },
      { id: 'NC5FRX', type: 'direct', polesUsed: 5, warning: null, notes: 'Cable to right-angle 5-pin connection' },
      { id: 'NC5FXX', type: 'direct', polesUsed: 5, warning: null, notes: 'Full 5-pin DMX/stereo audio connection' },
      { id: 'NC5MRX', type: 'direct', polesUsed: 5, warning: null, notes: 'Cable to right-angle 5-pin connection' },
      { id: 'NC5FD-L-1', type: 'direct', polesUsed: 5, warning: null, notes: 'Cable to panel-mount 5-pin connection' },
      { id: 'NC5MD-L-1', type: 'direct', polesUsed: 5, warning: null, notes: 'Cable to panel-mount 5-pin connection' },
      // XLR 5-pin to XLR 3-pin (partial compatibility)
      { id: 'NC3FXX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'DMX/hybrid: Maps Pins 1-3 for DMX/audio' },
      { id: 'NC3MXX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'DMX/hybrid: Maps Pins 1-3 for DMX/audio' },
      { id: 'NC3FRX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'DMX/hybrid: Right-angle 3-pin' },
      { id: 'NC3MRX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'DMX/hybrid: Right-angle 3-pin' },
      { id: 'NC3FD-L-1', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'DMX/hybrid: Panel-mount 3-pin' },
      { id: 'NC3MD-L-1', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'DMX/hybrid: Panel-mount 3-pin' }
    ],
    notes: '5-pin XLR for DMX, stereo/dual-channel audio, AES/EBU. Use 110-ohm cable for DMX/AES/EBU. Pins 1-5 used for stereo (2/3, 4/5) or DMX (1-3, 4/5 optional).'
  },
  
  'NC5MXX': {
    id: 'NC5MXX',
    skuCode: 'XLRM5',
    type: 'XLR',
    family: 'XLR 5-pin',
    poles: 5,
    gender: 'male',
    mountType: 'cable',
    purpose: 'dmx',
    description: 'XLR 5-Pin Male (DMX)',
    image: '/images/nc5mxx.png',
    wireCompatibility: ["PSDMX"], // Zip is not compatible
    compatibleWith: [
      // XLR 5-pin to XLR 5-pin (full compatibility)
      { id: 'NC5FXX', type: 'direct', polesUsed: 5, warning: null, notes: 'Full 5-pin DMX/stereo audio connection' },
      { id: 'NC5FRX', type: 'direct', polesUsed: 5, warning: null, notes: 'Cable to right-angle 5-pin connection' },
      { id: 'NC5MXX', type: 'direct', polesUsed: 5, warning: null, notes: 'Full 5-pin DMX/stereo audio connection' },
      { id: 'NC5MRX', type: 'direct', polesUsed: 5, warning: null, notes: 'Cable to right-angle 5-pin connection' },
      { id: 'NC5FD-L-1', type: 'direct', polesUsed: 5, warning: null, notes: 'Cable to panel-mount 5-pin connection' },
      { id: 'NC5MD-L-1', type: 'direct', polesUsed: 5, warning: null, notes: 'Cable to panel-mount 5-pin connection' },
      // XLR 5-pin to XLR 3-pin (partial compatibility)
      { id: 'NC3FXX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'DMX/hybrid: Maps Pins 1-3 for DMX/audio' },
      { id: 'NC3MXX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'DMX/hybrid: Maps Pins 1-3 for DMX/audio' },
      { id: 'NC3FRX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'DMX/hybrid: Right-angle 3-pin' },
      { id: 'NC3MRX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'DMX/hybrid: Right-angle 3-pin' },
      { id: 'NC3FD-L-1', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'DMX/hybrid: Panel-mount 3-pin' },
      { id: 'NC3MD-L-1', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'DMX/hybrid: Panel-mount 3-pin' },
      ],
    notes: '5-pin XLR for DMX, stereo/dual-channel audio, AES/EBU. Use 110-ohm cable for DMX/AES/EBU. Pins 1-5 used for stereo (2/3, 4/5) or DMX (1-3, 4/5 optional).'
  },
// XLR 5-Pin Right Angle and Panel Mount variants (defined after base connectors)
'NC5MRX': { 
  id: 'NC5MRX',
  type: 'XLR',
  family: 'XLR 5-pin',
  poles: 5,
  gender: 'male',
  mountType: 'rightangle',
  purpose: 'dmx',
  description: 'Neutrik XLR 5-Pin Male Right Angle',
  image: '/images/coming_soon.png',
  wireCompatibility: ["PSDMX"], // Zip is not compatible
  compatibleWith: [
    { id: 'NC5FXX', type: 'direct', polesUsed: 5, warning: null, notes: 'Standard DMX/hybrid connection' },
    { id: 'NC5MXX', type: 'direct', polesUsed: 5, warning: null, notes: 'Standard DMX/hybrid connection' },
    { id: 'NC5MRX', type: 'direct', polesUsed: 5, warning: null, notes: 'Right-Angle variant' },
    { id: 'NC5FRX', type: 'direct', polesUsed: 5, warning: null, notes: 'Right-Angle variant' },
    { id: 'NC5FD-L-1', type: 'direct', polesUsed: 5, warning: null, notes: 'Panel-mount variant' },
    { id: 'NC5MD-L-1', type: 'direct', polesUsed: 5, warning: null, notes: 'Panel-mount variant' },
    { id: 'NC3FXX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'Maps Pins 1-3 for DMX/audio' },
    { id: 'NC3FRX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'Right-angle 3-pin' },
    { id: 'NC3MXX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'Maps Pins 1-3 for DMX/audio' },
    { id: 'NC3MRX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'Right-angle 3-pin' },
    { id: 'NC3FD-L-1', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'Panel-mount 3-pin' },
    { id: 'NC3MD-L-1', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'Panel-mount 3-pin' },
  ],
  notes: 'DMX/hybrid only. Pins 1-3 for DMX/audio, 4-5 for second channel or unused. Use 110-ohm cable for DMX.'
},
'NC5FRX': { 
  id: 'NC5FRX',
  type: 'XLR',
  family: 'XLR 5-pin',
  poles: 5,
  gender: 'female',
  mountType: 'rightangle',
  purpose: 'dmx',
  description: 'Neutrik XLR 5-Pin Female Right Angle',
  image: '/images/coming_soon.png',
  wireCompatibility: ["PSDMX"], // Zip is not compatible
  compatibleWith: [
    { id: 'NC5FXX', type: 'direct', polesUsed: 5, warning: null, notes: 'Standard DMX/hybrid connection' },
    { id: 'NC5MXX', type: 'direct', polesUsed: 5, warning: null, notes: 'Standard DMX/hybrid connection' },
    { id: 'NC5MRX', type: 'direct', polesUsed: 5, warning: null, notes: 'Right-Angle variant' },
    { id: 'NC5FRX', type: 'direct', polesUsed: 5, warning: null, notes: 'Right-Angle variant' },
    { id: 'NC5FD-L-1', type: 'direct', polesUsed: 5, warning: null, notes: 'Panel-mount variant' },
    { id: 'NC5MD-L-1', type: 'direct', polesUsed: 5, warning: null, notes: 'Panel-mount variant' },
    { id: 'NC3FXX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'Maps Pins 1-3 for DMX/audio' },
    { id: 'NC3FRX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'Right-angle 3-pin' },
    { id: 'NC3MXX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'Maps Pins 1-3 for DMX/audio' },
    { id: 'NC3MRX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'Right-angle 3-pin' },
    { id: 'NC3FD-L-1', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'Panel-mount 3-pin' },
    { id: 'NC3MD-L-1', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'Panel-mount 3-pin' },
  ],
  notes: 'DMX/hybrid only. Pins 1-3 for DMX/audio, 4-5 for second channel or unused. Use 110-ohm cable for DMX.'
},
'NC5MD-L-1': { 
  id: 'NC5MD-L-1',
  type: 'XLR',
  family: 'XLR 5-pin',
  poles: 5,
  gender: 'male',
  mountType: 'panel',
  purpose: 'dmx',
  description: 'Neutrik XLR 5-Pin Male Panel Mount',
  image: '/images/coming_soon.png',
  wireCompatibility: ["PSDMX"], // Zip is not compatible
  compatibleWith: [
    { id: 'NC5FXX', type: 'direct', polesUsed: 5, warning: null, notes: 'Standard DMX/hybrid connection' },
    { id: 'NC5MXX', type: 'direct', polesUsed: 5, warning: null, notes: 'Standard DMX/hybrid connection' },
    { id: 'NC5MRX', type: 'direct', polesUsed: 5, warning: null, notes: 'Right-Angle variant' },
    { id: 'NC5FRX', type: 'direct', polesUsed: 5, warning: null, notes: 'Right-Angle variant' },
    { id: 'NC3FXX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'Maps Pins 1-3 for DMX/audio' },
    { id: 'NC3FRX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'Right-angle 3-pin' },
    { id: 'NC3MXX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'Maps Pins 1-3 for DMX/audio' },
    { id: 'NC3MRX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'Right-angle 3-pin' },
  ],
  notes: 'DMX/hybrid only. Pins 1-3 for DMX/audio, 4-5 for second channel or unused. Use 110-ohm cable for DMX.'
},
'NC5FD-L-1': { 
  id: 'NC5FD-L-1',
  type: 'XLR',
  family: 'XLR 5-pin',
  poles: 5,
  gender: 'female',
  mountType: 'panel',
  purpose: 'dmx',
  description: 'Neutrik XLR 5-Pin Female Panel Mount',
  image: '/images/coming_soon.png',
  wireCompatibility: ["PSDMX"], // Zip is not compatible
  compatibleWith: [
    { id: 'NC5MXX', type: 'direct', polesUsed: 5, warning: null, notes: 'Standard DMX/hybrid connection' },
    { id: 'NC5FXX', type: 'direct', polesUsed: 5, warning: null, notes: 'Standard DMX/hybrid connection' },
    { id: 'NC5FRX', type: 'direct', polesUsed: 5, warning: null, notes: 'Right-angle variant' },
    { id: 'NC5MRX', type: 'direct', polesUsed: 5, warning: null, notes: 'Right-angle variant' },
    { id: 'NC3MXX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'Maps Pins 1-3 for DMX/audio' },
    { id: 'NC3MRX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'Right-angle 3-pin' },
    { id: 'NC3FXX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'Maps Pins 1-3 for DMX/audio' },
    { id: 'NC3FRX', type: 'partial', polesUsed: 3, warning: 'Pins 4-5 unused; only 1 channel audio or DMX', notes: 'Right-angle 3-pin' },
  ],
  notes: 'DMX/hybrid only. Pins 1-3 for DMX/audio, 4-5 for second channel or unused. Use 110-ohm cable for DMX.'
}

  // 'NL8FP': {
  //   id: 'NL8FP',
  //   skuCode: 'NL8FPM',
  //   type: 'Speakon',
  //   family: 'Speakon',
  //   poles: 8,
  //   gender: 'female',
  //   mountType: 'panel',
  //   purpose: 'audio, wye',
  //   description: 'Neutrik Speakon 8-Pole Female Panel-Mount',
  //   image: '/images/coming_soon.png',
  //   wireCompatibility: ["8C"],
  //   compatibleWith: [
  //     { id: 'NL8MX', type: 'direct', polesUsed: 8, warning: null, notes: 'Standard balanced audio for four speaker circuits, panel to cable' },
  //     { id: 'NL8FP', type: 'direct', polesUsed: 8, warning: null, notes: 'Panel to panel connection for four speaker circuits or complex hybrid' },
  //     { id: 'NL4MX', type: 'partial', polesUsed: 4, warning: 'Only +1/-1, +2/-2 used; +3/-3, +4/-4 unused', notes: 'Two circuit audio, connects to 4-pole cable connector' },
  //     { id: 'NL4MX', type: 'partial', polesUsed: 4, warning: 'Only +1/-1, +2/-2 used; +3/-3, +4/-4 unused', notes: 'Simplified Speakon 4-Pole Male' },
  //     { id: 'NL2MX', type: 'partial', polesUsed: 2, warning: 'Only +1/-1 used; +2/-2, +3/-3, +4/-4 unused', notes: 'Single circuit audio, connects to 2-pole cable connector' },
  //     { id: 'NC3MXX', type: 'partial', polesUsed: 3, warning: 'Non-standard; non-standard audio, signal level mismatch', notes: 'Audio: +1 to Pin 2, -1 to Pin 1, Pin 3 unused. DMX: +2/-2/ground to Pins 1-3' },
  //     { id: 'NC3FXX', type: 'partial', polesUsed: 3, warning: 'Non-standard; non-standard audio, signal level mismatch', notes: 'Audio: +1 to Pin 2, -1 to Pin 1, Pin 3 unused. DMX: +2/-2/ground to Pins 1-3' },
  //     { id: 'NC5MXX', type: 'partial', polesUsed: 3, warning: 'Hybrid connection or single-channel audio; Pins 4-5 unused', notes: 'Audio: +1/-1 to Pins 2/1, Pins 4-5 unused. DMX: +2/-2/ground to Pins 1-3' },
  //     { id: 'NC5FXX', type: 'partial', polesUsed: 3, warning: 'Hybrid connection or single-channel audio; Pins 4-5 unused', notes: 'Audio: +1/-1 to Pins 2/1, Pins 4-5 unused. DMX: +2/-2/ground to Pins 1-3' },
  //     { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: +1 to positive, -1 to negative' },
  //     { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: +1 to positive, -1 to negative' }
  //   ],
  //   notes: 'Balanced audio for four speaker circuits or complex hybrid power/DMX. Use 12 AWG 8-conductor cable for audio, 2.5 mm² + 0.22 mm² for hybrid. Non-standard.'
  // },

  // 'NL8MX': {
  //   id: 'NL8MX',
  //   skuCode: 'NL8M',
  //   type: 'Speakon',
  //   family: 'Speakon',
  //   poles: 8,
  //   gender: 'male',
  //   mountType: 'cable',
  //   purpose: 'audio, wye',
  //   description: 'Neutrik Speakon 8-Pole Male',
  //   image: '/images/coming_soon.png',
  //   wireCompatibility: ["8C"],
  //   compatibleWith: [
  //     { id: 'NL8FC', type: 'direct', polesUsed: 8, warning: null, notes: 'Standard balanced audio for four speaker circuits, male to female cable' },
  //     { id: 'NL8MX', type: 'direct', polesUsed: 8, warning: null, notes: 'Cable to cable extension for four speaker circuits or complex hybrid' },
  //     { id: 'NL8FP', type: 'direct', polesUsed: 8, warning: null, notes: 'Standard balanced audio for four speaker circuits, cable to panel-mount' },
  //     { id: 'NL4FXX-W-S', type: 'partial', polesUsed: 4, warning: 'Only +1/-1, +2/-2 used; +3/-3, +4/-4 unused', notes: 'Two circuit audio, connects to 4-pole cable connector' },
  //     { id: 'NL2FXX-W-S', type: 'partial', polesUsed: 2, warning: 'Only +1/-1 used; +2/-2, +3/-3, +4/-4 unused', notes: 'Single circuit audio, connects to 2-pole cable connector' },
  //     { id: 'NC3MXX', type: 'partial', polesUsed: 3, warning: 'Non-standard; non-standard audio, signal level mismatch', notes: 'Audio: +1 to Pin 2, -1 to Pin 1, Pin 3 unused. DMX: +2/-2/ground to Pins 1-3' },
  //     { id: 'NC3FXX', type: 'partial', polesUsed: 3, warning: 'Non-standard; non-standard audio, signal level mismatch', notes: 'Audio: +1 to Pin 2, -1 to Pin 1, Pin 3 unused. DMX: +2/-2/ground to Pins 1-3' },
  //     { id: 'NC5MXX', type: 'partial', polesUsed: 3, warning: 'Hybrid connection or single-channel audio; Pins 4-5 unused', notes: 'Audio: +1/-1 to Pins 2/1, Pins 4-5 unused. DMX: +2/-2/ground to Pins 1-3' },
  //     { id: 'NC5FXX', type: 'partial', polesUsed: 3, warning: 'Hybrid connection or single-channel audio; Pins 4-5 unused', notes: 'Audio: +1/-1 to Pins 2/1, Pins 4-5 unused. DMX: +2/-2/ground to Pins 1-3' },
  //     { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: +1 to positive, -1 to negative' },
  //     { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: +1 to positive, -1 to negative' }
  //   ],
  //   notes: 'Balanced audio for four speaker circuits or complex hybrid power/DMX. Use 12 AWG 8-conductor cable for audio, 2.5 mm² + 0.22 mm² for hybrid. Non-standard, use +2/-2/ground or higher poles for multiple DMX signals.'
  // },

  // 'NL2MX': {
  //   id: 'NL2MX',
  //   skuCode: 'NL2M',
  //   type: 'Speakon',
  //   family: 'Speakon',
  //   poles: 2,
  //   gender: 'male',
  //   mountType: 'cable',
  //   purpose: 'audio, wye',
  //   description: 'Neutrik Speakon 2-Pole Male',
  //   image: '/images/Speakon_2pole_male.png',
  //   wireCompatibility: ["2C 12","2C 14","2C 16"],
  //   compatibleWith: [
  //     { id: 'NL2FXX-W-S', type: 'direct', polesUsed: 2, warning: null, notes: 'Standard balanced audio connection for single speaker circuit, male to female cable' },
  //     { id: 'NL2MX', type: 'direct', polesUsed: 2, warning: null, notes: 'Cable to cable extension for single speaker circuit' },
  //     { id: 'NL2FP', type: 'direct', polesUsed: 2, warning: null, notes: 'Standard balanced audio connection for single speaker circuit, cable to panel-mount' },
  //     { id: 'NL4FXX-W-S', type: 'partial', polesUsed: 2, warning: 'Only +1/-1 used; +2/-2 unused', notes: 'Connects to 4-pole cable connector, single circuit audio' },
  //     { id: 'NL4FXX-W-S', type: 'partial', polesUsed: 2, warning: 'Only +1/-1 used; +2/-2 unused', notes: 'Simplified Speakon 4-Pole Female' },
  //     { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (speaker vs. mic/line)', notes: 'Audio: +1 to Pin 2, -1 to Pin 1, Pin 3 unused' },
  //     { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (speaker vs. mic/line)', notes: 'Audio: +1 to Pin 2, -1 to Pin 1, Pin 3 unused' },
  //     { id: 'NC5MXX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; Pins 4-5 unused', notes: 'Audio: +1 to Pin 2, -1 to Pin 1, Pins 4-5 unused. Non-standard: +1/-1/ground to Pins 1-3' },
  //     { id: 'NC5FXX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; Pins 4-5 unused', notes: 'Audio: +1 to Pin 2, -1 to Pin 1, Pins 4-5 unused. Non-standard: +1/-1/ground to Pins 1-3' },
  //     { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: +1 to positive, -1 to negative' },
  //     { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: +1 to positive, -1 to negative' }
  //   ],
  //   notes: 'Primarily for single-channel speaker audio. Use 14-12 AWG cable for audio. Non-standard for hybrid; requires specific pin mapping and 110-ohm cable for DMX.'
  // },

  // 'NL2MP': {
  //   id: 'NL2MP',
  //   skuCode: 'NL2MPM',
  //   type: 'Speakon',
  //   family: 'Speakon',
  //   poles: 2,
  //   gender: 'male',
  //   mountType: 'panel',
  //   purpose: 'audio, wye',
  //   description: 'Neutrik Speakon 2-Pole Male Panel-Mount',
  //   image: '/images/coming_soon.png',
  //   wireCompatibility: ["2C 12","2C 14","2C 16"],
  //   compatibleWith: [
  //     { id: 'NL2FXX-W-S', type: 'direct', polesUsed: 2, warning: null, notes: 'Standard balanced audio connection for single speaker circuit, panel to cable' },
  //     { id: 'NL2MP', type: 'direct', polesUsed: 2, warning: null, notes: 'Panel to panel connection for single speaker circuit' },
  //     { id: 'SPK2_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Panel-mount variant' },
  //     { id: 'SPK2_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Panel-mount variant' },
  //     { id: 'NL4FXX-W-S', type: 'partial', polesUsed: 2, warning: 'Only +1/-1 used; +2/-2 unused', notes: 'Connects to 4-pole cable connector, single circuit audio' },
  //     { id: 'NL4FXX-W-S', type: 'partial', polesUsed: 2, warning: 'Only +1/-1 used; +2/-2 unused', notes: 'Simplified Speakon 4-Pole Female' },
  //     { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (speaker vs. mic/line)', notes: 'Audio: +1 to Pin 2, -1 to Pin 1, Pin 3 unused' },
  //     { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (speaker vs. mic/line)', notes: 'Audio: +1 to Pin 2, -1 to Pin 1, Pin 3 unused' },
  //     { id: 'NC5MXX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; Pins 4-5 unused', notes: 'Audio: +1 to Pin 2, -1 to Pin 1, Pins 4-5 unused. Non-standard: +1/-1/ground to Pins 1-3' },
  //     { id: 'NC5FXX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; Pins 4-5 unused', notes: 'Audio: +1 to Pin 2, -1 to Pin 1, Pins 4-5 unused. Non-standard: +1/-1/ground to Pins 1-3' },
  //     { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: +1 to positive, -1 to negative' },
  //     { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: +1 to positive, -1 to negative' }
  //   ],
  //   notes: 'Primarily for single-channel speaker audio, panel-mount. Use 14-12 AWG cable for audio. Non-standard for hybrid; requires specific pin mapping.'
  // },
  
  // 'NL2FP': {
  //   id: 'NL2FP',
  //   skuCode: 'NL2FPM',
  //   type: 'Speakon',
  //   family: 'Speakon',
  //   poles: 2,
  //   gender: 'female',
  //   mountType: 'panel',
  //   purpose: 'audio, wye',
  //   description: 'Neutrik Speakon 2-Pole Female Panel-Mount',
  //   image: '/images/Speakon_2pole_female_panel.png',
  //   wireCompatibility: ["2C 12","2C 14","2C 16"],
  //   compatibleWith: [
  //     { id: 'NL2MX', type: 'direct', polesUsed: 2, warning: null, notes: 'Standard balanced audio connection for single speaker circuit, panel to cable' },
  //     { id: 'NL2FP', type: 'direct', polesUsed: 2, warning: null, notes: 'Panel to panel connection for single speaker circuit' },
  //     { id: 'SPK2_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Panel-mount variant' },
  //     { id: 'SPK2_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: 'Panel-mount variant' },
  //     { id: 'NL4FXX-W-S', type: 'partial', polesUsed: 2, warning: 'Only +1/-1 used; +2/-2 unused', notes: 'Connects to 4-pole cable connector, single circuit audio' },
  //     { id: 'NL4FXX-W-S', type: 'partial', polesUsed: 2, warning: 'Only +1/-1 used; +2/-2 unused', notes: 'Simplified Speakon 4-Pole Female' },
  //     { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (speaker vs. mic/line)', notes: 'Audio: +1 to Pin 2, -1 to Pin 1, Pin 3 unused' },
  //     { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (speaker vs. mic/line)', notes: 'Audio: +1 to Pin 2, -1 to Pin 1, Pin 3 unused' },
  //     { id: 'NC5MXX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; Pins 4-5 unused', notes: 'Audio: +1 to Pin 2, -1 to Pin 1, Pins 4-5 unused. Non-standard: +1/-1/ground to Pins 1-3' },
  //     { id: 'NC5FXX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; Pins 4-5 unused', notes: 'Audio: +1 to Pin 2, -1 to Pin 1, Pins 4-5 unused. Non-standard: +1/-1/ground to Pins 1-3' },
  //     { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: +1 to positive, -1 to negative' },
  //     { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: +1 to positive, -1 to negative' }
  //   ],
  //   notes: 'Primarily for single-channel speaker audio, panel-mount. Use 14-12 AWG cable for audio. Non-standard for hybrid; requires specific pin mapping.'
  // },
  
  // Speakon 4-Pole Connectors (Comprehensive)
  
  // 'NL4MX': {
  //   id: 'NL4MX',
  //   skuCode: 'NL4M',
  //   type: 'Speakon',
  //   family: 'Speakon',
  //   poles: 4,
  //   gender: 'male',
  //   mountType: 'cable',
  //   purpose: 'audio, wye',
  //   description: 'Neutrik Speakon 4-Pole Male',
  //   image: '/images/Speakon_4pole_male.png',
  //   wireCompatibility: ["4C"],
  //   compatibleWith: [
  //     { id: 'NL4FXX-W-S', type: 'direct', polesUsed: 4, warning: null, notes: 'Standard balanced audio for two speaker circuits, male to female cable' },
  //     { id: 'NL4MX', type: 'direct', polesUsed: 4, warning: null, notes: 'Cable to cable extension for two speaker circuits or hybrid power/DMX' },
  //     { id: 'NL4MPXX', type: 'direct', polesUsed: 4, warning: null, notes: 'Standard balanced audio for two speaker circuits, cable to panel-mount' },
  //     { id: 'NL2FXX-W-S', type: 'partial', polesUsed: 2, warning: 'Only +1/-1 used; +2/-2 unused', notes: 'Single circuit audio, connects to 2-pole cable connector' },
  //     { id: 'NL2MX', type: 'partial', polesUsed: 2, warning: 'Only +1/-1 used; +2/-2 unused', notes: 'Simplified Speakon 2-Pole Female' },
  //     { id: 'NC3MXX', type: 'partial', polesUsed: 3, warning: 'Non-standard; non-standard audio, signal level mismatch', notes: 'Audio: +1 to Pin 2, -1 to Pin 1, Pin 3 unused. DMX: +2/-2/ground to Pins 1-3' },
  //     { id: 'NC3FXX', type: 'partial', polesUsed: 3, warning: 'Non-standard; non-standard audio, signal level mismatch', notes: 'Audio: +1 to Pin 2, -1 to Pin 1, Pin 3 unused. DMX: +2/-2/ground to Pins 1-3' },
  //     { id: 'NC5MXX', type: 'partial', polesUsed: 3, warning: 'Hybrid connection or single-channel audio; Pins 4-5 unused', notes: 'Audio: +1/-1 to Pins 2/1, Pins 4-5 unused. DMX: +2/-2/ground to Pins 1-3' },
  //     { id: 'NC5FXX', type: 'partial', polesUsed: 3, warning: 'Hybrid connection or single-channel audio; Pins 4-5 unused', notes: 'Audio: +1/-1 to Pins 2/1, Pins 4-5 unused. DMX: +2/-2/ground to Pins 1-3' },
  //     { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to tip, -1 to sleeve' },
  //     { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch', notes: 'Audio: +1 to center, -1 to shield' },
  //     { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: +1 to positive, -1 to negative' },
  //     { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection', notes: 'Audio: +1 to positive, -1 to negative' },
  //     { id: 'NL8MPRXX', type: 'partial', polesUsed: 4, warning: 'Only +1/-1, +2/-2 used; +3/-3, +4/-4 unused', notes: 'Connects to 8-pole panel-mount, two circuit audio' },
  //     { id: 'NL8FC', type: 'partial', polesUsed: 4, warning: 'Only +1/-1, +2/-2 used; +3/-3, +4/-4 unused', notes: 'Connects to 8-pole cable connector, two circuit audio' },
  //     { id: 'NL8MX', type: 'partial', polesUsed: 4, warning: 'Only +1/-1, +2/-2 used; +3/-3, +4/-4 unused', notes: 'Simplified Speakon 8-Pole Male' },
  //     { id: 'NL8FC', type: 'partial', polesUsed: 4, warning: 'Only +1/-1, +2/-2 used; +3/-3, +4/-4 unused', notes: 'Simplified Speakon 8-Pole Female' }
  //   ],
  //   notes: 'Balanced audio for two speaker circuits (bi-amping) or hybrid power/DMX. Use 12 AWG 4-conductor cable for audio, 2.5 mm² + 0.22 mm² for hybrid. Non-standard, use +2/-2/ground with 110-ohm cable.'
  // },

  // 3.5mm TS Male Panel-Mount // -- CORRECTED--
  // '3T_M_PM': {
  //   id: '3T_M_PM',
  //   skuCode: '3.5TSMPM',
  //   type: '3.5mm',
  //   family: '3.5mm TS',
  //   poles: 2,
  //   gender: 'male',
  //   mountType: 'panel',
  //   purpose: 'audio, wye',
  //   description: '3.5mm Tip/Sleeve (TS) Male Panel-Mount',
  //   image: '/images/coming_soon.png',
    // wireCompatibility: ["PSI","PSM","Zip"],
  //   compatibleWith: [
  //     // 3.5mm TS connections (unbalanced)
  //     { id: '3T_F', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_M', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     // 1/4" TS connections (unbalanced)
  //     { id: '2T_M', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS connection - Unbalanced audio' },
  //     { id: '2T_F', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS connection - Unbalanced audio' },
  //     { id: '2T_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS right-angle connection - Unbalanced audio' },
  //     { id: '2T_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS right-angle connection - Unbalanced audio' },
  //     { id: '2T_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS panel-mount connection - Unbalanced audio' },
  //     { id: '2T_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS panel-mount connection - Unbalanced audio' },
  //     // TRS connections (unbalanced with warning)
  //     { id: '3TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '2TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS connection' },
  //     { id: '2TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS connection' },
  //     { id: '2TR_FL', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS connection' },
  //     { id: '2TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS right-angle connection' },
  //     { id: '2TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS right-angle connection' },
  //     { id: '2TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS panel-mount connection' },
  //     { id: '2TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS panel-mount connection' },
  //     // RCA connections (unbalanced)
  //     { id: 'RCA_M', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA connection - Unbalanced audio' },
  //     { id: 'RCA_F', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA connection - Unbalanced audio' },
  //     { id: 'RCA_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA right-angle connection - Unbalanced audio' },
  //     { id: 'RCA_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA right-angle connection - Unbalanced audio' },
  //     { id: 'RCA_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA panel-mount connection - Unbalanced audio' },
  //     { id: 'RCA_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA panel-mount connection - Unbalanced audio' },
  //     // XLR connections (unbalanced with warning)
  //     { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR connection' },
  //     { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR connection' },
  //     { id: 'NC3FRX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR right-angle connection' },
  //     { id: 'NC3MRX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR right-angle connection' },
  //     { id: 'NC3FD-L-1', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR panel-mount connection' },
  //     { id: 'NC3MD-L-1', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR panel-mount connection' },
  //     // Speakon connections (partial - hybrid/DMX)
  //     { id: 'NL2MX', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' },
  //     { id: 'NL2MX', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' },
  //     { id: 'NL4FXX-W-S', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' },
  //     { id: 'NL4MX', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' }
  //   ],
  //   notes: '3.5mm TS for consumer audio devices. Unbalanced audio. Pin 2 to tip, Pin 1 to sleeve, Pin 3 unused or grounded. Noise-prone for long runs.'
  // },

  // // 3.5mm TS Female Panel-Mount // -- CORRECTED--
  // '3T_F_PM': {
  //   id: '3T_F_PM',
  //   skuCode: '3.5TSFPM',
  //   type: '3.5mm',
  //   family: '3.5mm TS',
  //   poles: 2,
  //   gender: 'female',
  //   mountType: 'panel',
  //   purpose: 'audio, wye',
  //   description: '3.5mm Tip/Sleeve (TS) Female Panel-Mount',
  //   image: '/images/coming_soon.png',
    // wireCompatibility: ["PSI","PSM","Zip"],
  //   compatibleWith: [
  //     // 3.5mm TS connections (unbalanced)
  //     { id: '3T_F', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_M', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     // 1/4" TS connections (unbalanced)
  //     { id: '2T_M', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS connection - Unbalanced audio' },
  //     { id: '2T_F', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS connection - Unbalanced audio' },
  //     { id: '2T_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS right-angle connection - Unbalanced audio' },
  //     { id: '2T_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS right-angle connection - Unbalanced audio' },
  //     { id: '2T_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS panel-mount connection - Unbalanced audio' },
  //     { id: '2T_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS panel-mount connection - Unbalanced audio' },
  //     // TRS connections (unbalanced with warning)
  //     { id: '3TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '2TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS connection' },
  //     { id: '2TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS connection' },
  //     { id: '2TR_FL', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS connection' },
  //     { id: '2TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS right-angle connection' },
  //     { id: '2TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS right-angle connection' },
  //     { id: '2TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS panel-mount connection' },
  //     { id: '2TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS panel-mount connection' },
  //     // RCA connections (unbalanced)
  //     { id: 'RCA_M', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA connection - Unbalanced audio' },
  //     { id: 'RCA_F', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA connection - Unbalanced audio' },
  //     { id: 'RCA_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA right-angle connection - Unbalanced audio' },
  //     { id: 'RCA_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA right-angle connection - Unbalanced audio' },
  //     { id: 'RCA_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA panel-mount connection - Unbalanced audio' },
  //     { id: 'RCA_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA panel-mount connection - Unbalanced audio' },
  //     // XLR connections (unbalanced with warning)
  //     { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR connection' },
  //     { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR connection' },
  //     { id: 'NC3FRX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR right-angle connection' },
  //     { id: 'NC3MRX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR right-angle connection' },
  //     { id: 'NC3FD-L-1', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR panel-mount connection' },
  //     { id: 'NC3MD-L-1', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR panel-mount connection' },
  //     // Speakon connections (partial - hybrid/DMX)
  //     { id: 'NL2MX', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' },
  //     { id: 'NL2MX', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' },
  //     { id: 'NL4FXX-W-S', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' },
  //     { id: 'NL4MX', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' }
  //   ],
  //   notes: '3.5mm TS for consumer audio devices. Unbalanced audio. Pin 2 to tip, Pin 1 to sleeve, Pin 3 unused or grounded. Noise-prone for long runs.'
  // },

  // 3.5mm TS Male Right-Angle // -- CORRECTED--
  // '3T_M_RA': {
  //   id: '3T_M_RA',
  //   skuCode: '3.5TSMRA',
  //   type: '3.5mm',
  //   family: '3.5mm TS',
  //   poles: 2,
  //   gender: 'male',
  //   mountType: 'rightangle',
  //   purpose: 'audio, wye',
  //   description: '3.5mm Tip/Sleeve (TS) Male Right Angle',
  //   image: '/images/coming_soon.png',
    // wireCompatibility: ["PSI","PSM","Zip"],
  //   compatibleWith: [
  //     // 3.5mm TS connections (unbalanced)
  //     { id: '3T_F', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_M', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     // 1/4" TS connections (unbalanced)
  //     { id: '2T_M', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS connection - Unbalanced audio' },
  //     { id: '2T_F', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS connection - Unbalanced audio' },
  //     { id: '2T_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS right-angle connection - Unbalanced audio' },
  //     { id: '2T_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS right-angle connection - Unbalanced audio' },
  //     { id: '2T_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS panel-mount connection - Unbalanced audio' },
  //     { id: '2T_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS panel-mount connection - Unbalanced audio' },
  //     // TRS connections (unbalanced with warning)
  //     { id: '3TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '2TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS connection' },
  //     { id: '2TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS connection' },
  //     { id: '2TR_FL', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS connection' },
  //     { id: '2TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS right-angle connection' },
  //     { id: '2TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS right-angle connection' },
  //     { id: '2TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS panel-mount connection' },
  //     { id: '2TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS panel-mount connection' },
  //     // RCA connections (unbalanced)
  //     { id: 'RCA_M', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA connection - Unbalanced audio' },
  //     { id: 'RCA_F', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA connection - Unbalanced audio' },
  //     { id: 'RCA_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA right-angle connection - Unbalanced audio' },
  //     { id: 'RCA_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA right-angle connection - Unbalanced audio' },
  //     { id: 'RCA_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA panel-mount connection - Unbalanced audio' },
  //     { id: 'RCA_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA panel-mount connection - Unbalanced audio' },
  //     // XLR connections (unbalanced with warning)
  //     { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR connection' },
  //     { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR connection' },
  //     { id: 'NC3FRX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR right-angle connection' },
  //     { id: 'NC3MRX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR right-angle connection' },
  //     { id: 'NC3FD-L-1', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR panel-mount connection' },
  //     { id: 'NC3MD-L-1', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR panel-mount connection' },
  //    // Speakon connections (partial - hybrid/DMX)
  //     { id: 'NL2MX', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' },
  //     { id: 'NL2MX', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' },
  //     { id: 'NL4FXX-W-S', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' },
  //     { id: 'NL4MX', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' }
  //   ],
  //   notes: '3.5mm TS for consumer audio devices. Unbalanced audio. Pin 2 to tip, Pin 1 to sleeve, Pin 3 unused or grounded. Noise-prone for long runs.'
  // },

  // // 3.5mm TS Female Right-Angle // -- CORRECTED--
  // '3T_F_RA': {
  //   id: '3T_F_RA',
  //   skuCode: '3.5TSFRA',
  //   type: '3.5mm',
  //   family: '3.5mm TS',
  //   poles: 2,
  //   gender: 'female',
  //   mountType: 'rightangle',
  //   purpose: 'audio, wye',
  //   description: '3.5mm Tip/Sleeve (TS) Female Right Angle',
  //   image: '/images/coming_soon.png',
    // wireCompatibility: ["PSI","PSM","Zip"],
  //   compatibleWith: [
  //     // 3.5mm TS connections (unbalanced)
  //     { id: '3T_F', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_M', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     { id: '3T_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 3.5mm TS connection - Unbalanced audio' },
  //     // 1/4" TS connections (unbalanced)
  //     { id: '2T_M', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS connection - Unbalanced audio' },
  //     { id: '2T_F', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS connection - Unbalanced audio' },
  //     { id: '2T_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS right-angle connection - Unbalanced audio' },
  //     { id: '2T_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS right-angle connection - Unbalanced audio' },
  //     { id: '2T_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS panel-mount connection - Unbalanced audio' },
  //     { id: '2T_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to 1/4" TS panel-mount connection - Unbalanced audio' },
  //     // TRS connections (unbalanced with warning)
  //     { id: '3TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '2TR_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS connection' },
  //     { id: '2TR_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS connection' },
  //     { id: '2TR_FL', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS connection' },
  //     { id: '2TR_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS right-angle connection' },
  //     { id: '2TR_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS right-angle connection' },
  //     { id: '2TR_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS panel-mount connection' },
  //     { id: '2TR_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 1/4" TRS panel-mount connection' },
  //     // RCA connections (unbalanced)
  //     { id: 'RCA_M', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA connection - Unbalanced audio' },
  //     { id: 'RCA_F', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA connection - Unbalanced audio' },
  //     { id: 'RCA_M_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA right-angle connection - Unbalanced audio' },
  //     { id: 'RCA_F_RA', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA right-angle connection - Unbalanced audio' },
  //     { id: 'RCA_M_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA panel-mount connection - Unbalanced audio' },
  //     { id: 'RCA_F_PM', type: 'direct', polesUsed: 2, warning: null, notes: '3.5mm TS to RCA panel-mount connection - Unbalanced audio' },
  //     // XLR connections (unbalanced with warning)
  //     { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR connection' },
  //     { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR connection' },
  //     { id: 'NC3FRX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR right-angle connection' },
  //     { id: 'NC3MRX', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR right-angle connection' },
  //     { id: 'NC3FD-L-1', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR panel-mount connection' },
  //     { id: 'NC3MD-L-1', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to XLR panel-mount connection' },
  //   // Speakon connections (partial - hybrid/DMX)
  //     { id: 'NL2MX', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' },
  //     { id: 'NL2MX', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' },
  //     { id: 'NL4FXX-W-S', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' },
  //     { id: 'NL4MX', type: 'partial', polesUsed: 2, warning: 'Non-standard; pin mapping required', notes: 'Hybrid power/DMX' }
  //   ],
  //   notes: '3.5mm TS for consumer audio devices. Unbalanced audio. Pin 2 to tip, Pin 1 to sleeve, Pin 3 unused or grounded. Noise-prone for long runs.'
  // },

  // 3.5mm TRS Male Panel-Mount
  // '3TR_M_PM': {
  //   id: '3TR_M_PM',
  //   skuCode: '3.5TRSMPM',
  //   type: '3.5mm',
  //   family: '3.5mm TRS',
  //   poles: 3,
  //   gender: 'male',
  //   mountType: 'panel',
  //   purpose: 'audio, dmx, wye',
  //   description: '3.5mm TRS Male Panel-Mount',
  //   image: '/images/coming_soon.png',
    // wireCompatibility: ["PSI","PSM","Zip"],
  //   compatibleWith: [
  //     { id: '3TR_M', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to cable' },
  //     { id: '3TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to panel-mount' },
  //     { id: '3TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to right-angle' },
  //     { id: '3TR_F', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to cable' },
  //     { id: '3TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to panel-mount' },
  //     { id: '3TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to right-angle' },
  //     { id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2TR_M', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to cable' },
  //     { id: '2TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to panel-mount' },
  //     { id: '2TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to right-angle' },
  //     { id: '2TR_F', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to cable' },
  //     { id: '2TR_FL', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to cable' },
  //     { id: '2TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to panel-mount' },
  //     { id: '2TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to right-angle' },
  //     { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, ring unused or Pin 3 grounded' },
  //     { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, ring unused or Pin 3 grounded' },
  //     { id: 'NC5MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
  //     { id: 'NC5FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
  //     { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker); ring unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker); ring unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'NL4MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; ring unused; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'NL4FXX-W-S', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; ring unused; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'NL8MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; ring unused; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'NL8FC', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; ring unused; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection; ring unused', notes: 'Audio: Tip to positive, sleeve to negative, ring unused' },
  //     { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection; ring unused', notes: 'Audio: Tip to positive, sleeve to negative, ring unused' },
  //     { id: 'NC3MXX', type: 'partial', polesUsed: 3, warning: 'Non-standard; requires 110-ohm cable', notes: 'DMX: Sleeve to Pin 1 (ground), ring to Pin 2 (Data-), tip to Pin 3 (Data+)' },
  //     { id: 'NC3FXX', type: 'partial', polesUsed: 3, warning: 'Non-standard; requires 110-ohm cable', notes: 'DMX: Sleeve to Pin 1 (ground), ring to Pin 2 (Data-), tip to Pin 3 (Data+)' },
  //     { id: 'NC5MXX', type: 'partial', polesUsed: 3, warning: 'Non-standard; Pins 4-5 unused', notes: 'DMX: Sleeve to Pin 1 (ground), ring to Pin 2 (Data-), tip to Pin 3 (Data+), Pins 4-5 unused' },
  //     { id: 'NC5FXX', type: 'partial', polesUsed: 3, warning: 'Non-standard; Pins 4-5 unused', notes: 'DMX: Sleeve to Pin 1 (ground), ring to Pin 2 (Data-), tip to Pin 3 (Data+), Pins 4-5 unused' },
  //     { id: 'NL4MX', type: 'partial', polesUsed: 3, warning: 'Non-standard; requires 110-ohm cable; +1/-1 unused', notes: 'DMX: Sleeve to ground, ring to -2, tip to +2' },
  //     { id: 'NL4FXX-W-S', type: 'partial', polesUsed: 3, warning: 'Non-standard; requires 110-ohm cable; +1/-1 unused', notes: 'DMX: Sleeve to ground, ring to -2, tip to +2' },
  //     { id: 'NL8MX', type: 'partial', polesUsed: 3, warning: 'Non-standard; requires 110-ohm cable; +1/-1, +3/-3, +4/-4 unused', notes: 'DMX: Sleeve to ground, ring to -2, tip to +2' },
  //     { id: 'NL8FC', type: 'partial', polesUsed: 3, warning: 'Non-standard; requires 110-ohm cable; +1/-1, +3/-3, +4/-4 unused', notes: 'DMX: Sleeve to ground, ring to -2, tip to +2' }
  //   ],
  //   notes: 'Balanced mono audio or stereo audio with ring (non-standard). Use 24 AWG shielded two-conductor cable for balanced audio, three-conductor for stereo. Use 110-ohm twisted pair (e.g., Belden 9841) for DMX.'
  // },

  // // 3.5mm TRS Male Right-Angle
  // '3TR_M_RA': {
  //   id: '3TR_M_RA',
  //   skuCode: '3.5TRSMRA',
  //   type: '3.5mm',
  //   family: '3.5mm TRS',
  //   poles: 3,
  //   gender: 'male',
  //   mountType: 'cable',
  //   purpose: 'audio, dmx, wye',
  //   description: '3.5mm TRS Male Right-Angle',
  //   image: '/images/coming_soon.png',
    // wireCompatibility: ["PSI","PSM","Zip"],
  //   compatibleWith: [
  //     { id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '3TR_M', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to cable' },
  //     { id: '3TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to panel-mount' },
  //     { id: '3TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to right-angle' },
  //     { id: '3TR_F', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to cable' },
  //     { id: '3TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to panel-mount' },
  //     { id: '3TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to right-angle' },
  //     { id: '2TR_M', type: 'unbalanced', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to cable' },
  //     { id: '2TR_F', type: 'unbalanced', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to cable' },
  //     { id: '2TR_FL', type: 'unbalanced', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to cable' },
  //     { id: '2TR_M_PM', type: 'unbalanced', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to panel-mount' },
  //     { id: '2TR_F_PM', type: 'unbalanced', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to panel-mount' },
  //     { id: '2TR_M_RA', type: 'unbalanced', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to right-angle' },
  //     { id: '2TR_F_RA', type: 'unbalanced', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to right-angle' },
  //     { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, ring unused or Pin 3 grounded' },
  //     { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, ring unused or Pin 3 grounded' },
  //     { id: 'NC5MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
  //     { id: 'NC5FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
  //     { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker); ring unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker); ring unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'NL4MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; ring unused; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'NL4FXX-W-S', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; ring unused; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'NL8MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; ring unused; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'NL8FC', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; ring unused; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection; ring unused', notes: 'Audio: Tip to positive, sleeve to negative, ring unused' },
  //     { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection; ring unused', notes: 'Audio: Tip to positive, sleeve to negative, ring unused' },
  //     { id: 'NC3MXX', type: 'partial', polesUsed: 3, warning: 'Non-standard; requires 110-ohm cable', notes: 'DMX: Sleeve to Pin 1 (ground), ring to Pin 2 (Data-), tip to Pin 3 (Data+)' },
  //     { id: 'NC3FXX', type: 'partial', polesUsed: 3, warning: 'Non-standard; requires 110-ohm cable', notes: 'DMX: Sleeve to Pin 1 (ground), ring to Pin 2 (Data-), tip to Pin 3 (Data+)' },
  //     { id: 'NC5MXX', type: 'partial', polesUsed: 3, warning: 'Non-standard; Pins 4-5 unused', notes: 'DMX: Sleeve to Pin 1 (ground), ring to Pin 2 (Data-), tip to Pin 3 (Data+), Pins 4-5 unused' },
  //     { id: 'NC5FXX', type: 'partial', polesUsed: 3, warning: 'Non-standard; Pins 4-5 unused', notes: 'DMX: Sleeve to Pin 1 (ground), ring to Pin 2 (Data-), tip to Pin 3 (Data+), Pins 4-5 unused' },
  //     { id: 'NL4MX', type: 'partial', polesUsed: 3, warning: 'Non-standard; requires 110-ohm cable; +1/-1 unused', notes: 'DMX: Sleeve to ground, ring to -2, tip to +2' },
  //     { id: 'NL4FXX-W-S', type: 'partial', polesUsed: 3, warning: 'Non-standard; requires 110-ohm cable; +1/-1 unused', notes: 'DMX: Sleeve to ground, ring to -2, tip to +2' },
  //     { id: 'NL8MX', type: 'partial', polesUsed: 3, warning: 'Non-standard; requires 110-ohm cable; +1/-1, +3/-3, +4/-4 unused', notes: 'DMX: Sleeve to ground, ring to -2, tip to +2' },
  //     { id: 'NL8FC', type: 'partial', polesUsed: 3, warning: 'Non-standard; requires 110-ohm cable; +1/-1, +3/-3, +4/-4 unused', notes: 'DMX: Sleeve to ground, ring to -2, tip to +2' }
  //   ],
  //   notes: 'Balanced mono audio or stereo audio with ring (non-standard). Use 24 AWG shielded two-conductor cable for balanced audio, three-conductor for stereo. Use 110-ohm twisted pair (e.g., Belden 9841) for DMX. Right-angle for tight spaces.'
  // },
  // // 3.5mm TRS Female Panel-Mount
  // '3TR_F_PM': {
  //   id: '3TR_F_PM',
  //   skuCode: '3.5TRSFPM',
  //   type: '3.5mm',
  //   family: '3.5mm TRS',
  //   poles: 3,
  //   gender: 'female',
  //   mountType: 'panel',
  //   purpose: 'audio, dmx, wye',
  //   description: '3.5mm TRS Female Panel-Mount',
  //   image: '/images/coming_soon.png',
    // wireCompatibility: ["PSI","PSM","Zip"],
  //   compatibleWith: [
  //     { id: '3TR_M', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to cable' },
  //     { id: '3TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to panel-mount' },
  //     { id: '3TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to right-angle' },
  //     { id: '3TR_F', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to cable' },
  //     { id: '3TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to panel-mount' },
  //     { id: '3TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to right-angle' },
  //     { id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Compatible but with Unbalanced Audio - Consider using TRS for balanced connection', notes: '3.5mm TS to 3.5mm TRS connection' },
  //     { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2TR_M', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to cable' },
  //     { id: '2TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to panel-mount' },
  //     { id: '2TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to right-angle' },
  //     { id: '2TR_F', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to cable' },
  //     { id: '2TR_FL', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to cable' },
  //     { id: '2TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to panel-mount' },
  //     { id: '2TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; panel-mount to right-angle' },
  //     { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, ring unused or Pin 3 grounded' },
  //     { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, ring unused or Pin 3 grounded' },
  //     { id: 'NC5MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
  //     { id: 'NC5FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused; Pins 4-5 unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, Pins 4-5 unused' },
  //     { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker); ring unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker); ring unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'NL4MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; ring unused; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'NL4FXX-W-S', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; ring unused; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'NL8MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; ring unused; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'NL8FC', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; ring unused; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection; ring unused', notes: 'Audio: Tip to positive, sleeve to negative, ring unused' },
  //     { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection; ring unused', notes: 'Audio: Tip to positive, sleeve to negative, ring unused' },
  //     { id: 'NC3MXX', type: 'partial', polesUsed: 3, warning: 'Non-standard; requires 110-ohm cable', notes: 'DMX: Sleeve to Pin 1 (ground), ring to Pin 2 (Data-), tip to Pin 3 (Data+)' },
  //     { id: 'NC3FXX', type: 'partial', polesUsed: 3, warning: 'Non-standard; requires 110-ohm cable', notes: 'DMX: Sleeve to Pin 1 (ground), ring to Pin 2 (Data-), tip to Pin 3 (Data+)' },
  //     { id: 'NC5MXX', type: 'partial', polesUsed: 3, warning: 'Non-standard; Pins 4-5 unused', notes: 'DMX: Sleeve to Pin 1 (ground), ring to Pin 2 (Data-), tip to Pin 3 (Data+), Pins 4-5 unused' },
  //     { id: 'NC5FXX', type: 'partial', polesUsed: 3, warning: 'Non-standard; Pins 4-5 unused', notes: 'DMX: Sleeve to Pin 1 (ground), ring to Pin 2 (Data-), tip to Pin 3 (Data+), Pins 4-5 unused' },
  //     { id: 'NL4MX', type: 'partial', polesUsed: 3, warning: 'Non-standard; requires 110-ohm cable; +1/-1 unused', notes: 'DMX: Sleeve to ground, ring to -2, tip to +2' },
  //     { id: 'NL4FXX-W-S', type: 'partial', polesUsed: 3, warning: 'Non-standard; requires 110-ohm cable; +1/-1 unused', notes: 'DMX: Sleeve to ground, ring to -2, tip to +2' },
  //     { id: 'NL8MX', type: 'partial', polesUsed: 3, warning: 'Non-standard; requires 110-ohm cable; +1/-1, +3/-3, +4/-4 unused', notes: 'DMX: Sleeve to ground, ring to -2, tip to +2' },
  //     { id: 'NL8FC', type: 'partial', polesUsed: 3, warning: 'Non-standard; requires 110-ohm cable; +1/-1, +3/-3, +4/-4 unused', notes: 'DMX: Sleeve to ground, ring to -2, tip to +2' }
  //   ],
  //   notes: 'Balanced mono audio or stereo audio with ring (non-standard). Use 24 AWG shielded two-conductor cable for balanced audio, three-conductor for stereo. Use 110-ohm twisted pair (e.g., Belden 9841) for DMX.'
  // },
  // // 3.5mm TRS Female Right-Angle // -- CORRECTED--
  // '3TR_F_RA': {
  //   id: '3TR_F_RA',
  //   skuCode: '3.5TRSRA',
  //   type: '3.5mm',
  //   family: '3.5mm TRS',
  //   poles: 3,
  //   gender: 'female',
  //   mountType: 'rightangle',
  //   purpose: 'audio, dmx, wye',
  //   description: '3.5mm TRS Female Right-Angle',
  //   image: '/images/coming_soon.png',
    // wireCompatibility: ["PSI","PSM","Zip"],
  //   compatibleWith: [
  //     { id: '3T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '3T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '3T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '3T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '3T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '3T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2T_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2T_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2T_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2T_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2T_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '2T_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to tip, sleeve to sleeve, ring unused' },
  //     { id: '3TR_M', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to cable' },
  //     { id: '3TR_M_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to panel-mount' },
  //     { id: '3TR_M_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to right-angle' },
  //     { id: '3TR_F', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to cable' },
  //     { id: '3TR_F_PM', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to panel-mount' },
  //     { id: '3TR_F_RA', type: 'direct', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to right-angle' },
  //     { id: '2TR_M', type: 'unbalanced', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to cable' },
  //     { id: '2TR_F', type: 'unbalanced', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to cable' },
  //     { id: '2TR_FL', type: 'unbalanced', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to cable' },
  //     { id: '2TR_M_PM', type: 'unbalanced', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to panel-mount' },
  //     { id: '2TR_F_PM', type: 'unbalanced', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to panel-mount' },
  //     { id: '2TR_M_RA', type: 'unbalanced', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to right-angle' },
  //     { id: '2TR_F_RA', type: 'unbalanced', polesUsed: 3, warning: null, notes: 'Balanced mono audio or stereo audio with ring; right-angle to right-angle' },
  //     { id: 'RCA_M', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'RCA_F', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'RCA_M_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'RCA_F_PM', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'RCA_M_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'RCA_F_RA', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to center, sleeve to shield, ring unused' },
  //     { id: 'NC3MXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, ring unused or Pin 3 grounded' },
  //     { id: 'NC3FXX', type: 'unbalanced', polesUsed: 2, warning: 'Unbalanced audio only; ring unused', notes: 'Audio: Tip to Pin 2, sleeve to Pin 1, ring unused or Pin 3 grounded' },
  //     { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker); ring unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'NL2MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch (line vs. speaker); ring unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'NL4MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; ring unused; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'NL4FXX-W-S', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; ring unused; +2/-2 unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'NL8MX', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; ring unused; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'NL8FC', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; signal level mismatch; ring unused; +2/-2, +3/-3, +4/-4 unused', notes: 'Audio: Tip to +1, sleeve to -1, ring unused' },
  //     { id: 'BANANA_M', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection; ring unused', notes: 'Audio: Tip to positive, sleeve to negative, ring unused' },
  //     { id: 'BARE_WIRE', type: 'unbalanced', polesUsed: 2, warning: 'Non-standard audio; less secure connection; ring unused', notes: 'Audio: Tip to positive, sleeve to negative, ring unused' },
  //     ],
  //   notes: 'Balanced mono audio or stereo audio with ring (non-standard). Use 24 AWG shielded two-conductor cable for balanced audio, three-conductor for stereo. Right-angle for tight spaces.'
  // },

};
// Helper function to get compatibility data for a connector
function getConnectorCompatibility(connectorId) {
  return compatibilityMatrix[connectorId] || null;
}

// Helper function to check if two connectors are compatible
function areConnectorsCompatible(connectorA, connectorB) {
  const aData = compatibilityMatrix[connectorA];
  const bData = compatibilityMatrix[connectorB];
  if (!aData && !bData) return null;

  // Prefer an explicit incompatibility in either direction.
  const aIncompat = aData?.notCompatibleWith?.find(inc => inc && inc.id === connectorB);
  if (aIncompat) {
    return { compatible: false, reason: aIncompat.reason, details: aIncompat.details };
  }
  const bIncompat = bData?.notCompatibleWith?.find(inc => inc && inc.id === connectorA);
  if (bIncompat) {
    return { compatible: false, reason: bIncompat.reason, details: bIncompat.details };
  }

  // Then allow explicit compatibility from either direction (the matrix isn't always authored bidirectionally).
  const aCompat = Array.isArray(aData?.compatibleWith)
    ? aData.compatibleWith.find(comp => comp && comp.id === connectorB)
    : null;
  const bCompat = Array.isArray(bData?.compatibleWith)
    ? bData.compatibleWith.find(comp => comp && comp.id === connectorA)
    : null;

  const compatibility = aCompat || bCompat;
  if (!compatibility) return null;

  return {
    compatible: true,
    type: compatibility.type,
    polesUsed: compatibility.polesUsed,
    warning: compatibility.warning,
    notes: compatibility.notes,
    unbalanced: compatibility.type === 'unbalanced'
  };
}

// Helper function to get all compatible connectors for a given connector
function getAllCompatibleConnectors(connectorId) {
  const connectorData = compatibilityMatrix[connectorId];
  if (!connectorData || !connectorData.compatibleWith || !Array.isArray(connectorData.compatibleWith)) {
    return [];
  }

  return connectorData.compatibleWith
    .filter(comp => comp && comp.id) // Filter out null/undefined entries
    .map(comp => ({
      id: comp.id,
      type: comp.type,
      polesUsed: comp.polesUsed,
      warning: comp.warning,
      notes: comp.notes,
      unbalanced: comp.type === 'unbalanced'
    }));
}

// Map power wire SKU codes to AWG labels when wireGaugeCompatibility is absent.
const POWER_WIRE_CODE_TO_GAUGE = {
  PSP12: '12AWG',
  PSP14: '14AWG',
  PSP16: '16AWG',
  PSS12: '12AWG',
  PSS14: '14AWG',
  PSS16: '16AWG'
};

function wireCodesToGauges(wireCodes) {
  if (!Array.isArray(wireCodes)) return [];
  return wireCodes
    .map((code) => POWER_WIRE_CODE_TO_GAUGE[code])
    .filter(Boolean);
}

// Helper function to get compatible wire gauges for a connector
function getConnectorWireGaugeCompatibility(connectorId) {
  const connectorData = compatibilityMatrix[connectorId];
  if (!connectorData) {
    return [];
  }
  if (connectorData.wireGaugeCompatibility?.length) {
    return connectorData.wireGaugeCompatibility;
  }
  return wireCodesToGauges(connectorData.wireCompatibility);
}

// Helper function to get compatible wire types for a connector
function getConnectorWireCompatibility(connectorId) {
  const connectorData = compatibilityMatrix[connectorId];
  if (!connectorData || !connectorData.wireCompatibility) {
    return [];
  }
  return connectorData.wireCompatibility;
}

// Smart PowerCon compatibility function
function getPowerConCompatibility(connectorA, connectorB, context = 'global') {
  // Get connector data from the matrix
  const connectorAData = compatibilityMatrix[connectorA];
  const connectorBData = compatibilityMatrix[connectorB];
  
  // Helper function to identify PowerCon types
  function getPowerConType(connectorId, connectorData) {
    if (!connectorId || !connectorData) return null;
    
    // Use family field if available, otherwise fall back to ID parsing
    if (connectorData.family) {
      if (connectorData.family.includes('Blue')) return 'blue';
      if (connectorData.family.includes('Grey')) return 'grey';
    }
    
    // Fallback to ID parsing
    const isBlue = connectorId.includes('Blue') || 
                   connectorId.includes('NAC3FXXA') || 
                   connectorId.includes('NAC3MPXXA');
    const isGrey = connectorId.includes('Grey') || 
                   connectorId.includes('NAC3FXXB') || 
                   connectorId.includes('NAC3MPXXB');
    
    if (isBlue) return 'blue';
    if (isGrey) return 'grey';
    return null;
  }
  
  const typeA = getPowerConType(connectorA, connectorAData);
  const typeB = getPowerConType(connectorB, connectorBData);
  const mountA = connectorAData?.mountType;
  const mountB = connectorBData?.mountType;
  
  // Only process if both are PowerCon connectors
  if (!typeA || !typeB) return null;
  
  // Hybrid context: Always cable-to-cable, Grey goes with Blue
  if (context === 'hybrid') {
    if (mountA === 'cable' && mountB === 'cable') {
      if ((typeA === 'grey' && typeB === 'blue') || (typeA === 'blue' && typeB === 'grey')) {
        return {
          compatible: true,
          type: 'hybrid',
          message: 'Standard hybrid cable connection: Grey to Blue',
          notes: 'For hybrid cables, Grey (power-out) connects to Blue (power-in)'
        };
      }
      return {
        compatible: false,
        reason: 'Hybrid cables must be Grey to Blue',
        details: 'In hybrid context, Grey cable (power-out) must connect to Blue cable (power-in)'
      };
    }
    return {
      compatible: false,
      reason: 'Hybrid context requires cable-to-cable connections',
      details: 'Hybrid cables must be cable-to-cable connections only'
    };
  }
  
  // Global context rules
  if (mountA === 'panel' && mountB === 'panel') {
    // Both panel-mount: Blue goes with Grey
    if ((typeA === 'blue' && typeB === 'grey') || (typeA === 'grey' && typeB === 'blue')) {
      return {
        compatible: true,
        type: 'global',
        message: 'Standard panel-to-panel connection: Blue to Grey',
        notes: 'For panel-to-panel connections, Blue (power-in) connects to Grey (power-out)'
      };
    }
    return {
      compatible: false,
      reason: 'Panel-to-panel: Blue must connect to Grey',
      details: 'Panel-to-panel connections require Blue (power-in) to connect to Grey (power-out)'
    };
  }
  
  if ((mountA === 'cable' && mountB === 'panel') || (mountA === 'panel' && mountB === 'cable')) {
    // Mixed cable/panel: Grey goes with Grey, Blue goes with Blue
    if (typeA === typeB) {
      return {
        compatible: true,
        type: 'mixed',
        message: `Mixed connection: ${typeA} to ${typeB}`,
        notes: `For mixed cable/panel connections, ${typeA} connects to ${typeB}`
      };
    }
    return {
      compatible: false,
      reason: 'Mixed connections: Grey goes with Grey, Blue goes with Blue',
      details: 'Mixed cable/panel connections require same color: Grey to Grey, Blue to Blue'
    };
  }
  
  return {
    compatible: false,
    reason: 'Invalid PowerCon connection',
    details: 'Unable to determine valid PowerCon connection pattern'
  };
}

// Enhanced compatibility checker that includes PowerCon smart rules
function areConnectorsCompatibleWithContext(connectorA, connectorB, context = 'global') {
  // First check PowerCon specific rules
  const powerConResult = getPowerConCompatibility(connectorA, connectorB, context);
  if (powerConResult) {
    return powerConResult;
  }
  
  // Fall back to standard compatibility check
  return areConnectorsCompatible(connectorA, connectorB);
}

module.exports = { 
  compatibilityMatrix,
  getConnectorCompatibility,
  areConnectorsCompatible,
  areConnectorsCompatibleWithContext,
  getPowerConCompatibility,
  getAllCompatibleConnectors,
  getConnectorWireGaugeCompatibility,
  getConnectorWireCompatibility
}; 
